<template>
  <div class="cutting-params h100">
    <div class="w100 h100 flex">
      <AnchorNav
        :getContainer="() => container"
        :navs="navs"
        prefix="cuttingParams"
      />
      <div class="wrap h100 y-auto" ref="wrap">
        <div class="hole-slot-focus" id="hole-slot-focus">
          <span id="span_itxpe0v9xn" class="head-title">
            {{ $t('cuttingDock.cuttingParams.holeSlotMainSide') }}
            <span
              id="span_574oc1yxyu"
              class="ml10 fs14 color-o-4"
              style="font-weight: 400"
            >
              {{ $t('cuttingDock.cuttingParams.workPriority') }}
            </span>
          </span>
          <div class="content ml8">
            <div class="flex flex-cross--center">
              <span id="span_up7ecw79bv" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.holeMainSide') }}：</span
              >
              <a-radio-group
                v-model="formData.holeFaceSetting.holeConcentrated"
                :disabled="
                  formData.holeFaceSetting.prorate_holes_slots_of_both_side
                "
              >
                <a-radio
                  value="front"
                  id="engraving_setting_holeConcentrated_front_radio"
                  >{{ $t('common.front') }}</a-radio
                >
                <a-radio
                  value="back"
                  id="engraving_setting_holeConcentrated_back_radio"
                  >{{ $t('common.back') }}</a-radio
                >
              </a-radio-group>
            </div>
            <div class="flex flex-cross--center">
              <span id="span_5xw1sq7ddo" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.slotMainSide') }}：</span
              >
              <a-radio-group
                v-model="formData.holeFaceSetting.apertureSlotConcentrated"
                :disabled="
                  formData.holeFaceSetting.prorate_holes_slots_of_both_side
                "
              >
                <a-radio
                  value="front"
                  id="engraving_setting_apertureSlotConcentrated_front_radio"
                  >{{ $t('common.front') }}</a-radio
                >
                <a-radio
                  value="back"
                  id="engraving_setting_apertureSlotConcentrated_back_radio"
                  >{{ $t('common.back') }}</a-radio
                >
              </a-radio-group>
            </div>
            <div>
              <span id="span_f5e8k5mxqz" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.specialFrontSide') }}：</span
              >
              <!-- 孔槽分流中设置的特殊孔槽优先排在大板正面功能 -->
              <a-checkbox
                v-model="formData.holeFaceSetting.hs_on_front_aft_shunt"
                id="engraving_setting_hs_on_front_aft_shunt_checkbox"
                :disabled="
                  formData.holeFaceSetting.prorate_holes_slots_of_both_side
                "
              ></a-checkbox>
            </div>
            <div class="flex">
              <span id="span_73j9qgqxl5" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.followWork') }}：</span
              >
              <a-checkbox
                v-model="formData.holeFaceSetting.throughHoleSlotSameSide"
                id="engraving_setting_throughHoleSlotSameSide_checkbox"
              ></a-checkbox>
            </div>
            <!--            &lt;!&ndash; 当选择此选项，当前选项隐藏并自动添加到到特殊孔槽规则中 &ndash;&gt;-->
            <!--            <div-->
            <!--              v-if="!formData.holeFaceSetting.processChainAndHoleOnBigPlaneBack"-->
            <!--            >-->
            <!--              <span class="base_title mr14">{{-->
            <!--                $t('cuttingDock.cuttingParams.hingeRollWork')-->
            <!--              }}</span>-->
            <!--              <a-checkbox-->
            <!--                v-model="-->
            <!--                  formData.holeFaceSetting.processChainAndHoleOnBigPlaneBack-->
            <!--                "-->
            <!--                @change="changeCheck"-->
            <!--                id="engraving_setting_processChainAndHoleOnBigPlaneBack_checkbox"-->
            <!--              ></a-checkbox>-->
            <!--            </div>-->

            <div class="allocation color-o-9 flex">
              <span id="span_0luldhnfe4" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.autoMatchSide') }}：</span
              >
              <div>
                <a-switch
                  v-model="
                    formData.holeFaceSetting.prorate_holes_slots_of_both_side
                  "
                  id="engraving_setting_prorate_holes_slots_of_both_side_switch"
                ></a-switch>
                <div
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.holeFaceSetting.prorate_holes_slots_of_both_side
                  "
                  style="margin-top: 24px"
                >
                  <span id="span_dtljgvyg89" class="mr8">{{
                    $t('cuttingDock.cuttingParams.backHSRate')
                  }}</span>
                  <input-number-suffix
                    min="0"
                    max="100"
                    suffix="%"
                    v-model="
                      formData.holeFaceSetting.percentage_of_back_hole_slot
                    "
                    id="engraving_setting_percentage_of_back_hole_slot_input"
                    :disabled="
                      !formData.holeFaceSetting.prorate_holes_slots_of_both_side
                    "
                  ></input-number-suffix>
                  <div id="div_ncnub7czee" class="edge-again-info mt5">
                    {{ $t('cuttingDock.cuttingParams.matchTip') }}
                  </div>
                </div>
              </div>
            </div>

            <div class="machine-board">
              <div class="flex">
                <span id="span_qm3iobdpmi" class="base-title-label"
                  >{{
                    $t('cuttingDock.cuttingParams.specIalHoleAndSlotSurface')
                  }}：</span
                >
                <div>
                  <a-switch
                    id="spRuleSwitch"
                    v-bp="'engraving:specialHoleSlotCustom'"
                    v-model="
                      formData.holeFaceSetting.custom_special_hole_slot_side
                        .is_open
                    "
                    @change="handlerSpecialSwitch"
                  ></a-switch>
                  <div
                    id="div_eozletxkyw"
                    class="edge-again-info color-o-4 mt4"
                    v-if="
                      formData.holeFaceSetting.custom_special_hole_slot_side
                        .is_open
                    "
                  >
                    {{ translateLang('cuttingDock.cuttingParams.addRulesTip') }}
                  </div>
                  <div
                    v-if="
                      formData.holeFaceSetting.custom_special_hole_slot_side
                        .is_open
                    "
                    class="mt20"
                  >
                    <span
                      id="addSpecialRule"
                      class="addRules"
                      v-bp="'engraving:specialHoleSlotCustomAddRule'"
                      style="
                        cursor: pointer;
                        color: #18a8c7;
                        font-size: 16px;
                        margin-right: 5px;
                      "
                      @click="addSpecialRule"
                      >{{ $t('cuttingDock.cuttingParams.addRules') }}</span
                    >
                  </div>
                  <SpecialHoleAndSlotTable
                    ref="SpecialHoleAndSlotTable"
                    v-if="
                      formData.holeFaceSetting.custom_special_hole_slot_side
                        .is_open
                    "
                    :special_hole_slot_side_rules="
                      formData.holeFaceSetting.custom_special_hole_slot_side
                        .special_hole_slot_side || []
                    "
                    :is_open="
                      formData.holeFaceSetting.custom_special_hole_slot_side
                        .is_open
                    "
                    @deleteStrHine="deleteStrHine"
                  />
                </div>
              </div>
            </div>
            <!-- 孔槽分流后计算翻版次数 -->
            <div>
              <span id="span_yluc5mbxd4" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.rollCountTip') }}：</span
              >
              <a-switch
                v-model="formData.holeFaceSetting.cal_turn_num_aft_shunt"
                id="engraving_setting_cal_turn_num_aft_shunt_switch"
              ></a-switch>
            </div>
          </div>
        </div>
        <div class="board-slot-place" id="board-slot-place">
          <span id="span_0wtvly4y2a" class="head-title">{{
            $t('cuttingDock.cuttingParams.highGlossSetting')
          }}</span>
          <div class="content ml8">
            <div class="flex">
              <div id="div_l5ddtovf42" class="base-title-label">
                {{ $t('cuttingDock.cuttingParams.heighGlossFront') }}：
              </div>
              <a-radio-group
                name="radioGroup"
                v-model="formData.highgloss_setting.highgloss_direction"
              >
                <a-radio
                  v-for="option in plateGighGlossOptions"
                  :id="`newPaiban_select_highlight_surface_radio${option.label}`"
                  :value="option.value"
                  :key="option.value"
                  >{{ $t(option.label) }}</a-radio
                >
              </a-radio-group>
            </div>
          </div>
          <div class="content ml8">
            <div class="flex">
              <span id="span_0luldhnfe4" class="base-title-label"
                >{{ $translateLang('高光板不转板') }}：</span
              >
              <div>
                <a-switch
                  v-model="
                    formData.highgloss_setting.high_gloss_plank_no_rotate
                  "
                ></a-switch>
              </div>
            </div>
          </div>
          <!-- 高光板翻版设置 -->
          <div class="content ml8">
            <div class="flex" style="margin-bottom: 10px !important">
              <div id="div_l5ddtovf42" class="base-title-label">
                {{ $translateLang('仅带有反面孔槽的大板自动翻面') }}：
              </div>
              <a-switch
                id="engraving_setting_auto_high_gloss_reverse_switch"
                v-model="formData.highgloss_setting.auto_high_gloss_reverse"
                @change="handleChangeHighGlossReverse"
              ></a-switch>

              <span
                v-html="
                  `${$translateLang(
                    `<span class='color-o-4'>（启用后仅反面孔槽的大板排版时将会自动翻面，变为单面板。配合自定义文件名“高光面翻面放板“数据使用）</span>`
                  )}`
                "
              ></span>
            </div>
          </div>
          <div class="content ml8">
            <div
              class="pr14"
              style="width: 240px; text-align: right; color: red"
            >
              暂不支持xy轴互换
            </div>
          </div>
        </div>
        <div class="board-slot-place" id="board-slot-place">
          <span id="span_to6zjyfetd" class="head-title">{{
            $t('cuttingDock.cuttingParams.sideSlotPut')
          }}</span>
          <div class="content ml8 flex">
            <span id="span_v8hlfusy22" class="base-title-label"
              >{{ $t('cuttingDock.cuttingParams.sideSlotPut') }}：</span
            >
            <!-- <template slot="title">{{
              $t('cuttingDock.cuttingParams.optimize')
            }}</template> -->
            <div>
              <a-radio-group
                v-model="formData.edgePlankSlotDirection.sideBoardPlacing"
                class="radioBox flex"
              >
                <a-radio
                  value="default"
                  id="engraving_setting_sideBoardPlacing_default_radio"
                  >{{ $t('cuttingDock.cuttingParams.sysDefault') }}</a-radio
                >
                <a-radio
                  value="inside"
                  id="engraving_setting_sideBoardPlacing_inside_radio"
                  >{{ $t('cuttingDock.cuttingParams.plankInSide') }}</a-radio
                >
                <a-radio
                  value="outside"
                  id="engraving_setting_sideBoardPlacing_outside_radio"
                  >{{ $t('cuttingDock.cuttingParams.plankOutSide') }}</a-radio
                >
              </a-radio-group>

              <span id="span_57d9h8haa9" class="color-o-4 mt6">{{
                $t('cuttingDock.cuttingParams.specialNotWork')
              }}</span>
              <div class="flex mt12">
                <img
                  src="../../assets/image/insideSlot.png"
                  class="imgWrap mr20"
                  style="display: none"
                />
                <div class="flex flex-dir--top img-box p13 mr20">
                  <img src="../../assets/image/inside.png" class="imgWrap" />
                  <span
                    id="span_qpxj5fj1co"
                    class="align-center mt11 color-o-6"
                    >{{ $t('cuttingDock.cuttingParams.plankInSide') }}</span
                  >
                </div>
                <div class="flex flex-dir--top img-box p13">
                  <img src="../../assets/image/outside.png" class="imgWrap" />
                  <span
                    id="span_talgfvg2ce"
                    class="align-center mt11 color-o-6"
                    >{{ $t('cuttingDock.cuttingParams.plankOutSide') }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="common-side-cut" id="common-side-cut">
          <!-- 共边设置 -->
          <div id="div_074571hfei" class="head-title flex flex-cross--center">
            {{ $t('cuttingDock.cuttingParams.commonSetting') }}
          </div>

          <div class="base_title flex">
            <span id="span_aaj9ev1k4z" class="base-title-label"
              >{{ $t('cuttingDock.cuttingParams.commonSide') }}：</span
            >
            <div>
              <a-switch
                v-model="formData.coedgeCuttingSetting.coedgeCutting"
                id="engraving_setting_coedgeCutting_switch"
              />
              <div
                style="margin-top: 29px"
                v-show="
                  isShowSecondaryCatalog ||
                  formData.coedgeCuttingSetting.coedgeCutting
                "
              >
                <span id="span_6v5dw7alfi" class="mr8">{{
                  $t('cuttingDock.cuttingParams.plankThickRange')
                }}</span>
                <input-number-suffix
                  v-model="formData.coedgeCuttingSetting.coedgeThick"
                  :disabled="!formData.coedgeCuttingSetting.coedgeCutting"
                  id="engraving_setting_coedgeThick_input"
                ></input-number-suffix>
                <span id="span_3bdy2tzguk" class="ml8 color-o-9">{{
                  $t('cuttingDock.cuttingParams.useCommonSide')
                }}</span>
                <div id="div_jhihh4ur7h" class="color-o-4 mt4">
                  <!-- 排版间隙需手动改为0，加工至已切割边时抬刀跳过该边，此功能开启后，将不支持斜下刀加工。 -->
                  {{ $t('cuttingDock.cuttingParams.zeroTip') }}
                </div>
              </div>
            </div>
          </div>
          <div class="base_title flex">
            <span id="span_6q5h0mkg7c" class="base-title-label"
              >{{ $t('cuttingDock.cuttingParams.commonSpeed') }}：</span
            >
            <div>
              <a-switch
                id="engraving_setting_coedgeAccelerate_switch"
                v-model="formData.coedgeCuttingSetting.coedgeAccelerate"
              />
              <div
                v-show="
                  isShowSecondaryCatalog ||
                  formData.coedgeCuttingSetting.coedgeAccelerate
                "
                style="margin-top: 24px"
              >
                <span id="span_2bxhs5m1dm" class="mr8">{{
                  $t('cuttingDock.cuttingParams.highSpeed')
                }}</span>
                <input-number-suffix
                  width="140px"
                  id="engraving_setting_coedgeSpeed_input"
                  v-model="formData.coedgeCuttingSetting.coedgeSpeed"
                  :disabled="!formData.coedgeCuttingSetting.coedgeAccelerate"
                  :suffix="`mm/${$t('cuttingDock.cuttingParams.min')}`"
                >
                </input-number-suffix>
                <div id="div_ooxcv5c1rm" class="mt4 color-o-4">
                  {{ $t('cuttingDock.cuttingParams.notWorkTip') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-board" id="table-board">
          <span id="span_60o45r6uop" class="head-title">{{
            $t('cuttingDock.labelingSettings.countertopSetting.title')
          }}</span>
          <div class="base_title ml8">
            <div class="toggle-XY">
              <span id="span_qr6xszlv93" class="base-title-label"
                >{{ $t('common.xyReverse') }}：</span
              >
              <a-switch
                id="engraving_setting_xyReverse_checkbox"
                v-model="formData.countertopSetting.xyReverse"
              ></a-switch>
            </div>
            <div
              v-if="formData.countertopSetting.xyReverse"
              class="toggle-XYAuto"
            >
              <span id="span_qr6xszlv93" class="base-title-label pt2"
                >{{ $translateLang('孔槽加工设备自动适配互换') }}：</span
              >
              <div>
                <div class="flex flex-cross--center">
                  <a-switch
                    id="engraving_setting_autoXYReverse_checkbox"
                    v-model="
                      formData.countertopSetting.auto_adaptation_xy_reverse
                    "
                  ></a-switch>
                  <i
                    class="iconfont icon-wenhao"
                    :title="
                      $translateLang(
                        '启用后侧孔机和五六面钻的加工数据将自动适配雕刻机的XY轴互换'
                      )
                    "
                  ></i>
                </div>

                <div style="color: red">
                  （{{ $translateLang('注：PTP暂不支持') }}）
                </div>
              </div>
            </div>
            <div class="start-point flex">
              <span id="span_r2ufj0qac7" class="base-title-label"
                >{{
                  $t(
                    'cuttingDock.labelingSettings.countertopSetting.startPoint'
                  )
                }}：
              </span>
              <div>
                <div class="flex flex-cross--center">
                  <m-machine-pos
                    :position="formData.countertopSetting.startPosition"
                    @onPositionChange="chosePoint"
                  >
                  </m-machine-pos>
                  <span class="ml10 mr10 color-o-4">{{
                    positionDisValue
                  }}</span>
                </div>
                <div
                  id="div_scetm530zb"
                  class="mt5 mb5"
                  style="color: rgba(0, 0, 0, 0.4)"
                >
                  {{ $t('preLayoutSetting.click')
                  }}<span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      flex-shrink: 0;
                      background: #d9d9d9;
                    "
                  ></span
                  >{{ $t('preLayoutSetting.grayStart') }}，<span
                    style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      flex-shrink: 0;
                      background: #18a8c7;
                    "
                  ></span
                  >{{ $t('preLayoutSetting.currentStart') }}
                </div>
              </div>
            </div>
            <div class="flex" v-if="showConfig">
              <span id="span_wdkd5d9b1b" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.changeStartPoint') }}：</span
              >
              <div>
                <a-switch
                  id="engraving_setting_doubleStationReverse_checkbox"
                  v-model="formData.countertopSetting.doubleStationReverse"
                ></a-switch>
                <div id="div_9k2n39gth5" class="mt4 color-o-4">
                  {{ $t('cuttingDock.cuttingParams.changeStartPointTip') }}
                </div>
              </div>
            </div>
            <div class="machine-board">
              <div class="flex">
                <span id="span_qhwvur3tu5" class="base-title-label"
                  >{{ $t('cuttingDock.cuttingParams.flatOffset') }}：</span
                >
                <div>
                  <a-switch
                    id="engraving_setting_planeOffset_switch"
                    v-model="formData.countertopSetting.planeOffset"
                  ></a-switch>
                </div>
              </div>
            </div>
            <div style="margin-left: 143px">
              <div class="flex">
                <div
                  v-for="(item, index) in planeOffsetOptions"
                  class="board-offset flex flex-cross--center"
                  :key="index"
                  style="width: 130px"
                  :style="{ margin: index === 1 ? '0 24px' : '' }"
                >
                  <span class="fs14 mr12">{{ item.label }}: </span>
                  <a-input
                    :placeholder="$t('common.inputPlaceholder')"
                    v-model="formData.countertopSetting[item.key]"
                    :disabled="!formData.countertopSetting.planeOffset"
                    :id="`engraving_setting_${item.key}_input`"
                    @input="inputCheck('countertopSetting', item.key, false, 1)"
                  ></a-input>
                </div>
              </div>
            </div>
            <div class="machine-board">
              <span id="span_kaboj4nryy" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.xRowChange') }}：</span
              >
              <div class="flex flex-dir--top">
                <a-switch
                  id="engraving_setting_X_reference_swap_switch"
                  v-model="formData.countertopSetting.X_reference_swap"
                  style="width: 44px"
                ></a-switch>
                <span id="span_fih7gr3kak" class="mt4 color-o-4">{{
                  $t('cuttingDock.cuttingParams.plankMirrorTip')
                }}</span>
              </div>
            </div>
            <div class="flex">
              <span
                id="span_a70a495pm9"
                class="base-title-label"
                style="white-space: nowrap"
                >{{
                  $t('cuttingDock.cuttingParams.bigplankPointChange')
                }}：</span
              >
              <div>
                <div class="mb4">
                  <a-checkbox
                    style="white-space: nowrap"
                    id="engraving_setting_X_reference_swap_switch"
                    v-model="
                      formData.countertopSetting.x_reverse_reference_swap
                    "
                  >
                    {{ $t('cuttingDock.cuttingParams.reverseXRowChange') }}
                  </a-checkbox>
                  <a-checkbox
                    style="white-space: nowrap"
                    id="engraving_setting_Y_reference_swap_switch"
                    v-model="
                      formData.countertopSetting.y_reverse_reference_swap
                    "
                  >
                    {{ $t('cuttingDock.cuttingParams.reverseYRowChange') }}
                  </a-checkbox>
                </div>
                <span id="span_fzed6qg9qs" class="color-o-4">
                  {{ $t('cuttingDock.cuttingParams.changebigplankPointTips') }}
                </span>
              </div>
            </div>
            <div class="mr15 flex" v-if="showConfig">
              <span id="span_0wxzhkxd6q" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.notSameSize') }}：</span
              >
              <div>
                <a-switch
                  id="engraving_setting_doubleDifferentSize_switch"
                  v-model="formData.countertopSetting.doubleDifferentSize"
                ></a-switch>
                <div
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.countertopSetting.doubleDifferentSize
                  "
                  style="margin-top: 24px"
                >
                  <div class="flex dual-input flex-cross--center">
                    <span id="span_9l8z3k2i7l" class="mr10"
                      >{{ $t('cuttingDock.cuttingParams.maxSize1') }}
                    </span>
                    <a-input
                      suffix="mm"
                      placeholder="请输入"
                      id="engraving_setting_stationOneMax_input"
                      @input="
                        handleDualInputValue(
                          formData.countertopSetting,
                          'stationOneMax'
                        )
                      "
                      :disabled="
                        !formData.countertopSetting.doubleDifferentSize
                      "
                      v-model="formData.countertopSetting.stationOneMax"
                    ></a-input>
                  </div>
                  <div id="div_6rxds6qx2a" class="mt4 color-o-4">
                    {{ $t('cuttingDock.cuttingParams.notSameSizeTip') }}
                  </div>
                  <div
                    class="flex dual-input flex-cross--center"
                    style="margin-top: 24px"
                  >
                    <span id="span_ycm9eip9fi" class="mr10"
                      >{{ $t('cuttingDock.cuttingParams.maxSize2') }}
                    </span>
                    <a-input
                      suffix="mm"
                      :placeholder="$t('common.inputPlaceholder')"
                      id="engraving_setting_stationTwoMax_input"
                      :disabled="
                        !formData.countertopSetting.doubleDifferentSize
                      "
                      v-model="formData.countertopSetting.stationTwoMax"
                      @input="
                        handleDualInputValue(
                          formData.countertopSetting,
                          'stationTwoMax'
                        )
                      "
                    ></a-input>
                  </div>
                  <div id="div_0p6mktfqef" class="color-o-4 mt4">
                    {{ $t('cuttingDock.cuttingParams.autoSelectTip') }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="small-title"
              style="font-size: 14px"
              v-show="
                (formData.countertopSetting.doubleDifferentSize ||
                  isShowSecondaryCatalog) &&
                showConfig
              "
            >
              <span id="span_mdowijoa9y" class="base-title-label">
                {{ $t('cuttingDock.cuttingParams.bigFlatLimit') }}
              </span>
              <a-switch
                id="cuttingParams_doubleDifferentSize_checkbox"
                v-model="formData.countertopSetting.smallStationFirst"
                :disabled="!formData.countertopSetting.doubleDifferentSize"
              >
              </a-switch>
            </div>
            <div class="mr15 flex">
              <span class="base-title-label"
                >{{ $translateLang('台面宽度') }}：</span
              >
              <div>
                <div class="mb10">
                  <a-switch
                    v-model="formData.countertopSetting.counter_limit_able"
                  ></a-switch>
                </div>
                <a-input
                  suffix="mm"
                  placeholder="请输入"
                  style="width: 138px"
                  id="engraving_setting_counter_width_input"
                  :disabled="!formData.countertopSetting.counter_limit_able"
                  @input="
                    handleDualInputValue(
                      formData.countertopSetting,
                      'counter_width'
                    )
                  "
                  v-model="formData.countertopSetting.counter_width"
                ></a-input>

                <p class="color-o-4 mt4">
                  ({{
                    $translateLang(
                      '使用余料大板时，宽度方向只能在设置的尺寸范围内排小板'
                    )
                  }})
                </p>
              </div>
            </div>
          </div>
        </div>

        <MTrimSetting
          style="padding-left: 24px"
          :trimming-setting="formData.trimmingSetting"
          :propertyName="propertyName"
          source="cuttingParams"
          @onUpdateTrimSetting1="onUpdateTrimSetting"
          :is-show-secondary-catalog="isShowSecondaryCatalog"
        ></MTrimSetting>

        <!-- 余料设置 -->
        <div id="surplus-setting">
          <span id="span_fpyhq37huk" class="head-title">{{
            $t('cuttingDock.cuttingParams.surplusSetting')
          }}</span>
          <m-setting-content
            :label="translateLang('cuttingDock.cuttingParams.surplusPosition')"
            class="color-o-9"
            style="padding-left: 25px"
          >
            <div class="flex flex-cross--center">
              <m-machine-pos
                :position="lavePoint"
                @onPositionChange="choselavePoint"
              ></m-machine-pos>
            </div>
            <div
              id="div_tiwiiqdow8"
              class="mt5 mb5"
              style="color: rgba(0, 0, 0, 0.4)"
            >
              {{ $t('preLayoutSetting.click')
              }}<span
                style="
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  flex-shrink: 0;
                  background: #d9d9d9;
                "
              ></span
              >{{ $t('preLayoutSetting.gayPosition') }}，<span
                style="
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  flex-shrink: 0;
                  background: #18a8c7;
                "
              ></span
              >{{ $t('preLayoutSetting.surplusPosition') }}
            </div>
            <div class="lave-off-img">
              <img
                :src="laveImg(formData.surplusSetting.surplusPosition)"
                alt=""
              />
            </div>
          </m-setting-content>
        </div>
        <div class="cut-hole-way" id="cut-hole-way">
          <span id="span_vzl6dmns8v" class="head-title">{{
            $t('cuttingDock.cuttingParams.cutHoleWay')
          }}</span>
          <div class="cut-hole">
            <div class="base_title">
              <span id="span_ghbhbff0ti" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.knifeFlat') }}：
              </span>
              <a-radio-group
                v-model="formData.cuttingPunchingSetting.zReference"
              >
                <a-radio
                  value="counter_top"
                  id="engraving_setting_zReference_counter_top_radio"
                  ><span
                    id="engraving_setting_zReference_counter_top_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.flat') }}</span
                  ></a-radio
                >
                <a-radio
                  value="plank_surface"
                  id="engraving_setting_zReference_plank_surface_radio"
                  ><span
                    id="engraving_setting_zReference_plank_surface_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.plankFlat') }}</span
                  ></a-radio
                >
              </a-radio-group>
            </div>
            <div class="base_title">
              <span id="span_bzi8ega1th" class="base-title-label pt5"
                >{{ $t('cuttingDock.cuttingParams.freeHeightZ') }}(H)：</span
              >
              <div>
                <a-input
                  suffix="mm"
                  style="width: 138px"
                  id="engraving_setting_idleZ_input"
                  v-model="formData.cuttingPunchingSetting.idleZ"
                  @input="
                    inputCheck('cuttingPunchingSetting', 'idleZ', false, 1)
                  "
                ></a-input>
                <div style="margin-top: 24px">
                  <a-checkbox
                    id="engraving_setting_knifeBasedOnPlank_checkbox"
                    v-model="formData.cuttingPunchingSetting.knifeBasedOnPlank"
                    >{{
                      $t('cuttingDock.cuttingParams.relativeHeight')
                    }}</a-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="base_title">
              <span id="span_achqhjavxc" class="base-title-label pt5"
                >{{ $t('cuttingDock.cuttingParams.cutDeepZ') }}(D)：</span
              >
              <a-input
                suffix="mm"
                style="width: 138px"
                id="engraving_setting_cutZ_input"
                v-model="formData.cuttingPunchingSetting.cutZ"
                @input="inputCheck('cuttingPunchingSetting', 'cutZ', false, 1)"
              ></a-input>
            </div>
            <div class="base_title">
              <span id="span_yjzjn0ijwv" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.cutDeepH') }}：
              </span>
              <a-radio-group
                v-model="formData.cuttingPunchingSetting.throughTowSideToCut"
              >
                <a-radio
                  :value="false"
                  id="engraving_setting_throughTowSideToCut_false_radio"
                  ><span
                    id="engraving_setting_throughTowSideToCut_false_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.onceThrough') }}</span
                  ></a-radio
                >
                <a-radio
                  :value="true"
                  id="engraving_setting_throughTowSideToCut_true_radio"
                  ><span
                    id="engraving_setting_throughTowSideToCut_true_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.rollThrough') }}</span
                  ></a-radio
                >
              </a-radio-group>
            </div>
            <div
              class="base_title"
              v-if="formData.cuttingPunchingSetting.throughTowSideToCut"
            >
              <m-setting-content
                style="margin-bottom: 0 !important"
                :label="$translateLang('设置不生效翻面两次打穿孔')"
                :isShowNew="true"
                :styleObj="{ top: '-12px', right: '0px' }"
                label-id="m_setting_content_l6bie1y5oz"
              >
                <div class="text-center">
                  <a-switch
                    id="setThroughHoleDrillingSwitch"
                    class="switch-setting"
                    v-model="
                      formData.cuttingPunchingSetting
                        .non_through_slot_two_side_cut.is_open
                    "
                    @change="handlePecialHoleAndSlotTableSwitch"
                  ></a-switch>
                  <div
                    id="div_jbx2z7dpvd"
                    class="edge-again-info color-o-4 mt4"
                    v-if="
                      formData.cuttingPunchingSetting
                        .non_through_slot_two_side_cut.is_open
                    "
                  >
                    {{
                      $translateLang(
                        '将对应通孔（打穿的孔）添加到下方规则后，不生效翻面两次打穿'
                      )
                    }}
                  </div>
                </div>
                <div>
                  <span
                    id="addSetThroughHoleDrillingRule"
                    v-if="
                      formData.cuttingPunchingSetting
                        .non_through_slot_two_side_cut.is_open
                    "
                    style="cursor: pointer; color: #18a8c7; font-size: 16px"
                    @click="handleSpecialHoleSlotRef"
                  >
                    {{ translateLang('cuttingDock.cuttingParams.addRules') }}
                  </span>
                  <SpecialHoleAndSlotTable
                    ref="specialHoleSlotRef"
                    keyType="setThroughHoleDrilling"
                    v-if="
                      formData.cuttingPunchingSetting
                        .non_through_slot_two_side_cut.is_open
                    "
                    :special_hole_slot_side_rules="
                      formData.cuttingPunchingSetting
                        .non_through_slot_two_side_cut.special_hole_slot_side ||
                      []
                    "
                    :is_open="
                      formData.cuttingPunchingSetting
                        .non_through_slot_two_side_cut.is_open
                    "
                  />
                </div>
              </m-setting-content>
            </div>
            <div class="base_title">
              <span id="span_5db23v6pcp" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.cutDeepS') }}：
              </span>
              <a-radio-group
                v-model="
                  formData.cuttingPunchingSetting.through_slot_two_side_cut
                "
              >
                <a-radio
                  :value="false"
                  id="engraving_setting_throughSlotToCut_false_radio"
                  ><span
                    id="engraving_setting_throughSlotToCut_false_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.onceThrough') }}</span
                  ></a-radio
                >
                <a-radio
                  :value="true"
                  id="engraving_setting_throughSlotToCut_true_radio"
                  ><span
                    id="engraving_setting_throughSlotToCut_true_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.rollThrough') }}</span
                  ></a-radio
                >
              </a-radio-group>
            </div>
            <div class="base_title">
              <span id="span_21aimp5rlp" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.plankCutDirection') }}：
              </span>
              <a-radio-group
                v-model="formData.cuttingPunchingSetting.cutDirection"
              >
                <a-radio
                  value="顺时针"
                  id="engraving_setting_cutDirection_s_radio"
                  ><span id="engraving_setting_cutDirection_s_radio_label">{{
                    $t('cuttingDock.cuttingParams.sDirection')
                  }}</span></a-radio
                >
                <a-radio
                  value="逆时针"
                  id="engraving_setting_cutDirection_n_radio"
                  ><span id="engraving_setting_cutDirection_n_radio_label">{{
                    $t('cuttingDock.cuttingParams.nDirection')
                  }}</span></a-radio
                >
              </a-radio-group>
            </div>
            <div class="base_title">
              <span id="span_thp0g27s77" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.clockDirSwitch') }}：
              </span>
              <a-switch
                id="engraving_setting_clockDir_switch"
                v-model="formData.cuttingPunchingSetting.clock_dir_switch"
              ></a-switch>
            </div>
            <div
              class="base_title"
              v-if="formData.cuttingPunchingSetting.clock_dir_switch"
            >
              <span id="span_4hycwmtvy8" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.millHoleSlotDir') }}：
              </span>
              <a-radio-group
                v-model="formData.cuttingPunchingSetting.mill_hole_slot_dir"
              >
                <a-radio
                  value="顺时针"
                  id="engraving_setting_millHoleSlotDir_s_radio"
                  ><span id="engraving_setting_millHoleSlotDir_s_radio_label">{{
                    $t('cuttingDock.cuttingParams.sDirection')
                  }}</span></a-radio
                >
                <a-radio
                  value="逆时针"
                  id="engraving_setting_millHoleSlotDir_n_radio"
                  ><span id="engraving_setting_millHoleSlotDir_n_radio_label">{{
                    $t('cuttingDock.cuttingParams.nDirection')
                  }}</span></a-radio
                >
              </a-radio-group>
            </div>
            <div
              class="base_title"
              v-if="formData.cuttingPunchingSetting.clock_dir_switch"
            >
              <span id="span_qns935sgu9" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.millInternalCurveDir') }}：
              </span>
              <a-radio-group
                v-model="formData.cuttingPunchingSetting.cut_internal_curve_dir"
              >
                <a-radio
                  value="顺时针"
                  id="engraving_setting_millInternalCurveDir_s_radio"
                  ><span
                    id="engraving_setting_millInternalCurveDir_s_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.sDirection') }}</span
                  ></a-radio
                >
                <a-radio
                  value="逆时针"
                  id="engraving_setting_millInternalCurveDir_n_radio"
                  ><span
                    id="engraving_setting_millInternalCurveDir_n_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.nDirection') }}</span
                  ></a-radio
                >
              </a-radio-group>
            </div>
            <div class="base_title">
              <span id="span_djyz0ebs8q" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.curveReplenish') }}：</span
              >
              <div>
                <a-switch
                  v-model="
                    formData.cuttingPunchingSetting
                      .cuttingCurvedInterpolationCommand
                  "
                  id="engraving_setting_cuttingCurvedInterpolationCommand_checkbox"
                ></a-switch>
                <div id="div_gz05g3z2xo" class="color-o-4 mt4">
                  {{ $t('cuttingDock.cuttingParams.curveReplenishTip') }}
                </div>
                <div style="margin-top: 24px">
                  <a-checkbox
                    v-model="formData.cuttingPunchingSetting.noG17G18G19"
                    :disabled="
                      !formData.cuttingPunchingSetting
                        .cuttingCurvedInterpolationCommand
                    "
                    id="engraving_setting_noG17G18G19_checkbox"
                  ></a-checkbox>
                  <span id="span_g1ckwt0of3" class="ml8 color-o-4">{{
                    $t('cuttingDock.cuttingParams.noGen')
                  }}</span>
                </div>
              </div>
            </div>
            <div class="base_title flex-cross--center">
              <span id="span_y1c804v3rs" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.arcInstruction') }}：</span
              >
              <a-textarea
                allowClear
                :maxLength="50"
                style="width: 200px"
                v-model="formData.cuttingPunchingSetting.arcInstruction"
                id="engraving_setting_arcInstruction_checkbox"
                :auto-size="{ minRows: 1, maxRows: 3 }"
              />
              <span
                id="span_2uyvrrmngn"
                class="ml14 color-o-6"
                style="font-weight: 400"
              >
                （{{ arcShowExample }}）</span
              >
            </div>
            <div class="base_title">
              <span id="span_3rqyxwps3g" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.curveCutTip') }}：</span
              >
              <a-checkbox
                id="engraving_setting_arcCuttingCode_checkbox"
                v-model="formData.cuttingPunchingSetting.arcCuttingCode"
              ></a-checkbox>
            </div>
            <div class="base_title">
              <span id="span_82x5w1t34v" class="base-title-label">{{
                $t('cuttingDock.cuttingParams.coverRate')
              }}</span>
              <div class="flex flex-dir--top">
                <a-input
                  suffix="%"
                  style="width: 138px"
                  v-model="millingSlotOverlapRate"
                  :max-length="2"
                  defaultValue="0"
                  id="engraving_setting_millingSlotOverlapRate_input"
                ></a-input>
                <span id="span_sdgmnzla2k" class="color-o-4 mt4">{{
                  $t('cuttingDock.cuttingParams.roughTip')
                }}</span>
              </div>
            </div>
            <!--  铣槽时未拉穿的槽自动清理圆角 -->
            <div class="base_title">
              <span id="span_s8yj8md1an" class="base-title-label">{{
                $t('cuttingDock.cuttingParams.clearCurve')
              }}</span>
              <div class="flex flex-dir--top">
                <a-switch
                  id="cuttingParams_autoClearFilletSlot_checkbox"
                  v-model="formData.cuttingPunchingSetting.autoClearFilletSlot"
                  style="width: 42px"
                ></a-switch>
                <span id="span_jw2pgsb0i4" class="color-o-4 mt4">{{
                  $t('cuttingDock.cuttingParams.curveUseTip')
                }}</span>
              </div>
            </div>
            <div class="base_title">
              <span id="span_ylore05rbx" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.slotCutWay') }}：
              </span>
              <a-radio-group
                v-model="formData.cuttingPunchingSetting.mill_slots_way"
                class="m0"
              >
                <a-radio
                  value="out_to_inner"
                  id="engraving_setting_millSlotsWay_out2inner_radio"
                  ><span
                    id="engraving_setting_millSlotsWay_out2inner_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.outToIn') }}</span
                  ></a-radio
                >
                <a-radio
                  value="inner_to_out"
                  id="engraving_setting_millSlotsWay_inner2out_radio"
                  ><span
                    id="engraving_setting_millSlotsWay_inner2out_radio_label"
                    >{{ $t('cuttingDock.cuttingParams.inToOut') }}</span
                  ></a-radio
                >
              </a-radio-group>
              <span
                id="span_dovnepqgbc"
                class="color-o-4"
                style="margin-left: -20px"
                >{{ $t('cuttingDock.cuttingParams.slotWorkLimit') }}</span
              >
            </div>
            <div class="base_title">
              <span id="span_e0liu327mf" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.zShapProcess') }}：</span
              >
              <div>
                <a-switch
                  id="engraving_setting_zShapeProcess_checkbox"
                  v-model="
                    formData.cuttingPunchingSetting
                      .z_shape_processed_through_slot
                  "
                ></a-switch>
                <div id="div_2s3ux4k0jn" class="mt4 color-o-4">
                  {{ $t('cuttingDock.cuttingParams.zShapProcessTip') }}
                </div>
              </div>
            </div>
            <div
              class="base_title flex-cross--center"
              v-show="
                formData.cuttingPunchingSetting
                  .z_shape_processed_through_slot || isShowSecondaryCatalog
              "
            >
              <span id="span_c53ox0dbcy" class="base-title-label"
                >{{
                  $t('cuttingDock.cuttingParams.zSlotCuttingOverlapRate')
                }}：</span
              >
              <a-input
                suffix="%"
                style="width: 138px"
                v-model="mill_z_slot_overlap_rate"
                :max-length="3"
                :defaultValue="0"
                id="engraving_setting_ millZSlotOverlapRate_input"
              ></a-input>
              <span
                class="ml12 color-o-4 fs14"
                v-if="mill_z_slot_overlap_rate > 50"
                >{{
                  $t('cuttingDock.cuttingParams.zSlotCuttingOverlapRateTip')
                }}</span
              >
            </div>
            <div class="base_title">
              <span id="span_c53ox0dbcy" class="base-title-label"
                >{{ $translateLang('加工减少换刀') }}：</span
              >
              <a-switch
                id="engraving_setting_minKnifeChange_checkbox"
                v-model="formData.cuttingPunchingSetting.min_knife_change"
              ></a-switch>
            </div>
            <div class="base_title">
              <span class="base-title-label"
                >{{ $translateLang('边缘槽隔条防断')
                }}<i
                  class="iconfont icon-wenhao ml2"
                  :title="
                    $translateLang(
                      '可解决槽位若过于靠近板材边缘，切割时该处的隔断条（即剩余连接部分）会因应力集中而容易断裂的情况'
                    )
                  "
                ></i
                >：</span
              >
              <div>
                <a-switch
                  id="engraving_setting_preventBreakage_checkbox"
                  v-model="
                    formData.cuttingPunchingSetting.prevent_breakage_setting
                      .enable
                  "
                  class="prevent-breakage-enable"
                ></a-switch>
                <div class="color-o-4 mt4">
                  {{
                    $translateLang(
                      '该设置仅对排版时位于正面的槽有效，可与“特殊孔槽加工面自定义”功能配合使用'
                    )
                  }}
                </div>
                <div
                  v-for="(item, index) in formData.cuttingPunchingSetting
                    .prevent_breakage_setting.rules"
                  :key="item.webId"
                  class="prevent-breakage-rule"
                  v-show="
                    formData.cuttingPunchingSetting.prevent_breakage_setting
                      .enable || isShowSecondaryCatalog
                  "
                >
                  <div
                    class="flex flex-cross--center prevent-breakage-rule-item"
                  >
                    <span class="mr8">{{ $translateLang('距板件边缘') }}</span>
                    <a-input
                      v-model="item.edge_distance[0]"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.edge_distance[0],
                          formData: item,
                          keys: ['edge_distance', 0],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['edge_distance', 0],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                    <span class="rule-to">{{ $translateLang('到') }}</span>
                    <a-input
                      v-model="item.edge_distance[1]"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.edge_distance[1],
                          formData: item,
                          keys: ['edge_distance', 1],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['edge_distance', 1],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                    <span class="ml20 mr8">{{
                      $translateLang('靠边部分长度')
                    }}</span>
                    <a-input
                      v-model="item.length[0]"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.length[0],
                          formData: item,
                          keys: ['length', 0],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['length', 0],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                    <span class="rule-to">{{ $translateLang('至') }}</span>
                    <a-input
                      v-model="item.length[1]"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.length[1],
                          formData: item,
                          keys: ['length', 1],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['length', 1],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                    <span class="ml20 mr8">{{ $translateLang('深度') }}</span>
                    <a-input
                      v-model="item.deep[0]"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.deep[0],
                          formData: item,
                          keys: ['deep', 0],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['deep', 0],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                    <span class="rule-to">{{ $translateLang('到') }}</span>
                    <a-input
                      v-model="item.deep[1]"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.deep[1],
                          formData: item,
                          keys: ['deep', 1],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['deep', 1],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                    <span class="ml8 mr10">{{ $translateLang('的槽') }}</span>
                    <span
                      class="btn add-btn"
                      :class="{
                        'disabled-btn':
                          formData.cuttingPunchingSetting
                            .prevent_breakage_setting.rules.length >= 10,
                      }"
                      @click="handleAddPreBreRule()"
                      >{{ $translateLang('添加') }}</span
                    >
                    <span
                      class="btn delete-btn"
                      :class="{
                        'disabled-btn':
                          formData.cuttingPunchingSetting
                            .prevent_breakage_setting.rules.length <= 1,
                      }"
                      @click="handleDelPreBreRule(index)"
                      >{{ $translateLang('删除') }}</span
                    >
                  </div>
                  <div class="mt10">
                    <span class="mr8">{{
                      $translateLang('首次切割深度')
                    }}</span>
                    <a-input
                      v-model="item.cut_deep"
                      suffix="mm"
                      @input="
                        verifyInputCheck({
                          value: item.cut_deep,
                          formData: item,
                          keys: ['cut_deep'],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @blur="
                        verifyInputCheck({
                          formData: item,
                          keys: ['cut_deep'],
                          isBlur: true,
                        })
                      "
                    ></a-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 输入值全改成前六后二 -->
        <div class="optimize-speed" id="optimize-speed">
          <span id="span_zklwqjeata" class="head-title">{{
            $t('cuttingDock.cuttingParams.workSpeedOp')
          }}</span>
          <div class="content">
            <div class="base_title">
              <span id="span_hzpduhrxow" class="base-title-label">
                {{ $t('cuttingDock.cuttingParams.obliqueCut') }}
                <a-tooltip>
                  <template #title>
                    <div>
                      {{ $translateLang('未指定板厚时，则对所有板厚小板生效') }}
                    </div>
                  </template>
                  <i class="iconfont icon-wenhao"></i>
                </a-tooltip>
                ：
              </span>
              <a-checkbox
                id="engraving_setting_noOblique_checkbox"
                v-model="formData.processingSpeedSetting.noOblique"
                @change="handleObliqueCutBuryPoint('noOblique')"
              >
                {{ $t('cuttingDock.sawEngraving.cutBlank') }}
              </a-checkbox>
              <a-checkbox
                id="engraving_setting_backTrimOblique_checkbox"
                v-model="formData.processingSpeedSetting.back_trim_oblique"
                @change="handleObliqueCutBuryPoint('backTrimOblique')"
              >
                {{ $translateLang('反面修边') }}
              </a-checkbox>
              <a-checkbox
                id="engraving_setting_holeSlotOblique_checkbox"
                v-model="formData.processingSpeedSetting.hole_slot_cut_oblique"
                @change="handleObliqueCutBuryPoint('holeSlotOblique')"
              >
                {{ $translateLang('拉槽/铣孔/铣槽') }}
              </a-checkbox>
            </div>
            <div class="base_title">
              <span id="span_oblique_thick_label" class="base-title-label"
                >{{ $translateLang('自定义斜下刀生效板厚') }}：</span
              >
              <div class="flex flex-dir--top">
                <a-switch
                  id="engraving_setting_oblique_thick_setting_switch"
                  v-model="
                    formData.processingSpeedSetting.oblique_thick_setting_switch
                  "
                  style="width: 44px"
                ></a-switch>
                <div
                  class="oblique-thick-table mt16"
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.processingSpeedSetting.oblique_thick_setting_switch
                  "
                >
                  <div class="manage-plank flex flex-cross--center mb16">
                    <a-button
                      id="engraving_setting_obliqueThick_add_btn"
                      class="mr12"
                      :disabled="!isObliqueThickTableOperateEnabled"
                      @click="handleAddObliqueThickRow"
                    >
                      {{ $t('common.add') }}
                    </a-button>
                    <a-button
                      id="engraving_setting_obliqueThick_delete_btn"
                      type="danger"
                      ghost
                      :disabled="!isObliqueThickTableOperateEnabled"
                      @click="handleDeleteObliqueThickRow"
                    >
                      {{ $t('common.delete') }}
                    </a-button>
                    <span id="span_oblique_thick_unit" class="color-o-4 ml12">
                      （{{ $translateLang('表中板厚单位为') }} :mm）
                    </span>
                  </div>
                  <el-table
                    v-show="hasVisibleObliqueThickColumn"
                    :key="obliqueThickTableColumnKey"
                    :data="formData.processingSpeedSetting.oblique_thick_list"
                    :header-cell-style="changeHeaderStyle"
                    max-height="360px"
                    :style="{ width: obliqueThickTableWidth }"
                  >
                    <el-table-column width="100">
                      <template slot-scope="scope">
                        {{ $translateLang('板厚') }} {{ scope.$index + 1 }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="
                        formData.processingSpeedSetting.noOblique ||
                        isShowSecondaryCatalog
                      "
                      :label="$t('cuttingDock.sawEngraving.cutBlank')"
                      min-width="120"
                    >
                      <template slot-scope="scope">
                        <a-input
                          style="width: 100px"
                          :id="`engraving_setting_obliqueThick_cut_${scope.$index}`"
                          :class="{
                            'oblique-thick-input-error':
                              getObliqueThickListError(scope.$index, 'cut'),
                          }"
                          v-model="scope.row.cut"
                          :disabled="
                            !formData.processingSpeedSetting
                              .oblique_thick_setting_switch ||
                            (isShowSecondaryCatalog &&
                              !formData.processingSpeedSetting.noOblique)
                          "
                          @input="
                            validatePositiveDecimal(
                              'oblique_thick_list',
                              $event,
                              scope.$index,
                              'cut',
                              'thick'
                            )
                          "
                          @blur="validateObliqueThickListColumn('cut')"
                        ></a-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="
                        formData.processingSpeedSetting.back_trim_oblique ||
                        isShowSecondaryCatalog
                      "
                      :label="$translateLang('反面修边')"
                      min-width="120"
                    >
                      <template slot-scope="scope">
                        <a-input
                          style="width: 100px"
                          :id="`engraving_setting_obliqueThick_back_${scope.$index}`"
                          :class="{
                            'oblique-thick-input-error':
                              getObliqueThickListError(
                                scope.$index,
                                'back_trim'
                              ),
                          }"
                          v-model="scope.row.back_trim"
                          :disabled="
                            !formData.processingSpeedSetting
                              .oblique_thick_setting_switch ||
                            (isShowSecondaryCatalog &&
                              !formData.processingSpeedSetting
                                .back_trim_oblique)
                          "
                          @input="
                            validatePositiveDecimal(
                              'oblique_thick_list',
                              $event,
                              scope.$index,
                              'back_trim',
                              'thick'
                            )
                          "
                          @blur="validateObliqueThickListColumn('back_trim')"
                        ></a-input>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="
                        formData.processingSpeedSetting.hole_slot_cut_oblique ||
                        isShowSecondaryCatalog
                      "
                      :label="$translateLang('拉槽/铣孔/铣槽')"
                      min-width="140"
                    >
                      <template slot-scope="scope">
                        <a-input
                          style="width: 100px"
                          :id="`engraving_setting_obliqueThick_hole_${scope.$index}`"
                          :class="{
                            'oblique-thick-input-error':
                              getObliqueThickListError(
                                scope.$index,
                                'hole_slot'
                              ),
                          }"
                          v-model="scope.row.hole_slot"
                          :disabled="
                            !formData.processingSpeedSetting
                              .oblique_thick_setting_switch ||
                            (isShowSecondaryCatalog &&
                              !formData.processingSpeedSetting
                                .hole_slot_cut_oblique)
                          "
                          @input="
                            validatePositiveDecimal(
                              'oblique_thick_list',
                              $event,
                              scope.$index,
                              'hole_slot',
                              'thick'
                            )
                          "
                          @blur="validateObliqueThickListColumn('hole_slot')"
                        ></a-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div
              class="base_title"
              v-if="
                formData.processingSpeedSetting.noOblique ||
                formData.processingSpeedSetting.back_trim_oblique ||
                formData.processingSpeedSetting.hole_slot_cut_oblique ||
                isShowSecondaryCatalog
              "
            >
              <span id="span_hybkw2b8qr" class="base-title-label pt6"
                >{{ $translateLang('斜下刀速度') }}：</span
              >
              <div class="flex flex-dir--top">
                <div
                  class="flex flex-cross--center mb16"
                  v-if="
                    formData.processingSpeedSetting.noOblique ||
                    formData.processingSpeedSetting.back_trim_oblique ||
                    isShowSecondaryCatalog
                  "
                >
                  <span
                    id="span_oblique_speed_cut_label"
                    class="oblique-param-sub-label"
                  >
                    {{ $translateLang('切割下料和反面修边') }}
                  </span>
                  <a-input
                    id="engraving_setting_obliqueSpeed_input"
                    suffix="mm"
                    style="width: 138px"
                    v-model="formData.processingSpeedSetting.obliqueSpeed"
                    @input="
                      validatePositiveDecimal(
                        'obliqueSpeed',
                        $event,
                        null,
                        null
                      )
                    "
                    @blur="
                      handleDecimalBlur(
                        'processingSpeedSetting',
                        'obliqueSpeed',
                        null,
                        null
                      )
                    "
                    :disabled="
                      isShowSecondaryCatalog &&
                      !(
                        formData.processingSpeedSetting.noOblique ||
                        formData.processingSpeedSetting.back_trim_oblique
                      )
                    "
                  ></a-input>
                </div>
                <div
                  class="flex flex-cross--center"
                  v-if="
                    formData.processingSpeedSetting.hole_slot_cut_oblique ||
                    isShowSecondaryCatalog
                  "
                >
                  <span
                    id="span_oblique_speed_hole_label"
                    class="oblique-param-sub-label"
                  >
                    {{ $translateLang('拉槽/铣孔/铣槽') }}
                  </span>
                  <a-input
                    id="engraving_setting_holeSlotObliqueSpeed_input"
                    suffix="mm"
                    style="width: 138px"
                    v-model="
                      formData.processingSpeedSetting.hole_slot_oblique_speed
                    "
                    @input="
                      validatePositiveDecimal(
                        'hole_slot_oblique_speed',
                        $event,
                        null,
                        null
                      )
                    "
                    @blur="
                      handleDecimalBlur(
                        'processingSpeedSetting',
                        'hole_slot_oblique_speed',
                        null,
                        null
                      )
                    "
                    :disabled="
                      isShowSecondaryCatalog &&
                      !formData.processingSpeedSetting.hole_slot_cut_oblique
                    "
                  ></a-input>
                </div>
              </div>
            </div>
            <div
              class="base_title"
              v-if="
                formData.processingSpeedSetting.noOblique ||
                formData.processingSpeedSetting.back_trim_oblique ||
                formData.processingSpeedSetting.hole_slot_cut_oblique ||
                isShowSecondaryCatalog
              "
            >
              <span id="span_j7lhc8w8pq" class="base-title-label pt6"
                >{{ $translateLang('斜下刀距离') }}：</span
              >
              <div class="flex flex-dir--top">
                <div
                  class="flex flex-cross--center mb16"
                  v-if="
                    formData.processingSpeedSetting.noOblique ||
                    formData.processingSpeedSetting.back_trim_oblique ||
                    isShowSecondaryCatalog
                  "
                >
                  <span
                    id="span_oblique_distance_cut_label"
                    class="oblique-param-sub-label"
                  >
                    {{ $translateLang('切割下料和反面修边') }}
                  </span>
                  <a-input
                    id="engraving_setting_obliqueDistance_input"
                    suffix="mm"
                    style="width: 138px"
                    v-model="formData.processingSpeedSetting.oblique_distance"
                    @input="
                      validatePositiveDecimal(
                        'oblique_distance',
                        $event,
                        null,
                        null
                      )
                    "
                    @blur="
                      handleDecimalBlur(
                        'processingSpeedSetting',
                        'oblique_distance',
                        null,
                        null
                      )
                    "
                    :disabled="
                      isShowSecondaryCatalog &&
                      !(
                        formData.processingSpeedSetting.noOblique ||
                        formData.processingSpeedSetting.back_trim_oblique
                      )
                    "
                  ></a-input>
                </div>
                <div
                  class="flex flex-cross--center"
                  v-if="
                    formData.processingSpeedSetting.hole_slot_cut_oblique ||
                    isShowSecondaryCatalog
                  "
                >
                  <span
                    id="span_oblique_distance_hole_label"
                    class="oblique-param-sub-label"
                  >
                    {{ $translateLang('拉槽/铣孔/铣槽') }}
                  </span>
                  <a-input
                    id="engraving_setting_holeSlotObliqueDistance_input"
                    suffix="mm"
                    style="width: 138px"
                    v-model="
                      formData.processingSpeedSetting.hole_slot_oblique_distance
                    "
                    @input="
                      validatePositiveDecimal(
                        'hole_slot_oblique_distance',
                        $event,
                        null,
                        null
                      )
                    "
                    @blur="
                      handleDecimalBlur(
                        'processingSpeedSetting',
                        'hole_slot_oblique_distance',
                        null,
                        null
                      )
                    "
                    :disabled="
                      isShowSecondaryCatalog &&
                      !formData.processingSpeedSetting.hole_slot_cut_oblique
                    "
                  ></a-input>
                </div>
              </div>
            </div>
            <div class="base_title">
              <span id="span_jlbn2njab1" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.arcSpeed') }}：</span
              >
              <!-- @input="inputCheck('processingSpeedSetting', 'arcSpeed', true)" -->
              <a-input
                id="engraving_setting_arcSpeed_input"
                v-model="formData.processingSpeedSetting.arcSpeed"
                @input="validatePositiveDecimal('arcSpeed', $event, null, null)"
                @blur="
                  handleDecimalBlur(
                    'processingSpeedSetting',
                    'arcSpeed',
                    null,
                    null
                  )
                "
              ></a-input>
            </div>

            <div class="base_title">
              <span id="span_xwge283rlo" class="base-title-label"
                >{{
                  $t('cuttingDock.cuttingParams.cuttingPreDistance')
                }}：</span
              >
              <!-- @input="inputCheck('processingSpeedSetting', 'cuttingPreDistance', false, 2, true)" -->
              <a-input
                suffix="mm"
                style="width: 138px"
                id="engraving_setting_cuttingPreDistance_input"
                v-model="formData.processingSpeedSetting.cuttingPreDistance"
                @input="
                  validatePositiveDecimal(
                    'cuttingPreDistance',
                    $event,
                    null,
                    null
                  )
                "
                @blur="
                  handleDecimalBlur(
                    'processingSpeedSetting',
                    'cuttingPreDistance',
                    null,
                    null
                  )
                "
              ></a-input>
            </div>
            <div class="base_title">
              <span id="span_jodiozxtzg" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.backKnife') }}：</span
              >
              <div class="flex flex-dir--top">
                <a-switch
                  id="engraving_setting_openknifeSpeed_switch"
                  v-model="formData.processingSpeedSetting.openknifeSpeed"
                  style="width: 42px"
                ></a-switch>
                <div
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.processingSpeedSetting.openknifeSpeed
                  "
                  class="flex-cross--center"
                  style="margin-top: 24px"
                >
                  <span id="span_retract_slow_distance">{{
                    $translateLang('减速距离')
                  }}</span>
                  <a-input
                    v-model="
                      formData.processingSpeedSetting.open_knife_distance
                    "
                    id="engraving_setting_openknifeDistance_input"
                    suffix="mm"
                    style="width: 138px"
                    class="ml8"
                    @focus="handleOpenKnifeDistanceFocus"
                    @input="validateOpenKnifeDistance($event)"
                    @blur="
                      handleDecimalBlur(
                        'processingSpeedSetting',
                        'open_knife_distance',
                        null,
                        null
                      )
                    "
                  ></a-input>

                  <span id="span_r2yk95m0h1" style="margin-left: 40px">{{
                    $t('cuttingDock.cuttingParams.openKnifeSpeed')
                  }}</span>
                  <!-- @input="inputCheck('processingSpeedSetting', 'knifeSpeed', true)"  -->
                  <a-input
                    :disabled="!formData.processingSpeedSetting.openknifeSpeed"
                    v-model="formData.processingSpeedSetting.knifeSpeed"
                    id="engraving_setting_openknifeSpeed_input"
                    @input="
                      validatePositiveDecimal('knifeSpeed', $event, null, null)
                    "
                    @blur="
                      handleDecimalBlur(
                        'processingSpeedSetting',
                        'knifeSpeed',
                        null,
                        null
                      )
                    "
                    class="ml8"
                  ></a-input>
                </div>
              </div>
            </div>
            <div class="base_title flex flex-cross--center">
              <span class="base-title-label"
                >{{
                  $t('cuttingDock.cuttingParams.retractionCompensation')
                }}：</span
              >
              <div class="flex flex-cross--center">
                <a-input
                  suffix="mm"
                  style="width: 138px"
                  v-model="
                    formData.processingSpeedSetting.retraction_compensation
                  "
                  @input="
                    validateRetractionCompensation(
                      'retraction_compensation',
                      $event
                    )
                  "
                  @blur="
                    handleRetractionCompensationBlur(
                      'processingSpeedSetting',
                      'retraction_compensation'
                    )
                  "
                ></a-input>
                <span class="color-o-4 ml8 fs14"
                  >({{
                    $t('cuttingDock.cuttingParams.retractionCompensationTip')
                  }})</span
                >
              </div>
            </div>
            <div class="base_title">
              <span id="span_ow0ccpx9se" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.cutCornerSlow') }}：</span
              >
              <div class="flex flex-dir--top">
                <div style="margin-bottom: 24px">
                  <a-switch
                    id="engraving_setting_angle_deceleration_enabled_switch"
                    v-model="
                      formData.processingSpeedSetting.angle_deceleration_enabled
                    "
                  ></a-switch>
                  <span
                    id="span_3pjfwoszwg"
                    class="base-btn pointer"
                    @click="
                      handelAddAngleDeceleration('angle_deceleration_list')
                    "
                    v-show="
                      !isShowBaseBtn &&
                      (isShowSecondaryCatalog ||
                        formData.processingSpeedSetting
                          .angle_deceleration_enabled)
                    "
                  >
                    {{ $t('cuttingDock.cuttingParams.addRow') }}
                  </span>
                </div>
                <template
                  v-if="
                    isShowSecondaryCatalog ||
                    formData.processingSpeedSetting.angle_deceleration_enabled
                  "
                >
                  <div
                    v-for="(item, index) in formData.processingSpeedSetting
                      .angle_deceleration_list"
                    :key="index"
                    class="flex-cross--center mb16"
                  >
                    <span id="span_5tbi01fb3v">{{
                      $t('cuttingDock.cuttingParams.bettwenDistance')
                    }}</span>
                    <!-- @change="handleInputVal('processingSpeedSetting','angle_deceleration_list',index, 0)" -->
                    <a-input
                      id="engraving_setting_angle_deceleration_dis_input"
                      suffix="mm"
                      class="ml8"
                      v-model="item[0]"
                      :disabled="
                        !formData.processingSpeedSetting
                          .angle_deceleration_enabled
                      "
                      @input="
                        validatePositiveDecimal(
                          'angle_deceleration_list',
                          $event,
                          index,
                          0
                        )
                      "
                      @blur="
                        handleDecimalBlur(
                          'processingSpeedSetting',
                          'angle_deceleration_list',
                          index,
                          0
                        )
                      "
                      style="width: 138px; margin-right: 40px"
                    ></a-input>
                    <span id="span_pdcb6j1jnh">{{
                      $t('cuttingDock.cuttingParams.cuttingSpeed')
                    }}</span>
                    <!-- @change="handleInputVal('processingSpeedSetting','angle_deceleration_list',index,1)" -->
                    <a-input
                      id="engraving_setting_angle_deceleration_speed_input"
                      :disabled="
                        !formData.processingSpeedSetting
                          .angle_deceleration_enabled
                      "
                      v-model="item[1]"
                      @input="
                        validatePositiveDecimal(
                          'angle_deceleration_list',
                          $event,
                          index,
                          1
                        )
                      "
                      @blur="
                        handleDecimalBlur(
                          'processingSpeedSetting',
                          'angle_deceleration_list',
                          index,
                          1
                        )
                      "
                      class="ml8"
                    ></a-input>
                    <span
                      id="span_0nxwzn87rp"
                      class="base-btn pointer ml16"
                      @click="handelDeleteAngleDeceleration(index)"
                      v-show="isShowBaseBtn"
                    >
                      {{ $t('common.delete') }}
                    </span>
                  </div>
                </template>
              </div>
            </div>
            <div class="base_title">
              <span id="span_alo0kewjqh" class="base-title-label"
                >{{
                  translateCuttingParams('单独设置小板尺寸范围加工速度')
                }}：</span
              >
              <div class="flex flex-dir--top">
                <div style="margin-bottom: 24px">
                  <a-switch
                    v-model="
                      formData.processingSpeedSetting.small_plank_cut_switch
                    "
                    id="engraving_setting_customSpeed_switch"
                  ></a-switch>
                  <span id="span_wctnpj49dl">{{
                    translateCuttingParams(
                      '（1.当满足下方设置尺寸的小板会按照设置的加工速度进行加工 2.当小板同时满足多条规则时生效速度最小规则 3.该功能不对锯片切割生效）'
                    )
                  }}</span>
                </div>
                <template
                  v-if="
                    isShowSecondaryCatalog ||
                    formData.processingSpeedSetting.small_plank_cut_switch
                  "
                >
                  <div>
                    <span
                      id="span_kowd74x9ab"
                      class="text-color mb16"
                      @click="hanadleAddSpeedRule"
                      :class="{
                        'rule-disabled':
                          formData.processingSpeedSetting.small_plank_cut_rule
                            .length >= 5,
                      }"
                      >{{ translateCuttingParams('添加规则') }}</span
                    >
                  </div>

                  <div class="speed-rule" id="speed-rule">
                    <div
                      v-for="(item, index) in formData.processingSpeedSetting
                        .small_plank_cut_rule"
                      :key="index"
                      class="color-o-9 mb16 flex flex-cross--center"
                      style="flex-wrap: wrap"
                    >
                      <span id="span_x5dw3tqwux">{{
                        translateCuttingParams('规则') + (index + 1)
                      }}</span>
                      <span id="span_vu67kfawug" class="mh16">{{
                        translateCuttingParams('短边尺寸')
                      }}</span>
                      <span id="span_ouefq9kd4v" class="bold">{{
                        translateCuttingParams('小于等于')
                      }}</span>
                      <!-- 输入框限制 输入数字（正整数）-->
                      <!-- @input="inputCheckCustomSpeed(index, 'short_edge_range')" -->
                      <a-input
                        v-model="item.short_edge_range"
                        id="engraving_setting_shortSize_input"
                        class="mh16"
                        @input="
                          validatePositiveDecimal(
                            'small_plank_cut_rule',
                            $event,
                            index,
                            'short_edge_range'
                          )
                        "
                        @blur="
                          handleDecimalBlur(
                            'processingSpeedSetting',
                            'small_plank_cut_rule',
                            index,
                            'short_edge_range'
                          )
                        "
                      ></a-input>
                      <span id="span_lq3r54k723" class="bold">{{
                        translateCuttingParams('且')
                      }}</span>
                      <span id="span_6aifdv1ljx" class="mh16">{{
                        translateCuttingParams('长边尺寸')
                      }}</span>
                      <span id="span_j8h9mcqhri" class="bold">{{
                        translateCuttingParams('小于等于')
                      }}</span>
                      <!-- @input="inputCheckCustomSpeed(index, 'long_edge_range')" -->
                      <a-input
                        id="engraving_setting_longSize_input"
                        v-model="item.long_edge_range"
                        class="mh16"
                        @input="
                          validatePositiveDecimal(
                            'small_plank_cut_rule',
                            $event,
                            index,
                            'long_edge_range'
                          )
                        "
                        @blur="
                          handleDecimalBlur(
                            'processingSpeedSetting',
                            'small_plank_cut_rule',
                            index,
                            'long_edge_range'
                          )
                        "
                      ></a-input>
                      <span id="span_pjc7vk18lw">{{
                        translateCuttingParams('加工速度')
                      }}</span>
                      <!-- @input="inputCheckCustomSpeed(index, 'speed')" -->
                      <a-input
                        id="engraving_setting_processingSpeed_input"
                        v-model="item.speed"
                        class="mh16"
                        @input="
                          validatePositiveDecimal(
                            'small_plank_cut_rule',
                            $event,
                            index,
                            'speed'
                          )
                        "
                        @blur="
                          handleDecimalBlur(
                            'processingSpeedSetting',
                            'small_plank_cut_rule',
                            index,
                            'speed'
                          )
                        "
                      ></a-input>
                      <!-- 删除图标 -->
                      <span
                        class="el-icon-delete cursor-pointer"
                        @click="handleDeleteSpeedRule(index)"
                      ></span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="hierarchy-cut" id="hierarchy-cutting">
          <span id="span_8rk6w910qa" class="head-title">{{
            $t('cuttingDock.cuttingParams.stepCutting')
          }}</span>
          <div class="hierarchy-cut-content">
            <div class="base_title">
              <span id="span_k5m14qlc98" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.splitSlot') }}：</span
              >
              <a-switch
                id="engraving-setting_repeatedSlot_checkbox"
                v-model="formData.layeredCuttingSetting.repeatedSlot"
              ></a-switch>
            </div>
            <!-- 拉槽铣槽分层切割 -->
            <div class="hierarchy-cut-twice base_title">
              <span id="span_cog0yfo4gk" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.hierarchyCutTwice') }}：</span
              >
              <div>
                <a-switch
                  v-model="formData.layeredCuttingSetting.layered_slot_cutting"
                  id="engraving_setting_layered_slot_cutting_switch"
                ></a-switch>
                <div
                  class="hierarchy-cut-limit"
                  v-show="
                    formData.layeredCuttingSetting.layered_slot_cutting ||
                    isShowSecondaryCatalog
                  "
                  style="margin-top: 24px"
                >
                  <div>
                    <span id="span_dj2hn1ks7i" class="mr8">{{
                      $t('cuttingDock.cuttingParams.knifeDia')
                    }}</span>
                    <a-input
                      suffix="mm"
                      style="width: 138px"
                      :value="
                        formData.layeredCuttingSetting
                          .layered_slot_lt_knife_diameter
                      "
                      @input="
                        handleCheckInput(
                          'layered_slot_lt_knife_diameter',
                          $event
                        )
                      "
                      :disabled="
                        !formData.layeredCuttingSetting.layered_slot_cutting
                      "
                    ></a-input>
                    <span id="span_blnggyle70" class="mh8"
                      >&nbsp;{{ $t('cuttingDock.cuttingParams.slotDeep') }}
                    </span>
                    <a-input
                      suffix="mm"
                      style="width: 138px"
                      :value="
                        formData.layeredCuttingSetting.layered_slot_gt_slot_deep
                      "
                      @input="
                        handleCheckInput('layered_slot_gt_slot_deep', $event)
                      "
                      :disabled="
                        !formData.layeredCuttingSetting.layered_slot_cutting
                      "
                      @blur="handleInputBlur"
                    ></a-input>
                    <span id="span_7w21vr50ze" class="ml8"
                      >&nbsp;{{
                        $t('cuttingDock.cuttingParams.cutTwiceSlot')
                      }}</span
                    >
                  </div>
                  <div class="secondCutting mb16">
                    <span id="span_2anv96apmh" class="mr8">{{
                      $t('cuttingDock.cuttingParams.twiceSlotDeep')
                    }}</span>
                    <a-input
                      style="width: 138px"
                      suffix="mm"
                      :value="
                        formData.layeredCuttingSetting
                          .layered_slot_second_slot_deep
                      "
                      @input="
                        handleCheckInput(
                          'layered_slot_second_slot_deep',
                          $event
                        )
                      "
                      :disabled="
                        !formData.layeredCuttingSetting.layered_slot_cutting
                      "
                      @blur="handleInputBlur"
                    ></a-input>
                    <div class="mt5" v-show="isShowWarning">
                      <!-- 提示 感觉不太对-->
                      <span id="span_2wxbeo08os" class="warning"
                        >切割深度不能大于槽深度</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="base_title">
              <span id="span_dhvtk3u8dg" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.splitPlankThick') }}：</span
              >
              <div class="flex flex-dir--top">
                <a-switch
                  id="engraving_setting_isLayeredCut_switch"
                  v-model="formData.layeredThickSetting.isLayeredCut"
                  style="width: 42px; margin-bottom: 25px"
                ></a-switch>
                <div
                  class="plank-table flex-box--1"
                  v-show="
                    isShowSecondaryCatalog ||
                    formData.layeredThickSetting.isLayeredCut
                  "
                >
                  <div class="manage-plank">
                    <a-button
                      @click="addNewPlank"
                      :disabled="!formData.layeredThickSetting.isLayeredCut"
                      class="mr12"
                      id="engraving_setting_addNewPlank_btn"
                      >{{ $t('materialPage.addPlank') }}</a-button
                    >
                    <a-button
                      type="danger"
                      ghost
                      @click="deletePlank"
                      :disabled="!formData.layeredThickSetting.isLayeredCut"
                      id="engraving_setting_deletePlank_btn"
                      >{{ $t('arrangedPage.deletePlank') }}</a-button
                    >
                  </div>
                  <div
                    class="plank-table-main"
                    id="engraving_setting_plankTable_div"
                  >
                    <!-- cell-click 当某个单元格被点击时会触发该事件 -->
                    <el-table
                      :data="formData.layeredThickSetting.layeredThicks"
                      :header-cell-style="changeHeaderStyle"
                      :cell-style="changeCellStyle"
                      :row-class-name="tableRowClassName"
                      :cell-class-name="tableCellClassName"
                      @cell-click="cellClick"
                      max-height="500px"
                    >
                      <el-table-column
                        v-for="(item, index) in plankListColumn"
                        :key="index"
                        :label="translateLang(item.label)"
                        :prop="item.prop"
                        class="ellipsis"
                      >
                        <template slot-scope="scope">
                          <div
                            v-if="
                              scope.row.index === rowIndex &&
                              scope.column.index === columnIndex &&
                              item.prop !== 'highlight'
                            "
                          >
                            <el-input
                              :id="`engraving_setting_layeredThicks_table_${scope.row.index}_${item.prop}_input`"
                              v-model="scope.row[item.prop]"
                              ref="editInput"
                              type="string"
                              size="mini"
                              :disabled="disableddRules(scope.row, item.prop)"
                              @blur="inputBlur(scope.row, item.prop)"
                              @change="inputBlur(scope.row, item.prop)"
                              @input="verifyInput(scope.row, item.prop)"
                            />
                          </div>
                          <!-- 高光属性 下拉框 -->
                          <div
                            v-else-if="
                              scope.row.index === rowIndex &&
                              scope.column.index === columnIndex &&
                              scope.row.matCode &&
                              item.prop === 'highlight'
                            "
                          >
                            <!-- 下拉框 默认是非高光 材质未选择的时候不允许选择-->
                            <el-select
                              :value="
                                scope.row[item.prop]
                                  ? 'heighGloss'
                                  : 'notHeighGloss'
                              "
                              :disabled="!scope.row.matCode"
                              @change="
                                (optionValue) =>
                                  handleChangeHighGloss(
                                    optionValue,
                                    scope.row,
                                    item.prop
                                  )
                              "
                              placeholder=""
                              :id="`cuttingParams_highlight_select_${scope.row.index}`"
                            >
                              <el-option
                                value="notHeighGloss"
                                :label="`非${matchHighlightBoardName(
                                  scope.row.matCode
                                )}`"
                                :id="`cuttingParams_notHeighGloss_selectOption_${scope.row.index}`"
                              >
                              </el-option>
                              <el-option
                                value="heighGloss"
                                :label="
                                  matchHighlightBoardName(scope.row.matCode)
                                "
                                :id="`cuttingParams_heighGloss_selectOption_${scope.row.index}`"
                              >
                              </el-option>
                            </el-select>
                          </div>
                          <div
                            class="knives-type"
                            :id="`engraving_setting_layeredThicks_table_${scope.row.index}_${item.prop}`"
                            v-else
                          >
                            {{
                              item.prop == 'highlight' &&
                              [true, false].includes(scope.row[item.prop])
                                ? !scope.row[item.prop]
                                  ? `非${matchHighlightBoardName(
                                      scope.row.matCode
                                    )}`
                                  : matchHighlightBoardName(scope.row.matCode)
                                : scope.row[item.prop]
                            }}
                          </div>
                          <div
                            v-if="
                              item.prop == 'thirdCut' &&
                              !onDealHierarchyCutting(scope.row)
                            "
                          >
                            <div
                              class="tip"
                              id="cutting_Params_totalThickLimit_tip"
                            >
                              ({{
                                $t('cuttingDock.cuttingParams.totalThickLimit')
                              }})
                            </div>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>

                  <div style="margin-top: 24px">
                    <a-checkbox
                      id="engraving_setting_trimmingFollowsLayeredCutting_checkbox"
                      v-model="
                        formData.layeredThickSetting
                          .trimmingFollowsLayeredCutting
                      "
                      :disabled="!formData.layeredThickSetting.isLayeredCut"
                    ></a-checkbox>
                    <span id="span_1eu3gilsnp" class="ml8">{{
                      $t('cuttingDock.cuttingParams.offsetFollowStep')
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newCutSequence hierarchy-cut" id="move-plank">
          <span id="span_urkisuscxg" class="head-title">{{
            $t('cuttingDock.cuttingParams.movePlankSetting')
          }}</span>
          <!-- 新版切割算法开关 -->
          <div class="base_title flex">
            <span id="span_7onm7nbg66" class="base-title-label"
              >{{ $t('cuttingDock.cuttingParams.newCutSequence') }}：</span
            >
            <div>
              <a-switch
                id="engraving_setting_newCutSequence_checkbox"
                v-model="formData.movePlankSetting.newCutSequence"
                style="width: 42px"
              ></a-switch>
              <span id="span_ne2638g7nh" class="color-o-4 ml5">
                {{ $t('cuttingDock.cuttingParams.newCutSequenceText') }}
              </span>
            </div>
          </div>
          <!-- 真空强吸力位置 -->
          <div
            class="base_title strong-van"
            v-show="formData.movePlankSetting.newCutSequence"
          >
            <span id="span_ba1pmyyzx9" class="base-title-label"
              >{{ $t('cuttingDock.cuttingParams.suctionPosition') }}：</span
            >
            <div class="container">
              <div class="grid-left mt16 mb16">
                <div
                  class="grid-item"
                  v-for="(item, index) in suctionPosition"
                  :key="index"
                  @click="handleSuctionClick(index)"
                  :class="{ active: item.isSelected }"
                ></div>
              </div>
              <div class="grid-rigth">
                <div class="rigth-top">
                  <div class="example"></div>
                  <span id="span_64esw5c0aa" class="ml6">{{
                    $t('cuttingDock.cuttingParams.strongArea')
                  }}</span>
                </div>

                <span id="span_prjho6lrlb" class="right-buttom"
                  >（{{ $t('cuttingDock.cuttingParams.positionTip') }}）</span
                >
              </div>
            </div>
          </div>

          <div class="base_title flex flex-cross--center">
            <span id="span_enotvde4rd" class="base-title-label">
              {{ $t('cuttingDock.cuttingParams.minSuctionPlank') }}：
            </span>
            <span id="span_rqczpy25c8" class="mr6">
              {{ $t('cuttingDock.cuttingParams.safeWidth') }}</span
            >
            <a-input
              v-if="
                formData.movePlankSetting.safe_length &&
                formData.movePlankSetting.safe_length.length
              "
              v-model="formData.movePlankSetting.safe_length[0]"
              suffix="mm"
              style="width: 100px"
              @input="safeInputCheck('movePlankSetting', 'safe_length', 0)"
            ></a-input>
            <span id="span_fh90907hjk" class="mr6">
              {{ $t('cuttingDock.cuttingParams.safeHeight') }}</span
            >

            <a-input
              v-if="
                formData.movePlankSetting.safe_length &&
                formData.movePlankSetting.safe_length.length
              "
              @input="safeInputCheck('movePlankSetting', 'safe_length', 1)"
              v-model="formData.movePlankSetting.safe_length[1]"
              suffix="mm"
              style="width: 100px"
            ></a-input>

            <span id="span_1njl1wn6ou"
              >（{{ $t('cuttingDock.cuttingParams.safeTip') }}）</span
            >
          </div>
          <!-- 小板分散排版 -->
          <div class="base_title">
            <span id="span_5ecg07stvq" class="base-title-label"
              >{{ $t('cuttingDock.cuttingParams.scattered_layout') }}：</span
            >
            <a-switch
              v-bp="'engraving:dispersePaiban'"
              v-model="formData.movePlankSetting.scattered_layout"
              id="engraving_setting_dispersePaiban_checkbox"
              class="mr10"
            ></a-switch>
            (
            <span id="span_u3hdko0jip">
              {{ $t('cuttingDock.cuttingParams.dispersePaibanTipOne') }}
            </span>
            <!-- <span style="color: #ed7b2f">{{
                $t('cuttingDock.cuttingParams.dispersePaibanTipTwo')
              }}</span
              > -->
            )
          </div>
          <!-- 最后切割小板下刀点自定义 -->
          <div class="base_title">
            <span class="base-title-label"
              >{{ $translateLang('大板上最后切割小板下刀点自定义') }}：</span
            >
            <a-switch
              v-model="formData.movePlankSetting.lastPlankCutPointEnable"
              style="width: 42px"
            ></a-switch>
            <span class="color-o-4 ml5"
              >({{
                $translateLang(
                  '启用后每张大板上最后切割的小板下刀点会按照设置的点位生成下刀点'
                )
              }})</span
            >
          </div>
          <div
            class="base_title last-cut-point-wrapper"
            v-show="formData.movePlankSetting.lastPlankCutPointEnable"
          >
            <span class="base-title-label"></span>
            <div class="last-cut-point-container">
              <div class="plank-diagram">
                <div
                  class="corner left-top"
                  :class="{
                    active:
                      formData.movePlankSetting.lastPlankCutPoint === 'leftTop',
                  }"
                  @click="
                    formData.movePlankSetting.lastPlankCutPoint = 'leftTop'
                  "
                >
                  <span class="corner-dot"></span>
                </div>
                <div
                  class="corner right-top"
                  :class="{
                    active:
                      formData.movePlankSetting.lastPlankCutPoint ===
                      'rightTop',
                  }"
                  @click="
                    formData.movePlankSetting.lastPlankCutPoint = 'rightTop'
                  "
                >
                  <span class="corner-dot"></span>
                </div>
                <div
                  class="corner left-bottom"
                  :class="{
                    active:
                      formData.movePlankSetting.lastPlankCutPoint ===
                      'leftBottom',
                  }"
                  @click="
                    formData.movePlankSetting.lastPlankCutPoint = 'leftBottom'
                  "
                >
                  <span class="corner-dot"></span>
                </div>
                <div
                  class="corner right-bottom"
                  :class="{
                    active:
                      formData.movePlankSetting.lastPlankCutPoint ===
                      'rightBottom',
                  }"
                  @click="
                    formData.movePlankSetting.lastPlankCutPoint = 'rightBottom'
                  "
                >
                  <span class="corner-dot"></span>
                </div>
                <span class="center-text">{{ lastCutPointText }}</span>
              </div>
            </div>
          </div>
          <!-- 小板切割两次 -->
          <div class="hierarchy-cut-twice base_title mb0 flex-dir--top w-100">
            <div
              class="flex flex-cross--center flex-dir--left flex-main--left w-100"
            >
              <span id="span_n8rjlxhl0w" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.splitPlank2') }}：</span
              >
              <div class="flex flex-cross--center flex-dir--left w-100">
                <a-switch
                  id="engraving_setting_repeatedCut_switch"
                  v-model="formData.layeredCuttingSetting.repeatedCut"
                  style="width: 42px"
                ></a-switch>
                <span id="span_z5f2xldbnd" class="color-o-4 ml5">
                  {{ $translateLang('（异形板件不生效此功能）') }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="hierarchy-cut-limit mb0 base_title mt20 ml8 flex-dir--top w-100"
            v-show="
              isShowSecondaryCatalog ||
              formData.layeredCuttingSetting.repeatedCut
            "
          >
            <div
              class="flex flex-cross--center flex-dir--left flex-main--left w-100"
            >
              <span class="base-title-label"
                >{{ $translateLang('切板方式') }}：</span
              >
              <span>
                <a-radio-group
                  v-model="
                    formData.layeredCuttingSetting.rect_plank_cutting_method
                  "
                  @change="handleChangeCutPlankMethod"
                  :disabled="!formData.layeredCuttingSetting.repeatedCut"
                >
                  <a-radio
                    value="4_sides_layer"
                    id="engraving_setting_rect_plank_cutting_method_4_sides_layer_radio"
                    >{{ $translateLang('四边切两次') }}</a-radio
                  >
                  <a-radio
                    value="1_side_layer"
                    id="engraving_setting_rect_plank_cutting_method_1_side_layer_radio"
                    >{{ $translateLang('仅最后一条边切两次')
                    }}<span class="color-o-4">
                      {{ $translateLang('（不兼容：收刀补偿）') }}
                    </span></a-radio
                  >
                </a-radio-group>
              </span>
            </div>
          </div>
          <div
            class="base_title flex flex-cross--center flex-dir--left flex-main--left w-100"
          >
            <div class="base-title-label"></div>
            <div
              class="hierarchy-cut-limit"
              v-show="
                isShowSecondaryCatalog ||
                formData.layeredCuttingSetting.repeatedCut
              "
            >
              <div class="mt20">
                <span id="span_dh01gv7lyn" class="mr8"
                  >{{ $t('cuttingDock.cuttingParams.maxWH') }}
                </span>
                <a-input
                  suffix="mm"
                  style="width: 138px"
                  id="engraving_setting_minSafeLength_input"
                  v-model="formData.layeredCuttingSetting.minSafeLength"
                  @input="
                    inputCheck('layeredCuttingSetting', 'minSafeLength', true)
                  "
                  :disabled="!formData.layeredCuttingSetting.repeatedCut"
                ></a-input>
                <span class="ml8 mr8">{{
                  $t('cuttingDock.cuttingParams.minSafeThick')
                }}</span>
                <a-input
                  suffix="mm"
                  style="width: 138px"
                  id="engraving_setting_minSafeThick"
                  v-model="formData.layeredCuttingSetting.minSafeThick"
                  @input="
                    inputCheck(
                      'layeredCuttingSetting',
                      'minSafeThick',
                      false,
                      1
                    )
                  "
                  :disabled="!formData.layeredCuttingSetting.repeatedCut"
                />

                <span id="span_drupcw4q9f" class="mh8"
                  >&nbsp;{{ $t('cuttingDock.cuttingParams.areaLimit') }}
                </span>
                <a-input
                  suffix="m²"
                  style="width: 138px"
                  id="engraving_setting_minSafeArea_input"
                  v-model="formData.layeredCuttingSetting.minSafeArea"
                  @input="
                    inputCheck('layeredCuttingSetting', 'minSafeArea', false, 1)
                  "
                  :disabled="!formData.layeredCuttingSetting.repeatedCut"
                ></a-input>
                <span id="span_8xix9b3qic" class="ml8"
                  >&nbsp;{{ $t('cuttingDock.cuttingParams.splitPlank') }}</span
                >
              </div>
              <div class="secondCutting mt20">
                <span id="span_vkqu80ig5t" class="mr8">{{
                  $t('cuttingDock.cuttingParams.secondDeep')
                }}</span>
                <a-input
                  id="engraving_setting_secondCuttingDepth_input"
                  style="width: 138px"
                  v-model="formData.layeredCuttingSetting.secondCuttingDepth"
                  @input="
                    inputDepth('layeredCuttingSetting', 'secondCuttingDepth')
                  "
                  :disabled="!formData.layeredCuttingSetting.repeatedCut"
                  :maxLength="7"
                  suffix="mm"
                ></a-input>
              </div>
            </div>
          </div>
          <!-- 异形板件切两次 -->
          <div class="hierarchy-cut-twice base_title">
            <span id="span_8mpruwf1p6" class="base-title-label"
              >{{ $translateLang('异形板件切两次') }}：</span
            >
            <div class="flex flex-dir--top">
              <div class="flex flex-cross--center mb16">
                <a-switch
                  id="engraving_setting_special_shap_repeatedCut_switch"
                  v-model="formData.layeredCuttingSetting.curve_layered_cutting"
                  style="width: 42px"
                  @change="handleChangeSpecialShapRepeatedCut"
                ></a-switch>
                <span id="span_sqz4xgrk01" class="color-o-4 ml5">
                  {{ $translateLang('（启用后所有异形板件都会切两次）') }}
                </span>
              </div>
              <div
                class="hierarchy-cut-limit"
                v-show="
                  isShowSecondaryCatalog ||
                  formData.layeredCuttingSetting.curve_layered_cutting
                "
              >
                <div class="secondCutting">
                  <span id="span_a6mifrqils" class="mr8">{{
                    $t('cuttingDock.cuttingParams.secondDeep')
                  }}</span>
                  <a-input
                    id="engraving_setting_special_shap_secondCuttingDepth_input"
                    style="width: 138px"
                    v-model="
                      formData.layeredCuttingSetting.curve_layered_cutting_deep
                    "
                    @input="
                      inputDepth(
                        'layeredCuttingSetting',
                        'curve_layered_cutting_deep'
                      )
                    "
                    :disabled="
                      !formData.layeredCuttingSetting.curve_layered_cutting
                    "
                    :maxLength="7"
                    suffix="mm"
                  ></a-input>
                </div>
              </div>
            </div>
          </div>
          <div class="base_title">
            <span class="base-title-label"
              >{{ $translateLang('搭桥留点法')
              }}<i
                class="iconfont icon-wenhao ml5"
                :title="
                  $translateLang(
                    '可解决当板件内部存在大量挖空区域时，切割路径容易因支撑不足而导致板材抖动或跑板的情况'
                  )
                "
              ></i
              >：</span
            >
            <a-switch
              v-model="formData.movePlankSetting.bridgeRetention.enable"
              style="width: 42px"
            ></a-switch>
            <span class="color-o-4 ml5">{{
              $t('cuttingDock.cuttingParams.bridgeRetentionTip')
            }}</span>
          </div>
          <div
            class="base_title bridge-cutting-object"
            v-show="
              formData.movePlankSetting.bridgeRetention.enable ||
              isShowSecondaryCatalog
            "
          >
            <span class="base-title-label"
              >{{ $translateLang('生效对象') }}：</span
            >
            <div>
              <a-checkbox
                style="margin-top: -10px"
                v-model="
                  formData.movePlankSetting.bridgeRetention.punchAreaEnable
                "
                :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                >{{ $translateLang('打穿部分超过总面积')
                }}<a-input
                  style="width: 138px"
                  suffix="%"
                  class="mh10"
                  v-model="
                    formData.movePlankSetting.bridgeRetention.punchAreaPercent
                  "
                  @input="
                    verifyInputCheck({
                      value:
                        formData.movePlankSetting.bridgeRetention
                          .punchAreaPercent,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'punchAreaPercent'],
                      rule: '3',
                      isMinus: false,
                      min: 0,
                      isEmpty: false,
                      max: 100,
                      isThickFlag: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />{{ $translateLang('的板件') }}</a-checkbox
              >
              <p class="mv20">
                {{ $translateLang('连接桥尺寸')
                }}<a-input
                  style="width: 138px"
                  suffix="mm"
                  class="mh10"
                  v-model="
                    formData.movePlankSetting.bridgeRetention.punchBridgeSize
                  "
                  @input="
                    verifyInputCheck({
                      value:
                        formData.movePlankSetting.bridgeRetention
                          .punchBridgeSize,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'punchBridgeSize'],
                      rule: '5-2',
                      isMinus: false,
                      min: 0,
                      isEmpty: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />{{ $translateLang('加工速度')
                }}<a-input
                  style="width: 138px"
                  class="ml10"
                  v-model="formData.movePlankSetting.bridgeRetention.punchSpeed"
                  @input="
                    verifyInputCheck({
                      value:
                        formData.movePlankSetting.bridgeRetention.punchSpeed,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'punchSpeed'],
                      rule: '6-2',
                      isMinus: false,
                    })
                  "
                />
              </p>
              <a-checkbox
                v-model="formData.movePlankSetting.bridgeRetention.sizeEnable"
                :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                >{{ $translateLang('长或宽小于')
                }}<a-input
                  style="width: 138px"
                  suffix="mm"
                  class="mh10"
                  v-model="
                    formData.movePlankSetting.bridgeRetention.maxSideLength
                  "
                  @input="
                    verifyInputCheck({
                      value:
                        formData.movePlankSetting.bridgeRetention.maxSideLength,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'maxSideLength'],
                      rule: '5-2',
                      isMinus: false,
                      min: 0,
                      isEmpty: false,
                      max: 0,
                      isThickFlag: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />{{ $translateLang('厚度大于')
                }}<a-input
                  style="width: 138px"
                  suffix="mm"
                  class="mh10"
                  v-model="formData.movePlankSetting.bridgeRetention.minThick"
                  @input="
                    verifyInputCheck({
                      value: formData.movePlankSetting.bridgeRetention.minThick,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'minThick'],
                      rule: '5-2',
                      isMinus: false,
                      min: 0,
                      isEmpty: false,
                      max: 0,
                      isThickFlag: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />{{ $translateLang('且面积小于')
                }}<a-input
                  style="width: 138px"
                  suffix="m²"
                  class="mh10"
                  v-model="formData.movePlankSetting.bridgeRetention.maxArea"
                  @input="
                    verifyInputCheck({
                      value: formData.movePlankSetting.bridgeRetention.maxArea,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'maxArea'],
                      rule: '5-2',
                      isMinus: false,
                      min: 0,
                      isEmpty: false,
                      max: 0,
                      isThickFlag: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />{{ $translateLang('的板件') }}</a-checkbox
              >
              <p class="mt20">
                {{ $translateLang('连接桥尺寸')
                }}<a-input
                  style="width: 138px"
                  suffix="mm"
                  class="mh10"
                  v-model="
                    formData.movePlankSetting.bridgeRetention.sizeBridgeSize
                  "
                  @input="
                    verifyInputCheck({
                      value:
                        formData.movePlankSetting.bridgeRetention
                          .sizeBridgeSize,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'sizeBridgeSize'],
                      rule: '5-2',
                      isMinus: false,
                      min: 0,
                      isEmpty: false,
                      max: 0,
                      isThickFlag: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />{{ $translateLang('加工速度')
                }}<a-input
                  style="width: 138px"
                  class="ml10"
                  v-model="formData.movePlankSetting.bridgeRetention.sizeSpeed"
                  @input="
                    verifyInputCheck({
                      value:
                        formData.movePlankSetting.bridgeRetention.sizeSpeed,
                      formData: formData.movePlankSetting,
                      keys: ['bridgeRetention', 'sizeSpeed'],
                      rule: '6-2',
                      isMinus: false,
                    })
                  "
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                />
              </p>
            </div>
          </div>
          <div
            class="base_title bridge-cutting-generate"
            v-show="
              formData.movePlankSetting.bridgeRetention.enable ||
              isShowSecondaryCatalog
            "
          >
            <span class="base-title-label"
              >{{ $translateLang('生成方式') }}：</span
            >
            <div>
              <div style="margin-top: -6px">
                <a-button
                  class="mr10"
                  @click="handleAddBridge"
                  :disabled="
                    formData.movePlankSetting.bridgeRetention.bridgeCountRules
                      .length >= 10 ||
                    !formData.movePlankSetting.bridgeRetention.enable
                  "
                  :title="
                    formData.movePlankSetting.bridgeRetention.bridgeCountRules
                      .length >= 10
                      ? $translateLang('最多添加10条数据')
                      : ''
                  "
                  >{{ $translateLang('添加') }}</a-button
                >
                <a-button
                  @click="handleDelBridge"
                  :disabled="!formData.movePlankSetting.bridgeRetention.enable"
                  >{{ $translateLang('删除') }}</a-button
                >
              </div>
              <a-table
                class="bridge-cutting-table"
                bordered
                :pagination="false"
                :columns="bridgeCuttingColumns"
                :rowKey="(record, index) => index"
                :data-source="
                  formData.movePlankSetting.bridgeRetention.bridgeCountRules
                "
                :row-selection="bridgeCuttingRowSelection"
              >
                <template slot="plankLength" slot-scope="text, record, index">
                  <div
                    class="bridge-length-cell flex flex-main--center flex-cross--center"
                  >
                    <a-input
                      v-if="
                        bridgeEditingCell.index === index &&
                        bridgeEditingCell.field === 'minLength'
                      "
                      class="bridge-length-input"
                      v-model="record.minLength"
                      @input="
                        verifyInputCheck({
                          value: record.minLength,
                          formData: record,
                          keys: ['minLength'],
                          rule: '5-2',
                          isMinus: false,
                          min: 0,
                          isEmpty: false,
                        })
                      "
                      @blur="handleBridgeCellBlur"
                      @pressEnter="handleBridgeCellBlur"
                      :disabled="
                        !formData.movePlankSetting.bridgeRetention.enable
                      "
                    />
                    <span
                      v-else
                      class="bridge-length-text"
                      @click="handleBridgeCellEdit(index, 'minLength')"
                      >{{ record.minLength }}</span
                    >
                    <span class="mh4">&lt; L ≤</span>
                    <a-input
                      v-if="
                        bridgeEditingCell.index === index &&
                        bridgeEditingCell.field === 'maxLength'
                      "
                      class="bridge-length-input"
                      v-model="record.maxLength"
                      @input="
                        verifyInputCheck({
                          value: record.maxLength,
                          formData: record,
                          keys: ['maxLength'],
                          rule: '5-2',
                          isMinus: false,
                          min: 0,
                          isEmpty: false,
                        })
                      "
                      @blur="handleBridgeCellBlur"
                      @pressEnter="handleBridgeCellBlur"
                      :disabled="
                        !formData.movePlankSetting.bridgeRetention.enable
                      "
                    />
                    <span
                      v-else
                      class="bridge-length-text"
                      @click="handleBridgeCellEdit(index, 'maxLength')"
                      >{{ record.maxLength }}</span
                    >
                  </div>
                </template>
                <template slot="count" slot-scope="text, record, index">
                  <a-input
                    v-if="
                      bridgeEditingCell.index === index &&
                      bridgeEditingCell.field === 'count'
                    "
                    class="bridge-count-input"
                    v-model="record.count"
                    @input="
                      verifyInputCheck({
                        value: record.count,
                        formData: record,
                        keys: ['count'],
                        rule: '5',
                        isMinus: false,
                        min: 0,
                        isEmpty: false,
                      })
                    "
                    @blur="handleBridgeCellBlur"
                    @pressEnter="handleBridgeCellBlur"
                    :disabled="
                      !formData.movePlankSetting.bridgeRetention.enable
                    "
                  />
                  <span
                    v-else
                    class="bridge-length-text"
                    @click="handleBridgeCellEdit(index, 'count')"
                    >{{ record.count }}</span
                  >
                </template>
                <template slot="operation" slot-scope="text, record, index">
                  <span
                    class="bridge-del-btn"
                    :class="{
                      'bridge-del-btn--disabled':
                        !formData.movePlankSetting.bridgeRetention.enable,
                    }"
                    @click="handleDelBridge(index)"
                    >{{ $translateLang('删除') }}</span
                  >
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <div class="long-door-plank" id="long-door-plank">
          <div class="head-title flex flex-cross--center">
            <span id="span_xty0p4yfhv" class="mr8">{{
              $t('cuttingDock.cuttingParams.longCut')
            }}</span>
            <a-switch
              id="engraving_setting_longPlankCuttingEnable_switch"
              v-model="formData.longPlankCuttingSetting.longPlankCuttingEnable"
              style="margin-left: 166px"
            ></a-switch>
          </div>

          <div
            class="base_title"
            v-show="
              formData.longPlankCuttingSetting.longPlankCuttingEnable ||
              isShowSecondaryCatalog
            "
          >
            <div
              class="color-o-4 flex flex-dir--top mb20"
              style="margin-left: 246px"
            >
              <span id="span_7lqfwgm30j"
                >{{ $t('cuttingDock.cuttingParams.longPlankTip1') }}
              </span>
              <span id="p_bl3d3g90vj">
                {{ $t('cuttingDock.cuttingParams.longPlankTip2') }}
              </span>
              <span>
                {{ $t('cuttingDock.cuttingParams.longPlankTip3') }}
              </span>
            </div>
            <!-- 长板加工-指定对象/切割设置（旧版 UI，保留备查） -->
            <template v-if="false">
              <div class="long-door secondary-cutting">
                <span id="span_ra75gqdczs" class="base-title-label pt5"
                  >{{ $t('cuttingDock.cuttingParams.secondCutting') }}：</span
                >
                <div class="flex flex-dir--top">
                  <div id="div_pkna2oyxvw" style="width: 280px">
                    <a-checkbox-group
                      v-model="secondaryCuttingList"
                      @change="handleSelectCutting"
                      style="display: flex; flex-direction: column"
                      :disabled="
                        !formData.longPlankCuttingSetting.longPlankCuttingEnable
                      "
                    >
                      <a-checkbox
                        v-for="(option, index) in secondaryCuttingOptions"
                        :value="option.checkedValueKey"
                        :key="option.checkedValueKey"
                        style="
                          display: flex;
                          align-items: center;
                          margin: 0 0 8px 0;
                        "
                        :id="`engraving_setting_${index}_checkbox`"
                      >
                        <div class="flex flex-cross--center ml8">
                          <span
                            :id="`engraving_setting_${index}_checkbox_label`"
                            >{{ translateLang(option.label) }}</span
                          >
                          <a-input
                            suffix="mm"
                            style="width: 100px"
                            class="ml8 mr8"
                            v-model="
                              formData.longPlankCuttingSetting[
                                option.inputValueKey
                              ]
                            "
                            @input="
                              inputCheck(
                                'longPlankCuttingSetting',
                                option.inputValueKey,
                                false,
                                1,
                                false,
                                3000
                              )
                            "
                            :disabled="
                              !formData.longPlankCuttingSetting
                                .longPlankCuttingEnable
                            "
                            id="engraving_setting_generalPlankThick_input"
                          ></a-input>
                          {{ translateLang(option.text) }}
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- <a-input
                    suffix="mm"
                    style="width: 100px; margin-left: -20px"
                    v-model="formData.longPlankCuttingSetting.generalPlankThick"
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'generalPlankThick',
                        false,
                        1,
                        false,
                        3000
                      )
                    "
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                    id="engraving_setting_generalPlankThick_input"
                  ></a-input> -->
                    <!-- {{ $t('cuttingDock.cuttingParams.normalPlank') }} -->
                  </div>
                  <div class="mv20">
                    <a-checkbox
                      v-model="
                        formData.longPlankCuttingSetting
                          .specified_board_secondary_cutting
                      "
                      :disabled="
                        !formData.longPlankCuttingSetting.longPlankCuttingEnable
                      "
                      >{{ $translateLang('指定板名切割') }}
                      <span class="color-o-4 ml5"
                        >({{
                          $translateLang(
                            '开启后当板件名称中包含下方添加的板件名则生效二次切割'
                          )
                        }})</span
                      ></a-checkbox
                    >
                  </div>
                  <div
                    id="engraving_setting_add_plank_name_btn"
                    v-show="
                      formData.longPlankCuttingSetting.longPlankCuttingEnable &&
                      formData.longPlankCuttingSetting
                        .specified_board_secondary_cutting
                    "
                    class="mb8"
                  >
                    <span class="add-plank-name" @click="handleAddPlankName">{{
                      $translateLang('添加板件名')
                    }}</span>
                  </div>
                  <div class="plank-name-box">
                    <a-input
                      style="width: 150px"
                      class="mr10 mb15"
                      :placeholder="$translateLang('这里输入')"
                      :disabled="
                        !formData.longPlankCuttingSetting
                          .longPlankCuttingEnable ||
                        !formData.longPlankCuttingSetting
                          .specified_board_secondary_cutting
                      "
                      v-for="(item, index) in formData.longPlankCuttingSetting
                        .secondary_cutting_board_list"
                      :key="`engraving_setting_plank_name_${index}`"
                      :value="getPlankNameValue(index)"
                      @focus="handleFocusPlankName(index)"
                      @blur="handleBlurPlankName(index)"
                      @input="handleInputPlankName($event, index)"
                    >
                      <template #suffix>
                        <i
                          class="iconfont el-icon-delete"
                          v-if="index !== currentInputIndex"
                          @click="handleDelPlank(index)"
                        ></i>
                        <span
                          v-else
                          class="add-plank"
                          @mousedown.prevent="handleSavePlankName(item, index)"
                          >{{ $translateLang('保存') }}</span
                        >
                      </template>
                    </a-input>
                  </div>
                </div>
              </div>
              <div class="long-door flex-cross--center">
                <span id="span_97ixjv4vt8" class="base-title-label"
                  >{{
                    $t('cuttingDock.cuttingParams.cutTwiceCondition')
                  }}：</span
                >
                <span id="span_ihmd71pwjp">
                  {{ $t('cuttingDock.cuttingParams.longLimit') }}
                  <a-input
                    suffix="mm"
                    style="width: 138px"
                    class="mr8 ml8"
                    v-model="
                      formData.longPlankCuttingSetting.longPlankMinLength
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankMinLength',
                        false,
                        1,
                        false,
                        3000
                      )
                    "
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                    id="engraving_setting_longPlankMinLength_input"
                  ></a-input>
                  {{ $t('cuttingDock.cuttingParams.plankShortLimit') }}
                  <a-input
                    suffix="mm"
                    style="width: 138px"
                    class="ml8"
                    v-model="
                      formData.longPlankCuttingSetting.longPlankShortMinLength
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankShortMinLength',
                        false,
                        1,
                        false,
                        3000
                      )
                    "
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                  ></a-input>
                  {{ $translateLang('分两次切割') }}
                </span>
              </div>
              <div class="long-door">
                <span id="span_wql6pe4dno" class="base-title-label pt6"
                  >{{ $t('cuttingDock.cuttingParams.firstExpand') }}：</span
                >
                <span id="span_g39kii43h7">
                  {{ $t('cuttingDock.cuttingParams.longExpandTip') }}
                  <a-input
                    suffix="mm"
                    style="width: 138px"
                    class="ml8 mr8"
                    v-model="
                      formData.longPlankCuttingSetting.longPlankExpandedSize
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankExpandedSize',
                        false,
                        1,
                        false,
                        20
                      )
                    "
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                    id="engraving_setting_longPlankExpandedSize_input"
                  ></a-input>
                  {{ $t('cuttingDock.cuttingParams.shortExpand') }}
                  <a-input
                    suffix="mm"
                    style="width: 138px"
                    class="ml8"
                    v-model="
                      formData.longPlankCuttingSetting
                        .longPlankShortExpandedSize
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankShortExpandedSize',
                        false,
                        1,
                        false,
                        20
                      )
                    "
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                    id="engraving_setting_longPlankShortExpandedSize_input"
                  ></a-input>
                  <div id="div_8wgi2gwwae" class="color-o-4 mt4">
                    {{ $t('cuttingDock.cuttingParams.expandTip') }}
                  </div>
                </span>
              </div>
              <div class="long-door">
                <span id="span_326zt6kf2z" class="base-title-label"
                  >{{ $t('cuttingDock.cuttingParams.pumpOffWay') }}：</span
                >
                <span>
                  <a-radio-group
                    v-model="
                      formData.longPlankCuttingSetting.vacuumPumpPauseWay
                    "
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                  >
                    <a-radio
                      value="after_one_plank"
                      id="engraving_setting_vacuumPumpPauseWay_after_one_plank_radio"
                      >{{
                        $t('cuttingDock.cuttingParams.afterOnePlank')
                      }}</a-radio
                    >
                    <a-radio
                      value="after_all_plank"
                      id="engraving_setting_vacuumPumpPauseWay_after_all_plank_radio"
                      >{{
                        $t('cuttingDock.cuttingParams.afterAllPlank')
                      }}</a-radio
                    >
                  </a-radio-group>
                </span>
              </div>
              <!-- 异形板二次切割 -->
              <div class="long-door">
                <span id="span_b7ulj9j0d5" class="base-title-label"
                  >{{
                    $t('cuttingDock.cuttingParams.shapeSecondCutenable')
                  }}：</span
                >
                <span>
                  <a-switch
                    :disabled="
                      !formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                    v-model="
                      formData.longPlankCuttingSetting.curveSecondCutEnable
                    "
                    v-bp="'engraving:shapeSecondCut'"
                    id="engraving_setting_longPlankCuttingSetting_shapeSecondCutenable"
                  />
                </span>
              </div>
              <!--指定材质-->
              <m-accord-texture-cut
                ref="accordTextureCut"
                v-if="formData.longPlankCuttingSetting.longPlankCuttingEnable"
                :isPrePaiban="false"
                :desMaterialList="
                  formData.longPlankCuttingSetting.desMaterialList
                "
                :desMaterialSwitch="
                  formData.longPlankCuttingSetting.desMaterialSwitch
                "
              />
            </template>

            <div class="long-plank-filter-panel">
              <div class="hierarchy-cut-twice long-plank-section-row">
                <span class="long-plank-section-title">
                  {{ $t('cuttingDock.cuttingParams.designatedTarget') }}
                </span>
              </div>

              <div class="long-plank-filter-level hierarchy-cut-twice">
                <div class="flex flex-cross--center mb8">
                  <span class="base-title-label">
                    {{
                      $t('cuttingDock.cuttingParams.filterLevel1Label')
                    }}： </span
                  ><span>{{
                    $t('cuttingDock.cuttingParams.filterLevel1Category')
                  }}</span>
                </div>
                <div class="long-plank-filter-level__body flex flex-dir--top">
                  <a-checkbox-group
                    v-model="secondaryCuttingList"
                    @change="handleSelectCutting"
                    class="long-plank-filter-level__group"
                    :disabled="isLongPlankCuttingDisabled"
                  >
                    <a-checkbox
                      v-for="(option, index) in secondaryCuttingOptions"
                      :value="option.checkedValueKey"
                      :key="option.checkedValueKey"
                      class="long-plank-filter-level__item"
                      :id="`engraving_setting_${index}_checkbox`"
                      :disabled="
                        !formData.longPlankCuttingSetting.longPlankCuttingEnable
                      "
                    >
                      <div class="flex flex-cross--center">
                        <span :id="`engraving_setting_${index}_checkbox_label`">
                          {{ translateLang(option.label) }}
                        </span>
                        <a-input
                          suffix="mm"
                          style="width: 100px"
                          class="ml8 mr8"
                          v-model="
                            formData.longPlankCuttingSetting[
                              option.inputValueKey
                            ]
                          "
                          @input="
                            inputCheck(
                              'longPlankCuttingSetting',
                              option.inputValueKey,
                              false,
                              1,
                              false,
                              3000
                            )
                          "
                          :disabled="isLongPlankCuttingDisabled"
                          :id="`engraving_setting_${option.inputValueKey}_input`"
                        />
                        {{ translateLang(option.text) }}
                      </div>
                    </a-checkbox>
                  </a-checkbox-group>
                  <div class="long-plank-specified-board">
                    <a-checkbox
                      v-model="
                        formData.longPlankCuttingSetting
                          .specified_board_secondary_cutting
                      "
                      class="long-plank-filter-level__item"
                      :disabled="isLongPlankCuttingDisabled"
                    >
                      <span>{{
                        $t('cuttingDock.cuttingParams.specifiedBoard')
                      }}</span>
                    </a-checkbox>
                    <a-checkbox
                      v-model="
                        formData.longPlankCuttingSetting.force_board_name
                      "
                      class="long-plank-filter-level__item ml16"
                      :disabled="
                        isLongPlankCuttingDisabled ||
                        !formData.longPlankCuttingSetting
                          .specified_board_secondary_cutting
                      "
                    >
                      <span class="color-o-6">
                        ({{
                          $t(
                            'cuttingDock.cuttingParams.specifiedBoardForceEnable'
                          )
                        }})
                      </span>
                    </a-checkbox>
                  </div>
                  <div
                    id="engraving_setting_add_plank_name_btn"
                    v-show="
                      formData.longPlankCuttingSetting
                        .specified_board_secondary_cutting &&
                      formData.longPlankCuttingSetting.longPlankCuttingEnable
                    "
                    class="mt8 mb8"
                  >
                    <span class="add-plank-name" @click="handleAddPlankName">
                      {{ $t('cuttingDock.cuttingParams.addPlankName') }}
                    </span>
                  </div>
                  <div class="plank-name-box">
                    <a-input
                      style="width: 150px"
                      class="mr10 mb15"
                      :placeholder="$translateLang('这里输入')"
                      :disabled="
                        isLongPlankCuttingDisabled ||
                        !formData.longPlankCuttingSetting
                          .specified_board_secondary_cutting
                      "
                      v-for="(item, index) in formData.longPlankCuttingSetting
                        .secondary_cutting_board_list"
                      :key="`engraving_setting_plank_name_${index}`"
                      :value="getPlankNameValue(index)"
                      @focus="handleFocusPlankName(index)"
                      @blur="handleBlurPlankName(index)"
                      @input="handleInputPlankName($event, index)"
                    >
                      <template #suffix>
                        <i
                          class="iconfont el-icon-delete"
                          v-if="index !== currentInputIndex"
                          @click="handleDelPlank(index)"
                        ></i>
                        <span
                          v-else
                          class="add-plank"
                          @mousedown.prevent="handleSavePlankName(item, index)"
                        >
                          {{ $translateLang('保存') }}
                        </span>
                      </template>
                    </a-input>
                  </div>
                </div>
              </div>

              <div
                class="long-plank-filter-level hierarchy-cut-twice"
                v-show="
                  secondaryCuttingList.length ||
                  formData.longPlankCuttingSetting
                    .specified_board_secondary_cutting
                "
              >
                <div class="flex flex-cross--center mb8">
                  <span class="base-title-label">
                    {{
                      $t('cuttingDock.cuttingParams.filterLevel2Label')
                    }}： </span
                  ><span>{{
                    $t('cuttingDock.cuttingParams.filterLevel2Category')
                  }}</span>
                </div>
                <div
                  id="span_ihmd71pwjp_new"
                  class="long-plank-filter-level__body long-plank-inline-inputs flex flex-cross--center flex-wrap"
                >
                  {{ $t('cuttingDock.cuttingParams.longLimit') }}
                  <a-input
                    suffix="mm"
                    style="width: 100px"
                    class="ml8 mr8"
                    v-model="
                      formData.longPlankCuttingSetting.longPlankMinLength
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankMinLength',
                        false,
                        1,
                        false,
                        3000
                      )
                    "
                    :disabled="isLongPlankCuttingDisabled"
                    id="engraving_setting_longPlankMinLength_input"
                  />
                  {{ $t('cuttingDock.cuttingParams.plankShortLimit') }}
                  <a-input
                    suffix="mm"
                    style="width: 100px"
                    class="ml8 mr8"
                    v-model="
                      formData.longPlankCuttingSetting.longPlankShortMinLength
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankShortMinLength',
                        false,
                        1,
                        false,
                        3000
                      )
                    "
                    :disabled="isLongPlankCuttingDisabled"
                  />
                  {{ $t('cuttingDock.cuttingParams.plankSizeLimitSuffix') }}
                </div>
              </div>

              <div
                class="long-plank-filter-level hierarchy-cut-twice long-plank-filter-level--last"
                v-show="
                  secondaryCuttingList.length ||
                  formData.longPlankCuttingSetting
                    .specified_board_secondary_cutting
                "
              >
                <div class="flex flex-cross--center mb8">
                  <span class="base-title-label">
                    {{ $t('cuttingDock.cuttingParams.filterLevel3Label') }}：
                  </span>
                  <span>{{
                    $t('cuttingDock.cuttingParams.filterLevel3Category')
                  }}</span>
                </div>
                <div class="long-plank-filter-level__body flex flex-dir--top">
                  <a-checkbox
                    v-model="
                      formData.longPlankCuttingSetting.curveSecondCutEnable
                    "
                    :disabled="isLongPlankCuttingDisabled"
                    v-bp="'engraving:shapeSecondCut'"
                    id="engraving_setting_longPlankCuttingSetting_shapeSecondCutenable"
                    class="long-plank-filter-level__item"
                  >
                    <span>{{ $translateLang('异形板') }}</span>
                  </a-checkbox>
                  <div class="mt8">
                    <a-checkbox
                      v-model="
                        formData.longPlankCuttingSetting.desMaterialSwitch
                      "
                      :disabled="isLongPlankCuttingDisabled"
                      id="engraving_setting_des_material_switch_checkbox"
                      class="long-plank-filter-level__item"
                    >
                      <span>{{
                        $t('cuttingDock.cuttingParams.specifyTheMaterial')
                      }}</span>
                    </a-checkbox>
                    <!-- <p class="color-o-4 mt8 mb0 long-plank-filter-level__tip">
                      {{
                        $t('cuttingDock.cuttingParams.curveMaterialFilterTip')
                      }}
                    </p> -->
                    <m-accord-texture-cut
                      ref="accordTextureCut"
                      v-if="
                        formData.longPlankCuttingSetting.desMaterialSwitch &&
                        formData.longPlankCuttingSetting.longPlankCuttingEnable
                      "
                      hide-header
                      class="long-plank-material-cut mt12"
                      :desMaterialList="
                        formData.longPlankCuttingSetting.desMaterialList
                      "
                      :desMaterialSwitch="
                        formData.longPlankCuttingSetting.desMaterialSwitch
                      "
                    />
                  </div>
                </div>
              </div>

              <div
                class="hierarchy-cut-twice long-plank-section-row long-plank-section-row--cutting"
              >
                <span class="long-plank-section-title">
                  {{ $t('cuttingDock.cuttingParams.cuttingSettings') }}
                </span>
              </div>
              <div class="long-plank-cutting-row hierarchy-cut-twice">
                <span id="span_wql6pe4dno" class="base-title-label pt6">
                  {{ $t('cuttingDock.cuttingParams.firstExpand') }}：
                </span>
                <div
                  id="span_g39kii43h7"
                  class="long-plank-filter-level__body pl0"
                >
                  {{ $t('cuttingDock.cuttingParams.longExpandTip') }}
                  <a-input
                    suffix="mm"
                    style="width: 100px"
                    class="ml8 mr8"
                    v-model="
                      formData.longPlankCuttingSetting.longPlankExpandedSize
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankExpandedSize',
                        false,
                        1,
                        false,
                        20
                      )
                    "
                    :disabled="isLongPlankCuttingDisabled"
                    id="engraving_setting_longPlankExpandedSize_input"
                  />
                  {{ $t('cuttingDock.cuttingParams.shortExpand') }}
                  <a-input
                    suffix="mm"
                    style="width: 100px"
                    class="ml8"
                    v-model="
                      formData.longPlankCuttingSetting
                        .longPlankShortExpandedSize
                    "
                    @input="
                      inputCheck(
                        'longPlankCuttingSetting',
                        'longPlankShortExpandedSize',
                        false,
                        1,
                        false,
                        20
                      )
                    "
                    :disabled="isLongPlankCuttingDisabled"
                    id="engraving_setting_longPlankShortExpandedSize_input"
                  />
                  <div id="div_8wgi2gwwae" class="color-o-4 mt4">
                    {{ $t('cuttingDock.cuttingParams.expandTip') }}
                  </div>
                </div>
              </div>
              <div class="long-plank-cutting-row hierarchy-cut-twice">
                <span id="span_326zt6kf2z" class="base-title-label">
                  {{ $t('cuttingDock.cuttingParams.pumpOffWay') }}：
                </span>
                <div class="long-plank-filter-level__body pl0">
                  <a-radio-group
                    v-model="
                      formData.longPlankCuttingSetting.vacuumPumpPauseWay
                    "
                    :disabled="isLongPlankCuttingDisabled"
                  >
                    <a-radio
                      value="after_one_plank"
                      id="engraving_setting_vacuumPumpPauseWay_after_one_plank_radio"
                    >
                      {{ $t('cuttingDock.cuttingParams.afterOnePlank') }}
                    </a-radio>
                    <a-radio
                      value="after_all_plank"
                      id="engraving_setting_vacuumPumpPauseWay_after_all_plank_radio"
                    >
                      {{ $t('cuttingDock.cuttingParams.afterAllPlank') }}
                    </a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="decimals" id="decimals">
          <span id="span_lckjqbtxiw" class="head-title">{{
            $t('cuttingDock.cuttingParams.numberFixed')
          }}</span>
          <div class="decimals-num ml8">
            <span id="span_a99l83wkli" class="base-title-label mt5"
              >{{ $t('cuttingDock.cuttingParams.numberFixed') }}：</span
            >
            <div class="flex flex-dir--top">
              <a-input
                id="engraving_setting_decimal_input"
                v-model="formData.decimalSetting.decimal"
                @input="inputCheck('decimalSetting', 'decimal', true)"
              ></a-input>
              <span id="span_m4seuco989" class="color-o-4 mt4">
                {{ $t('cuttingDock.cuttingParams.fixedTip') }}
              </span>
            </div>
          </div>
        </div>
        <div class="optimize-speed" id="buffer-code">
          <div id="div_77k1mqieds" class="head-title">
            {{ $t('cuttingDock.cuttingParams.bufferCode') }}
          </div>
          <div class="content">
            <div class="base_title">
              <span id="span_acdw6f4jvh" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.cuttingSlow') }}：</span
              >
              <a-switch
                v-model="formData.plankSurfaceBufferCommand"
                id="`engraving_setting_plankSurfaceBufferCommand_checkbox"
              ></a-switch>
            </div>
            <div class="base_title">
              <span id="span_sqp6lfe1rk" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.holeSlow') }}：</span
              >
              <a-switch
                v-model="formData.hole_surface_buffer"
                id="`engraving_setting_hole_surface_buffer_checkbox"
              ></a-switch>
            </div>
            <div class="base_title">
              <span id="span_a3jqy6v689" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.slotSlow') }}：</span
              >
              <a-switch
                v-model="formData.hole_slot_surface_buffer"
                id="`engraving_setting_hole_slot_surface_buffer_checkbox"
              ></a-switch>
            </div>
            <div class="base_title">
              <span id="span_moq0whx1q9" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.slowCode') }}：</span
              >
              <a-radio-group v-model="formData.buffer_way">
                <a-radio value="G00" id="engraving_buffer_way_G00_radio">
                  G00{{ $t('cuttingDock.cuttingParams.code') }}
                </a-radio>
                <a-radio value="G01" id="engraving_buffer_way_G01_radio">
                  G01{{ $t('cuttingDock.cuttingParams.code') }}
                </a-radio>
              </a-radio-group>
            </div>
            <div class="base_title">
              <span id="span_moq0whx1q9" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.bufferOffset') }}：</span
              >
              <div class="flex flex-dir--column flex-cross--top">
                <a-input
                  id="engraving_buffer_height_input"
                  class="mr8"
                  ref="bufferHeightRef"
                  v-model="formData.buffer_offset"
                  @input="
                    inputCheck(
                      'buffer_offset',
                      undefined,
                      false,
                      1,
                      false,
                      99999.99
                    )
                  "
                  @blur="handleBufferHeightBlur"
                  suffix="mm"
                  style="width: 138px"
                >
                </a-input>
                <div class="flex flex-cross--center ml20">
                  <img src="@/assets/bufferHeightOffset.png" alt="缓冲高度" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="interval-setting" id="interval-setting">
          <span id="span_refdleohnb" class="head-title">{{
            $t('cuttingDock.cuttingParams.layoutGap')
          }}</span>
          <div class="interval-setting-content ml8">
            <span id="span_ct84dq00d3" class="base-title-label pt5"
              >{{ $t('cuttingDock.cuttingParams.layoutGap') }}：</span
            >
            <div class="flex flex-dir--top">
              <a-input
                id="engraving_setting_boardGap_input"
                v-model="formData.boardGapsSetting.boardGap"
                @input="inputDepth('boardGapsSetting', 'boardGap')"
              ></a-input>
              <span id="span_0tei6yyh1l" class="inline-block color-o-4 mt4">{{
                $t('cuttingDock.cuttingParams.layoutGapTip')
              }}</span>
            </div>
          </div>
        </div>

        <div class="waste_auto_cutting" id="waste_auto_cutting">
          <div class="head-title flex flex-cross--center">
            <span id="span_1enx7z7n8z">{{
              $t('cuttingDock.cuttingParams.wasteCutting')
            }}</span>
            <a-switch
              id="engraving_waste_setting_checkbox"
              v-model="formData.waste_setting.waste_cutting"
              style="margin-left: 130px"
            ></a-switch>
          </div>
          <div
            v-if="
              formData.waste_setting.waste_cutting || isShowSecondaryCatalog
            "
          >
            <div class="base_title">
              <span id="span_bmj8ockvnr" class="base-title-label">{{
                $t('cuttingDock.cuttingParams.cuttingOrder')
              }}</span>
              <a-radio-group
                v-model="formData.waste_setting.waste_order"
                name="radioGroup"
                :disabled="!formData.waste_setting.waste_cutting"
              >
                <a-radio
                  value="plank_first"
                  id="engraving_waste_setting_plank_first_radio"
                >
                  {{ $t('cuttingDock.cuttingParams.plankFirst') }}
                </a-radio>
                <a-radio
                  value="waste_first"
                  id="engraving_waste_setting_waste_first_radio"
                >
                  {{ $t('cuttingDock.cuttingParams.wasteFirst') }}
                </a-radio>
                <span
                  id="span_qiqw6adkcf"
                  style="margin-left: -20px"
                  class="color-o-4"
                  >({{
                    $t('cuttingDock.cuttingParams.cuttingOrderTip')
                  }}!)</span
                >
              </a-radio-group>
            </div>
            <!-- 裁切方式 -->
            <div class="base_title flex">
              <span id="span_bmj8ockdoaq" class="base-title-label"
                >{{ $translateLang('裁剪方式') }}：</span
              >
              <a-checkbox
                v-model="formData.waste_setting.waste_horizontal_direction"
                v-bp="`engraving:waste_horizontal_direction`"
                id="engraving_waste_setting_waste_horizontal_direction_checkbox"
              >
                {{ $translateLang('横向裁切') }}
              </a-checkbox>
              <a-checkbox
                v-model="formData.waste_setting.waste_vertical_direction"
                v-bp="`engraving:waste_vertical_direction`"
                id="engraving_waste_setting_waste_vertical_direction_checkbox"
              >
                {{ $translateLang('竖向裁切') }}
              </a-checkbox>
            </div>
            <div class="base_title flex">
              <span id="span_djipnh0q9k" class="base-title-label mt5"
                >{{ $t('cuttingDock.cuttingParams.cuttingLimit') }}：</span
              >
              <div>
                <div>
                  <a-input
                    id="engraving_waste_setting_input"
                    class="mr8"
                    ref="wasteSizeRef"
                    @input="handleWasterSize('waste_setting', 'waste_size')"
                    @blur="handleWasterSizeBlur"
                    v-model="formData.waste_setting.waste_size"
                    suffix="mm"
                    style="width: 138px"
                    :disabled="!formData.waste_setting.waste_cutting"
                  >
                  </a-input>
                  <span id="span_gpkve29kus">{{
                    $t('cuttingDock.cuttingParams.waste')
                  }}</span>
                </div>
                <div id="div_kczi9zgrq4" class="mt4 color-o-4">
                  {{ $t('cuttingDock.cuttingParams.wasteSizeLimit') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex" id="ZK_datum_point_customize">
          <div>
            <div class="head-title flex flex-cross--center">
              <span id="span_aep2dlp3y4">{{
                $t('cuttingDock.cuttingParams.zkPointCustomize')
              }}</span>
              <span
                id="span_c1uggrpfya"
                class="fs16 color-o-4"
                style="font-weight: normal"
                >（{{ $t('cuttingDock.cuttingParams.zkPointCustomizeTip1') }}）
              </span>
            </div>
            <div class="base_title mt11 flex">
              <span id="span_dvfdfsvmho" class="base-title-label"
                >{{ $t('cuttingDock.cuttingParams.isCustom') }}：</span
              >
              <div>
                <a-switch
                  id="engraving_setting_ZKDatumPoint_switch"
                  v-model="formData.ZK_setting.ZK_datum_point_customize"
                ></a-switch>
                <!-- css权重不够，使用v-show隐藏不生效 -->
                <template
                  v-if="
                    isShowSecondaryCatalog ||
                    formData.ZK_setting.ZK_datum_point_customize
                  "
                >
                  <div class="flex">
                    <div>
                      <div
                        class="flex flex-cross--center"
                        style="margin-top: 25px; margin-bottom: 24px"
                      >
                        <span id="span_5tb9koqcpa" class="mr8"
                          >{{
                            $t('cuttingDock.cuttingParams.zkRotatePoint')
                          }}（A0）</span
                        >
                        <a-select
                          style="width: 138px"
                          v-model="formData.ZK_setting.rotate_base_point"
                          id="engraving_setting_basePoint_select"
                          showArrow
                          :disabled="
                            !formData.ZK_setting.ZK_datum_point_customize
                          "
                        >
                          <a-select-option
                            v-for="(item, index) in basePointOptions"
                            :key="item.value"
                            :value="item.value"
                            :id="`engraving_setting_basePoint_select_option_${index}`"
                            :title="translateLang(item.label)"
                            class="all-labeling ellipsis"
                            >{{ $t(item.label) }}
                          </a-select-option>
                        </a-select>
                      </div>
                      <div class="flex flex-cross--center">
                        <span id="span_ww089iur1x" class="mr12">{{
                          $t('cuttingDock.cuttingParams.zkRotateDir')
                        }}</span>
                        <a-select
                          style="width: 138px"
                          v-model="formData.ZK_setting.rotate_angle_direction"
                          id="engraving_setting_angleDirection_select"
                          showArrow
                          :disabled="
                            !formData.ZK_setting.ZK_datum_point_customize
                          "
                        >
                          <a-select-option
                            v-for="(item, index) in angleDirectionOptions"
                            :key="item.value"
                            :value="item.value"
                            :id="`engraving_setting_angleDirection_select_option_${index}`"
                            :title="translateLang(item.label)"
                            class="all-labeling ellipsis"
                            >{{ $t(item.label) }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                    <div
                      class="zk-customize relative"
                      v-show="
                        isShowSecondaryCatalog ||
                        formData.ZK_setting.ZK_datum_point_customize
                      "
                    >
                      <span
                        :class="[
                          'absolute',
                          item.value == 'top'
                            ? 'img-top'
                            : item.value == 'left'
                            ? 'img-left'
                            : item.value == 'right'
                            ? 'img-right'
                            : 'img-bottom',
                          item.value == formData.ZK_setting.rotate_base_point
                            ? 'customize-style'
                            : '',
                        ]"
                        class="ellipsis fs10"
                        v-for="item in basePointList"
                        :key="item.value"
                        :title="translateLang(item.label)"
                        >{{ $t(item.label) }}</span
                      >
                      <div class="inline-block">
                        <img
                          v-if="
                            formData.ZK_setting.rotate_angle_direction ==
                            'clockwise'
                          "
                          :src="img.clockwise"
                        />
                        <img v-else :src="img.counterclockwise" />
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import clockwise from '@/assets/image/clockwise.png'
import counterclockwise from '@/assets/image/counterclockwise.png'
import insideSlot from '@/assets/image/insideSlot.png'
import outsideSlot from '@/assets/image/outsideSlot.png'
import AnchorNav from '@/components/anchorNav/index.vue'
import inputNumber from '@/components/common/input-number'
import MAccordTextureCut from '@/components/engraving/m-accord-texture-cut.vue'
import MTrimSetting from '@/components/engraving/m-trim-setting.vue'
import SpecialHoleAndSlotTable from '@/components/engraving/specialHoleAndSlotTable.vue'
import inputNumberSuffix from '@/components/g-input-number-suffix.vue'
import newContent from '@/components/newContent.vue'
import { cuttingParamsNavs } from '@/util/anchorNavData.ts'
import { matchHighlightBoardName, translate } from '@/util/commonFun'
import { addIdForItems, buryPointApi, genUniId } from '@/util/commonFuncs'
import { verifyInputNumber } from '@/util/commonFuncs'
import { webId } from '@/util/configure'
import {
  regReplaceCuttingParamsInputCheck,
  regReplaceCuttingParamsInputDepth,
} from '@/util/regReplace'
import { translate as transLang } from '@/util/translate'
import mMachinePos from '@/views/preLayoutSetting/components/m-machine-pos.vue'
import mSettingContent from '@/views/preLayoutSetting/components/m-setting-content.vue'
import { mapGetters } from 'vuex'

const lavePoingImgObj = {
  左上角: require('../../assets/fiveSixSet/laveLT.png'),
  右上角: require('../../assets/fiveSixSet/laveRT.png'),
  左下角: require('../../assets/fiveSixSet/laveLB.png'),
  右下角: require('../../assets/fiveSixSet/laveRB.png'),
}

// 翻译映射
const languageMap = new Map([
  [
    '单独设置小板尺寸范围加工速度',
    'cuttingDock.cuttingParams.singleSetPlankSizeSpeed',
  ],
  [
    '（1.当满足下方设置尺寸的小板会按照设置的加工速度进行加工 2.当小板同时满足多条规则时生效速度最小规则 3.该功能不对锯片切割生效）',
    'cuttingDock.cuttingParams.singleSetPlankSizeSpeedTip',
  ],
  ['添加规则', 'cuttingDock.cuttingParams.addSpeedRules'],
  ['规则', 'cuttingDock.cuttingParams.speedRules'],
  ['短边尺寸', 'cuttingDock.cuttingParams.shortSideSize'],
  ['小于等于', 'cuttingDock.cuttingParams.lessThanEqual'],
  ['且', 'cuttingDock.cuttingParams.and'],
  ['长边尺寸', 'cuttingDock.cuttingParams.longSideSize'],
  ['加工速度', 'cuttingDock.cuttingParams.processingSpeed'],
])
export default {
  props: {
    obj: {
      type: [Array, Object],
      default: () => {},
    },
    isShowSecondaryCatalog: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onHighGlossReverseChange'],
  components: {
    MAccordTextureCut,
    inputNumber,
    AnchorNav,
    inputNumberSuffix,
    MTrimSetting,
    SpecialHoleAndSlotTable,
    mSettingContent,
    mMachinePos,
    newContent,
  },
  data() {
    return {
      propertyName: {
        TRIM_SIDE: 'trimSide',
        TRIM_L_SINGLE: 'trimLSingle',
        TRIM_L_MOMENT: 'trimLMoment',
        SECOND_TRIM_VALUE: 'secondTrimValue',
        NEW_TRIM: 'new_trim',
        SINGLE_PANEL_TRIM_DIRECTION: 'single_panel_trim_direction',
        IS_FIRST_TRIM_SINGLE_PANEL: 'is_first_trim_single_panel',
        IS_DOUBLE_PANEL_FOUR_TRIM: 'is_double_panel_four_trim', // 双面板修边 默认修两边
        DOUBLE_PANEL_TRIM_SHORT: 'double_panel_trim_short', // 双面板只修短边 默认关闭
        IS_SINGLE_PANEL_FOUR_TRIM: 'is_single_panel_four_trim', // 单面板修边
        // 修边补偿
        TRIM_COMPENSATION: 'trim_compensation',
        // 不生成路径设置
        IS_ZERO_NO_ROUTE: 'is_zero_no_route',
      },
      navs: cuttingParamsNavs,
      startPoint: ['左上角', '右上角', '左下角', '右下角'], // 记录工位起始点可选项
      startPointMap: [
        'cuttingDock.cuttingParams.topLeftD',
        'cuttingDock.cuttingParams.topRightD',
        'cuttingDock.cuttingParams.bottomLeftD',
        'cuttingDock.cuttingParams.bottomRightD',
      ], // 记录工位起始点可选项
      paringPoint: [
        {
          label: this.$t('cuttingDock.cuttingParams.topLeft'),
          value: 'topLeft',
        },
        {
          label: this.$t('cuttingDock.cuttingParams.bottomLeft'),
          value: 'bottomLeft',
        },
        {
          label: this.$t('cuttingDock.cuttingParams.topRight'),
          value: 'topRight',
        },
        {
          label: this.$t('cuttingDock.cuttingParams.bottomRight'),
          value: 'bottomRight',
        },
      ], // 记录修边方向可选项
      lavePoints: [
        {
          label: '左上角',
          value: 'topLeft',
        },
        {
          label: '左下角',
          value: 'bottomLeft',
        },
        {
          label: '右上角',
          value: 'topRight',
        },
        {
          label: '右下角',
          value: 'bottomRight',
        },
      ], // 记录余料摆放位置可选项
      basePointOptions: [
        { label: 'cuttingDock.cuttingParams.plankBack', value: 'top' },
        { label: 'cuttingDock.cuttingParams.plankLeft', value: 'left' },
        { label: 'cuttingDock.cuttingParams.plankRight', value: 'right' },
        { label: 'cuttingDock.cuttingParams.plankFront', value: 'bottom' },
      ],
      basePointList: [
        { label: 'cuttingDock.cuttingParams.backSide', value: 'top' },
        { label: 'cuttingDock.cuttingParams.leftSide', value: 'left' },
        { label: 'cuttingDock.cuttingParams.rightSide', value: 'right' },
        { label: 'cuttingDock.cuttingParams.frontSide', value: 'bottom' },
      ],
      angleDirectionOptions: [
        {
          label: 'cuttingDock.cuttingParams.nDirection',
          value: 'counter_clockwise',
        },
        { label: 'cuttingDock.cuttingParams.sDirection', value: 'clockwise' },
      ],
      activePoint: '左下角', // 记录选中的工位起始点
      plankListColumn: [
        // 板材材质
        {
          label: 'common.plankMatCode',
          prop: 'matCode',
        },
        // 高光属性
        {
          label: 'common.plankHighGloss',
          prop: 'highlight',
        },
        { label: 'common.plankThick', prop: 'pThick', unit: '(mm)' },
        {
          label: 'cuttingDock.cuttingParams.firstTime',
          prop: 'firstCut',
        },
        {
          label: 'cuttingDock.cuttingParams.secondTime',
          prop: 'secondCut',
        },
        {
          label: 'cuttingDock.cuttingParams.thirdTime',
          prop: 'thirdCut',
        },
      ], // 记录表格列属性
      formData: {
        // 孔槽集中面
        holeFaceSetting: {
          apertureSlotConcentrated: 'front',
          holeConcentrated: 'front',
          throughHoleSlotSameSide: false,
          percentage_of_back_hole_slot: 50,
          prorate_holes_slots_of_both_side: false,
          hs_on_front_aft_shunt: false, // 孔槽分流中设置的特殊孔槽优先排在大板正面功能
          cal_turn_num_aft_shunt: false, // 在孔槽分流后计算翻版次数
          custom_special_hole_slot_side: {
            is_open: false,
            special_hole_slot_side: [],
          },
        },
        //靠边板槽放置
        edgePlankSlotDirection: {
          sideBoardPlacing: 'default',
        },

        // 共边切割和共边加速
        coedgeCuttingSetting: {
          coedgeAccelerate: false, // 是否选中共边加速
          coedgeCutting: false, // 是否选中共边切割
          coedgeSpeed: '', // 高速擦铣速度
          coedgeThick: '', // 共边切割厚度条件
        },
        // 台面设置
        countertopSetting: {
          startPosition: '左下角', // 工位起始点
          xyReverse: false, // XY轴互换
          auto_adaptation_xy_reverse: false, // 自动XY轴互换适配
          doubleStationReverse: false, // 是否选中双工位起始点切换
          planeOffset: false, // 是否选中机台平面偏移
          planeXOffset: '', // 机台平面偏移X轴
          planeYOffset: '', // 机台平面偏移Y轴
          planeZOffset: '', // 机台平面偏移Z轴
          X_reference_swap: false, //X轴坐标基准对调
          x_reverse_reference_swap: false, //大板反面X轴坐标基准对调
          y_reverse_reference_swap: false, //大板反面Y轴坐标基准对调
          doubleDifferentSize: false, //双工位台面不同尺寸
          counter_limit_able: false, //工位台面宽度限制
          counter_width: 1300, //工位台面宽度
          stationOneMax: 2440, //工位一最大尺寸
          stationTwoMax: 2740, //工位二最大尺寸
          smallStationFirst: false, //大工位只加工小工位无法加工的大板
        },
        // 切割打孔方式
        cuttingPunchingSetting: {
          arcCuttingCode: false, // 圆弧切割用I, J表示
          cutDirection: this.$t('cuttingDock.cuttingParams.nDirection'), // 小板切割方向
          clock_dir_switch: false, //自定义铣孔铣槽/内部异形切割方向
          cut_internal_curve_dir: '顺时针', //内部异形切割方向
          mill_hole_slot_dir: '顺时针', //铣孔铣槽方向
          cutZ: 0.1, // 记录切透量Z深度(D)
          cuttingCurvedInterpolationCommand: false, // 记录是否选中圆弧插补指令切割弧形板
          idleZ: 38, // 记录空闲时Z高度(H)
          throughTowSideToCut: false, // 通孔打孔方式
          zReference: 'counter_top', // 对刀基准面
          knifeBasedOnPlank: false, // 相对大板表面高度
          noG17G18G19: false, //不生成G19面指令
          arcInstruction: '', // 圆弧前缀加工指令
          millingSlotOverlapRate: 0, //铣槽重叠率
          autoClearFilletSlot: false, //铣槽时未拉穿的槽自动清理圆角
          mill_slots_way: 'out_to_inner',
          through_slot_two_side_cut: false, // 通槽打穿方式
          z_shape_processed_through_slot: false, // 通槽上下Z字形铣槽
          mill_z_slot_overlap_rate: 50, //Z字形铣槽切割重叠率
          non_through_slot_two_side_cut: {
            // 是否设置不生效翻面两次打穿孔槽
            is_open: false,
            // exclude_through_two_side_to_cut: [],
            special_hole_slot_side: [],
          },
          prevent_breakage_setting: {
            enable: false,
            rules: [
              {
                edge_distance: [],
                length: [],
                deep: [],
                cut_deep: '',
                [webId]: genUniId(),
              },
            ],
          },
        },

        // 长板加工
        longPlankCuttingSetting: {
          longPlankCuttingEnable: false,
          longPlankMinLength: 1500,
          longPlankExpandedSize: 2,
          longPlankShortMinLength: 200,
          longPlankShortExpandedSize: 2,
          // 异形二次切割开关
          curveSecondCutEnable: true,
          // 指定材质开关
          desMaterialSwitch: false,
          // 指定材质列表
          desMaterialList: [],
          // 指定板件名称二次切割开关
          specified_board_secondary_cutting: false,
          force_board_name: false,
          secondary_cutting_board_list: [],
          cutSingleDoor: false,
          cutGeneralPlank: false,
          single_door_thick: 0,
          generalPlankThick: 0,
          vacuumPumpPauseWay: 'after_all_plank',
        },
        // 小数保留位数
        decimalSetting: {
          decimal: 2, // 记录小数保留位数
        },
        // 下刀板件表面缓冲指令
        plankSurfaceBufferCommand: true,
        hole_surface_buffer: true,
        hole_slot_surface_buffer: true,
        buffer_way: 'G00',
        buffer_offset: 0,
        //排版间隙设置
        boardGapsSetting: {
          boardGap: 0.1,
        },
        // 分层切割
        layeredCuttingSetting: {
          minSafeArea: '0.2', // 分层切割面积条件
          minSafeLength: '300', // 分层切割长宽条件
          minSafeThick: 0, // 分层切割厚度条件
          secondCuttingDepth: '2', //小板第二次切割深度
          repeatedCut: true, // 是否选中小板切割两次
          rect_plank_cutting_method: '4_sides_layer', //矩形板切割方式
          repeatedSlot: true, // 是否选中槽切割两次
          layered_slot_cutting: false, //拉槽铣槽分层切割
          layered_slot_lt_knife_diameter: '', //刀径
          layered_slot_gt_slot_deep: '', //槽深
          layered_slot_second_slot_deep: '', //第二次切割深度
          curve_layered_cutting: false, // 异形板件切两次
          curve_layered_cutting_deep: '2', //异形板件第二次切割深度
        },
        // 开料分层切割设置
        layeredThickSetting: {
          isLayeredCut: false, // 记录是否选中开料分层切割设置
          layeredThicks: [], // 记录表格渲染数据
          trimmingFollowsLayeredCutting: false, // 记录是否选中修边也跟随分层切割
        },
        // 防跑板设置
        movePlankSetting: {
          new_cut_sequence: true, //新版切割算法
          strong_suction_zones: [], // 吸力区域
          safe_length: [300, 500], // 最小可吸住板件
          scattered_layout: false, // 小板分散排版开关
          lastPlankCutPointEnable: false,
          lastPlankCutPoint: 'rightTop',
          // 搭桥留点法
          bridgeRetention: {
            enable: false,
            punchAreaEnable: true,
            punchAreaPercent: 60,
            punchBridgeSize: 8,
            punchSpeed: 4000,
            sizeEnable: true,
            maxSideLength: 250,
            minThick: 0,
            maxArea: 0.06,
            sizeBridgeSize: 4,
            sizeSpeed: 1000,
            bridgeCountRules: [
              { minLength: 0, maxLength: 100, count: 1, [webId]: genUniId() },
              { minLength: 101, maxLength: 300, count: 2, [webId]: genUniId() },
              { minLength: 301, maxLength: 600, count: 4, [webId]: genUniId() },
              {
                minLength: 601,
                maxLength: 1200,
                count: 5,
                [webId]: genUniId(),
              },
              {
                minLength: 1201,
                maxLength: 3000,
                count: 7,
                [webId]: genUniId(),
              },
            ],
          },
        },
        // 加工速度优化
        processingSpeedSetting: {
          arcSpeed: '8000', // 曲线加工速度
          knifeSpeed: '3000', // 收刀速度
          open_knife_distance: 100, // 收刀减速距离
          noOblique: false, // UI 层：true=勾选；保存/接口层反向，false=勾选
          back_trim_oblique: false, //反面修边斜下刀
          hole_slot_cut_oblique: false, //拉槽/铣孔/铣槽斜下刀
          obliqueSpeed: '3000', //斜下刀速度-切割下料和反面修边
          hole_slot_oblique_speed: '3000', //斜下刀速度-拉槽/铣孔/铣槽
          oblique_distance: 80, //斜下刀距离-切割下料和反面修边
          hole_slot_oblique_distance: 40, //斜下刀距离-拉槽/铣孔/铣槽
          oblique_thick_setting_switch: false, // 自定义板件厚度
          back_oblique_thick_setting_switch: false,
          // 自定义板件厚度表格（行=板厚，列=工艺；UI 用 oblique_thick_list，提交同步到此结构）
          oblique_thick_list: [],
          oblique_cut_range: {
            plank_thicks: [], //切割下料斜下刀生效厚度
            back_trim_thicks: [], //反面修边斜下刀生效厚度
            hole_slot_thicks: [], //拉槽/铣孔/铣槽斜下刀生效厚度
          },
          retraction_compensation: 0, //切割收刀距离补偿
          angle_deceleration_enabled: false,
          angle_deceleration_dis: 30,
          angle_deceleration_speed: 3000,
          openknifeSpeed: true,
          angle_deceleration_list: [[30, 3000]],
          small_plank_cut_switch: false,
          small_plank_cut_rule: [],
        },

        // 修边设置
        trimmingSetting: {
          secondTrimValue: 0, // 正面再修边
          trimLMoment: this.$t('cuttingDock.cuttingParams.startCutting'), // 反面修边顺序
          trimLSingle: false, // 只修长边
          trimSide: '',
          new_trim: false, //是否开启新版修边
          is_double_panel_four_trim: false, // 双面板修边 默认修两边
          double_panel_trim_short: false, // 双面板只修短边 默认关闭
          is_single_panel_four_trim: false, // 单面板修边
          single_panel_trim_direction: null, // 单面板修边方向
          // 修边补偿
          trim_compensation: 0,
          // 不生成路径设置
          is_zero_no_route: false,
        },
        // 余料设置
        surplusSetting: {
          surplusPosition: '',
        },
        // 高光设置
        highgloss_setting: {
          highgloss_direction: 'back', //back反面 | front正面
          high_gloss_plank_no_rotate: false, // 高光板不转板
          auto_high_gloss_reverse: false, // 仅带有反面孔槽的大板自动翻面
        },
        waste_setting: {
          // 是否开启废料自动截断
          waste_cutting: false,
          // 切割顺序
          waste_order: 'plank_first',
          // 废料裁剪尺寸
          waste_size: 400,
          /** 废料纵向裁切 */
          waste_vertical_direction: true,
          /** 废料横向裁切 */
          waste_horizontal_direction: true,
        },
        ZK_setting: {
          ZK_datum_point_customize: false,
          rotate_base_point: 'right',
          rotate_angle_direction: 'counter_clockwise',
        },
        mentaojiSizeSetting: {
          mentaojiSize: 20,
          mentaojiSizeSetting: true,
          noVerticalSaw: false,
        },
      },
      specialHoleSlotRef: null,
      isShowPecialHoleAndSlotTable: false, // 是否设置不生效翻面两次打穿孔槽
      processingSpeedSettingObj: {}, // 加工速度优化 用于记住接口返回的
      obliqueThickErrorMap: {},
      // 自定义板件厚度表格：按列存错误（cut / back_trim / hole_slot）
      obliqueThickListErrorMap: {
        cut: [],
        back_trim: [],
        hole_slot: [],
      },
      rowIndex: -1, // 记录表格行索引
      columnIndex: -1, // 记录表格列索引
      currentRow: {}, // 记录当前点击的行
      lavePointImg: '',
      secondaryCuttingOptions: [
        {
          label: 'cuttingDock.cuttingParams.thickRange',
          checkedValueKey: 'cutSingleDoor',
          inputValueKey: 'single_door_thick',
          text: 'common.textOfDoorPlank',
        },
        {
          label: 'cuttingDock.cuttingParams.thickRange',
          checkedValueKey: 'cutGeneralPlank',
          inputValueKey: 'generalPlankThick',
          text: 'common.textOfNotDoorPlank',
        },
      ],
      secondaryCuttingList: [],
      millingSlotOverlapRate: 0,
      mill_z_slot_overlap_rate: 50,
      prevMillZSlotOverlapRate: 50, // 保存 mill_z_slot_overlap_rate 的前一个有效值
      plateGighGlossOptions: [
        {
          label: 'common.front',
          value: 'front',
        },
        {
          label: 'common.back',
          value: 'back',
        },
      ],
      // 机台平面偏移配置项
      planeOffsetOptions: [
        {
          label: 'X',
          key: 'planeXOffset',
        },
        {
          label: 'Y',
          key: 'planeYOffset',
        },
        {
          label: 'Z',
          key: 'planeZOffset',
        },
      ],
      positionDis: [
        {
          position: '左下角',
          value: '+x,+y',
        },
        {
          position: '左上角',
          value: '+x,- y',
        },
        {
          position: '右下角',
          value: '- x,+y',
        },
        {
          position: '右上角',
          value: '- x,- y',
        },
      ],
      positionDisMap: [
        'cuttingDock.cuttingParams.bottomLeftD',
        'cuttingDock.cuttingParams.topLeftD',
        'cuttingDock.cuttingParams.bottomRightD',
        'cuttingDock.cuttingParams.topRightD',
      ],
      img: {
        insideSlot,
        outsideSlot,
        counterclockwise,
        clockwise,
      },
      isShowWarning: false,
      suctionPosition: [
        {
          isSelected: false,
          value: 1,
        },
        {
          isSelected: false,
          value: 2,
        },
        {
          isSelected: false,
          value: 3,
        },
        {
          isSelected: false,
          value: 4,
        },
        {
          isSelected: false,
          value: 5,
        },
        {
          isSelected: false,
          value: 6,
        },
        {
          isSelected: false,
          value: 7,
        },
        {
          isSelected: false,
          value: 8,
        },
        {
          isSelected: false,
          value: 9,
        },
      ],
      currentInputIndex: null,
      currentInputPlankName: '',
      // 临时存储板件名称
      tempPlankNames: [],
      openKnifeDistanceLastValid: '',
      selectedBridgeCuttingData: [],
      // 搭桥表格编辑态：field 为 minLength | maxLength | count
      bridgeEditingCell: {
        index: -1,
        field: '',
      },
    }
  },
  computed: {
    ...mapGetters('equipEnvironment', ['showConfig']),
    bridgeCuttingColumns() {
      return [
        {
          title: this.$translateLang('板件长度(L)'),
          dataIndex: 'plankLength',
          scopedSlots: { customRender: 'plankLength' },
          align: 'center',
          width: '200px',
        },
        {
          title: this.$translateLang('连接桥数'),
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          align: 'center',
        },
        {
          title: this.$translateLang('操作'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ]
    },
    isBridgeRetentionEnabled() {
      return !!this.formData.movePlankSetting.bridgeRetention.enable
    },
    bridgeCuttingRowSelection() {
      const enabled = this.isBridgeRetentionEnabled
      return {
        selectedRowKeys: this.selectedBridgeCuttingData,
        onChange: this.handleBridgeCuttingSelectChange,
        getCheckboxProps: () => ({
          disabled: !enabled,
        }),
      }
    },
    isLongPlankCuttingDisabled() {
      return !this.formData.longPlankCuttingSetting.longPlankCuttingEnable
    },
    lastCutPointText() {
      const map = {
        leftTop: this.$translateLang('左上角'),
        rightTop: this.$translateLang('右上角'),
        leftBottom: this.$translateLang('左下角'),
        rightBottom: this.$translateLang('右下角'),
      }
      return map[this.formData.movePlankSetting.lastPlankCutPoint] || ''
    },
    laveImg() {
      return (val) => {
        switch (val) {
          case 'bottomLeft':
            return require('../../views/preLayoutSetting/assets/lb.png')
            break
          case 'topLeft':
            return require('../../views/preLayoutSetting/assets/lt.png')
            break
          case 'bottomRight':
            return require('../../views/preLayoutSetting/assets/rb.png')
            break
          case 'topRight':
            return require('../../views/preLayoutSetting/assets/rt.png')
            break
        }
      }
    },
    lavePoint() {
      const p = this.lavePoints.find(
        (item) => this.formData.surplusSetting.surplusPosition === item.value
      )
      return p ? p.label : '右上角'
    },
    container() {
      return this.$refs.wrap
    },
    positionDisValue() {
      return this.positionDis.filter(
        (dis) => dis.position == this.formData.countertopSetting.startPosition
      )[0]?.value
    },
    isShowBaseBtn() {
      return (
        this.formData.processingSpeedSetting.angle_deceleration_list &&
        this.formData.processingSpeedSetting.angle_deceleration_list.length > 1
      )
    },
    isShowObliqueThickSetting() {
      const range =
        this.formData.processingSpeedSetting.oblique_cut_range?.plank_thicks ||
        []
      return (
        this.formData.processingSpeedSetting.oblique_thick_setting_switch &&
        range.length > 1
      )
    },
    isShowBackObliqueThickSetting() {
      const range =
        this.formData.processingSpeedSetting.oblique_cut_range
          ?.back_trim_thicks || []
      return (
        this.formData.processingSpeedSetting
          .back_oblique_thick_setting_switch && range.length > 1
      )
    },
    // 自定义板件厚度表格：仅展示已勾选「切割时斜下刀」类型对应的列
    visibleObliqueThickColumnKeyList() {
      const setting = this.formData.processingSpeedSetting
      const keyList = []
      if (setting.noOblique) {
        keyList.push('cut')
      }
      if (setting.back_trim_oblique) {
        keyList.push('back_trim')
      }
      if (setting.hole_slot_cut_oblique) {
        keyList.push('hole_slot')
      }
      return keyList
    },
    // 勾选变化时强制 el-table 重绘列
    obliqueThickTableColumnKey() {
      return this.visibleObliqueThickColumnKeyList.join('-') || 'none'
    },
    // 表格宽度随可见表头列变化
    obliqueThickTableWidth() {
      if (this.isShowSecondaryCatalog) {
        return '100%'
      }
      const typeColWidth = 100
      const columnWidthMap = {
        cut: 120,
        back_trim: 120,
        hole_slot: 140,
      }
      const columnsWidth = this.visibleObliqueThickColumnKeyList.reduce(
        (sum, key) => sum + (columnWidthMap[key] || 120),
        0
      )
      return `${typeColWidth + columnsWidth}px`
    },
    // 是否有可展示的斜下刀类型列（控制表格显隐、添加/删除可点）
    hasVisibleObliqueThickColumn() {
      return (
        this.visibleObliqueThickColumnKeyList.length > 0 ||
        this.isShowSecondaryCatalog
      )
    },
    isObliqueThickTableOperateEnabled() {
      return (
        this.formData.processingSpeedSetting.oblique_thick_setting_switch &&
        this.hasVisibleObliqueThickColumn
      )
    },
    // 开料分层切割顺序填写规则
    disableddRules() {
      return (row, prop) => {
        // 判断只对第一二三次厚度填写生效
        let verifyList = ['firstCut', 'secondCut', 'thirdCut']
        let flag
        if (verifyList.includes(prop)) {
          switch (prop) {
            case 'secondCut':
              flag = row['firstCut'] !== ''
              break
            case 'thirdCut':
              flag = row['secondCut'] !== '' && row['firstCut'] !== ''
              break
            default:
              flag = true
              break
          }
          return !flag
        }
        // 其余的数据正常输入
        return false
      }
    },
    arcShowExample() {
      const example = this.$t('cuttingDock.cuttingParams.example')
      const arcInstruction = this.formData.cuttingPunchingSetting.arcInstruction
        ? this.formData.cuttingPunchingSetting.arcInstruction
        : ''
      const arcExample = this.$t('cuttingDock.cuttingParams.arcExample')
      return `${example}: ${arcInstruction}${arcExample}`
    },
  },
  watch: {
    isBridgeRetentionEnabled(enabled) {
      if (!enabled) {
        this.selectedBridgeCuttingData = []
        this.bridgeEditingCell = { index: -1, field: '' }
      }
    },
    obj: {
      handler(newVal) {
        if (Object.keys(newVal).length > 0) {
          let s = JSON.parse(JSON.stringify(newVal))
          this.processingSpeedSettingObj = JSON.parse(
            JSON.stringify(newVal)
          ).processingSpeedSetting
          // 浅层合并 有可能导致数据丢失 以及 响应式丢失 不推荐使用
          // this.formData = { ...this.formData, ...s }
          // 使用深度合并确保所有属性都被正确更新
          this.deepMerge(this.formData, s)
          this.ensureObliqueCutRange()
          this.normalizeObliqueThickList()
          this.ensurePreventBreakageRulesWebId()
          // 兼容旧数据：为搭桥生成方式补齐唯一 id，供操作记录表格比对
          if (
            this.formData.movePlankSetting?.bridgeRetention?.bridgeCountRules
          ) {
            addIdForItems(
              this.formData.movePlankSetting.bridgeRetention.bridgeCountRules
            )
          }
          this.normalizeObliqueThickRange('oblique_thick_thick_range')
          this.normalizeObliqueThickRange('back_oblique_thick_thick_range')
          this.resetObliqueThickErrors()
          if (s.movePlankSetting.strong_suction_zones) {
            this.suctionPosition.forEach((item, index) => {
              item.isSelected = false
            })
            // 将suctionPosition的value与i对应的哪一项，isSelected为true, 其他为false
            if (s.movePlankSetting.strong_suction_zones.length) {
              s.movePlankSetting.strong_suction_zones.forEach((i, index) => {
                this.suctionPosition[i - 1].isSelected = true
              })
            } else {
              this.suctionPosition.forEach((item) => (item.isSelected = false))
            }
          }
          this.millingSlotOverlapRate =
            s.cuttingPunchingSetting.millingSlotOverlapRate
          this.mill_z_slot_overlap_rate =
            s.cuttingPunchingSetting.mill_z_slot_overlap_rate
          this.prevMillZSlotOverlapRate =
            s.cuttingPunchingSetting.mill_z_slot_overlap_rate || 50
          // noOblique 与 UI 勾选反向：接口 false=勾选，true=取消勾选
          if (typeof s.processingSpeedSetting.noOblique === 'boolean') {
            this.formData.processingSpeedSetting.noOblique =
              !this.formData.processingSpeedSetting.noOblique
          }
          let selectedCutting = [
            {
              label: this.$t('common.isDoorPlank'),
              key: 'cutSingleDoor',
              checked: this.formData.longPlankCuttingSetting.cutSingleDoor,
            },
            {
              label: this.$t('cuttingDock.cuttingParams.thickRange'),
              key: 'cutGeneralPlank',
              checked: this.formData.longPlankCuttingSetting.cutGeneralPlank,
            },
          ]
          this.secondaryCuttingList = selectedCutting
            .filter((e) => e.checked)
            .map((i) => i.key)
        }
      },
      deep: true,
      immediate: true,
    },
    millingSlotOverlapRate: {
      handler(val, preVal) {
        this.formatInputSlotCoverRate(val, preVal, 'millingSlotOverlapRate')
      },
    },
    mill_z_slot_overlap_rate: {
      handler(val, preVal) {
        this.formatInputSlotCoverRate(val, preVal, 'mill_z_slot_overlap_rate')
      },
    },
    'formData.movePlankSetting': {
      handler(newVal) {
        if (!newVal.safe_length) {
          this.$set(this.formData.movePlankSetting, 'safe_length', [300, 500])
        }
        if (!newVal.strong_suction_zones) {
          this.$set(this.formData.movePlankSetting, 'strong_suction_zones', [])
        }
        if (newVal.lastPlankCutPointEnable === undefined) {
          this.$set(
            this.formData.movePlankSetting,
            'lastPlankCutPointEnable',
            false
          )
        }
        if (!newVal.lastPlankCutPoint) {
          this.$set(
            this.formData.movePlankSetting,
            'lastPlankCutPoint',
            'rightTop'
          )
        }
        if (Array.isArray(newVal.strong_suction_zones)) {
          newVal.strong_suction_zones.forEach((e) => {
            let index = this.suctionPosition.findIndex((i) => i.value === e)
            if (index !== -1) {
              this.$set(this.suctionPosition, index, {
                ...this.suctionPosition[index],
                isSelected: true,
              })
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleChangeHighGlossReverse(val) {
      this.$emit('onHighGlossReverseChange', val)
    },
    handlePecialHoleAndSlotTableSwitch(data) {
      this.formData.cuttingPunchingSetting.non_through_slot_two_side_cut.is_open =
        data
    },
    handleSpecialHoleSlotRef() {
      this.$refs.specialHoleSlotRef.handleAdd()
    },
    resetObliqueThickErrors() {
      this.obliqueThickErrorMap = {}
      this.obliqueThickListErrorMap = {
        cut: [],
        back_trim: [],
        hole_slot: [],
      }
    },
    /** 保证 oblique_cut_range 结构完整 */
    ensureObliqueCutRange() {
      const setting = this.formData.processingSpeedSetting
      if (
        !setting.oblique_cut_range ||
        typeof setting.oblique_cut_range !== 'object'
      ) {
        this.$set(setting, 'oblique_cut_range', {
          plank_thicks: [],
          back_trim_thicks: [],
          hole_slot_thicks: [],
        })
        return
      }
      ;['plank_thicks', 'back_trim_thicks', 'hole_slot_thicks'].forEach(
        (key) => {
          if (!Array.isArray(setting.oblique_cut_range[key])) {
            this.$set(setting.oblique_cut_range, key, [])
          }
        }
      )
    },
    /** 兼容旧数据 { thick } 与纯数值 */
    getObliqueThickValue(item) {
      if (item === null || item === undefined) {
        return ''
      }
      if (typeof item === 'object') {
        return item.thick === null || item.thick === undefined
          ? ''
          : String(item.thick)
      }
      return String(item)
    },
    // 将 oblique_cut_range（或旧版三列 range）合并为转置表格数据；若已有 list 则规范化字段
    normalizeObliqueThickList() {
      const setting = this.formData.processingSpeedSetting
      this.ensureObliqueCutRange()
      if (!Array.isArray(setting.oblique_thick_list)) {
        this.$set(setting, 'oblique_thick_list', [])
      }
      if (setting.oblique_thick_list.length) {
        setting.oblique_thick_list = setting.oblique_thick_list.map((item) => ({
          cut:
            item?.cut === null || item?.cut === undefined
              ? ''
              : String(item.cut),
          back_trim:
            item?.back_trim === null || item?.back_trim === undefined
              ? ''
              : String(item.back_trim),
          hole_slot:
            item?.hole_slot === null || item?.hole_slot === undefined
              ? ''
              : String(item.hole_slot),
        }))
        this.syncObliqueThickListToRanges()
        return
      }
      let cutRange = setting.oblique_cut_range.plank_thicks || []
      let backRange = setting.oblique_cut_range.back_trim_thicks || []
      let holeRange = setting.oblique_cut_range.hole_slot_thicks || []
      // 兼容旧字段
      if (!cutRange.length && !backRange.length && !holeRange.length) {
        cutRange = setting.oblique_thick_thick_range || []
        backRange = setting.back_oblique_thick_thick_range || []
        holeRange = setting.hole_slot_cut_oblique_thick_range || []
      }
      const len = Math.max(cutRange.length, backRange.length, holeRange.length)
      if (!len) {
        setting.oblique_thick_list = []
        this.syncObliqueThickListToRanges()
        return
      }
      setting.oblique_thick_list = Array.from({ length: len }, (_, index) => ({
        cut: this.getObliqueThickValue(cutRange[index]),
        back_trim: this.getObliqueThickValue(backRange[index]),
        hole_slot: this.getObliqueThickValue(holeRange[index]),
      }))
      // 旧数据两套开关任一开启则开总开关
      if (
        setting.oblique_thick_setting_switch ||
        setting.back_oblique_thick_setting_switch
      ) {
        setting.oblique_thick_setting_switch = true
      }
      this.syncObliqueThickListToRanges()
    },
    /** 表格数据同步到 oblique_cut_range（提交/保存用） */
    syncObliqueThickListToRanges() {
      const setting = this.formData.processingSpeedSetting
      this.ensureObliqueCutRange()
      const list = setting.oblique_thick_list || []
      const switchOn = Boolean(setting.oblique_thick_setting_switch)
      setting.back_oblique_thick_setting_switch = switchOn
      setting.oblique_cut_range.plank_thicks = list.map(
        (item) => item?.cut ?? ''
      )
      setting.oblique_cut_range.back_trim_thicks = list.map(
        (item) => item?.back_trim ?? ''
      )
      setting.oblique_cut_range.hole_slot_thicks = list.map(
        (item) => item?.hole_slot ?? ''
      )
      // 迁移后清理旧字段，避免与 oblique_cut_range 双写
      ;[
        'oblique_thick_thick_range',
        'back_oblique_thick_thick_range',
        'hole_slot_cut_oblique_thick_range',
      ].forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(setting, key)) {
          this.$delete(setting, key)
        }
      })
    },
    handleAddObliqueThickRow() {
      if (!this.isObliqueThickTableOperateEnabled) {
        return
      }
      if (
        !Array.isArray(this.formData.processingSpeedSetting.oblique_thick_list)
      ) {
        this.$set(
          this.formData.processingSpeedSetting,
          'oblique_thick_list',
          []
        )
      }
      this.formData.processingSpeedSetting.oblique_thick_list.push({
        cut: '',
        back_trim: '',
        hole_slot: '',
      })
      const index =
        this.formData.processingSpeedSetting.oblique_thick_list.length - 1
      ;['cut', 'back_trim', 'hole_slot'].forEach((key) => {
        this.$set(this.obliqueThickListErrorMap[key], index, false)
      })
      this.syncObliqueThickListToRanges()
    },
    handleDeleteObliqueThickRow() {
      if (!this.isObliqueThickTableOperateEnabled) {
        return
      }
      const list = this.formData.processingSpeedSetting.oblique_thick_list || []
      if (!list.length) {
        return
      }
      const deleteIndex = list.length - 1
      list.splice(deleteIndex, 1)
      ;['cut', 'back_trim', 'hole_slot'].forEach((key) => {
        this.obliqueThickListErrorMap[key].splice(deleteIndex, 1)
      })
      this.syncObliqueThickListToRanges()
      this.validateObliqueThickListAll()
    },
    getObliqueThickListError(index, key) {
      return Boolean(this.obliqueThickListErrorMap[key]?.[index])
    },
    validateObliqueThickListColumn(key) {
      const list = this.formData.processingSpeedSetting.oblique_thick_list || []
      const errorList = []
      list.forEach((row, index) => {
        const thick = row?.[key]
        const isEmpty = thick === '' || thick === null || thick === undefined
        if (isEmpty) {
          errorList[index] = false
          return
        }
        const normalizedThick = this.normalizeObliqueThickCompareValue(thick)
        const isDuplicate = list.some((prevRow, prevIndex) => {
          if (prevIndex >= index) {
            return false
          }
          const prevThick = prevRow?.[key]
          const isPrevEmpty =
            prevThick === '' || prevThick === null || prevThick === undefined
          if (isPrevEmpty) {
            return false
          }
          return (
            this.normalizeObliqueThickCompareValue(prevThick) ===
            normalizedThick
          )
        })
        errorList[index] = isDuplicate ? 'duplicate' : false
      })
      this.obliqueThickListErrorMap[key] = errorList
      return errorList.every((error) => !error)
    },
    validateObliqueThickListAll() {
      const visibleKeyList = this.visibleObliqueThickColumnKeyList
      ;['cut', 'back_trim', 'hole_slot'].forEach((key) => {
        if (!visibleKeyList.includes(key)) {
          this.obliqueThickListErrorMap[key] = []
        }
      })
      if (!visibleKeyList.length) {
        return true
      }
      return visibleKeyList.every((key) =>
        this.validateObliqueThickListColumn(key)
      )
    },
    normalizeObliqueThickRange(rangeKey) {
      const rangeValue = this.formData.processingSpeedSetting[rangeKey]
      if (!Array.isArray(rangeValue)) {
        this.$set(this.formData.processingSpeedSetting, rangeKey, [])
        return
      }
      this.formData.processingSpeedSetting[rangeKey] = rangeValue.map(
        (item) => {
          if (item && typeof item === 'object') {
            return {
              ...item,
              thick:
                item.thick === null || item.thick === undefined
                  ? ''
                  : String(item.thick),
            }
          }
          return {
            thick: item === null || item === undefined ? '' : String(item),
          }
        }
      )
    },
    getObliqueThickError(rangeKey, index) {
      return Boolean(this.obliqueThickErrorMap[rangeKey]?.[index])
    },
    getObliqueThickErrorTip(rangeKey, index) {
      const error = this.obliqueThickErrorMap[rangeKey]?.[index]
      if (error === 'duplicate') {
        return this.$translateLang('生效厚度不能重复，请修改')
      }
      return this.$translateLang('请输入')
    },
    getObliqueThickSaveErrorMessage() {
      const keyList = this.visibleObliqueThickColumnKeyList
      let hasDuplicate = false
      keyList.forEach((key) => {
        const errorList = this.obliqueThickListErrorMap[key] || []
        errorList.forEach((error) => {
          if (error === 'duplicate') {
            hasDuplicate = true
          }
        })
      })
      if (hasDuplicate) {
        return this.$translateLang('生效厚度不能重复，请修改')
      }
      return ''
    },
    normalizeObliqueThickCompareValue(thick) {
      const thickStr = String(thick).trim()
      if (thickStr === '') {
        return ''
      }
      const thickNum = Number(thickStr)
      if (!Number.isNaN(thickNum)) {
        return String(thickNum)
      }
      return thickStr
    },
    isObliqueThickDuplicateWithPrevious(rangeKey, index) {
      const rangeValue = this.formData.processingSpeedSetting[rangeKey] || []
      const item = rangeValue[index]
      const thick = item?.thick
      if (thick === '' || thick === null || thick === undefined) {
        return false
      }
      const normalizedThick = this.normalizeObliqueThickCompareValue(thick)
      return rangeValue.some((row, rowIndex) => {
        if (rowIndex >= index) {
          return false
        }
        const previousThick = row?.thick
        if (
          previousThick === '' ||
          previousThick === null ||
          previousThick === undefined
        ) {
          return false
        }
        return (
          this.normalizeObliqueThickCompareValue(previousThick) ===
          normalizedThick
        )
      })
    },
    validateSingleObliqueThick(rangeKey, index) {
      const item = this.formData.processingSpeedSetting[rangeKey]?.[index]
      const thick = item?.thick
      const isEmpty = thick === '' || thick === null || thick === undefined
      if (isEmpty) {
        this.$set(this.obliqueThickErrorMap[rangeKey], index, 'empty')
        return false
      }
      if (this.isObliqueThickDuplicateWithPrevious(rangeKey, index)) {
        this.$set(this.obliqueThickErrorMap[rangeKey], index, 'duplicate')
        return false
      }
      this.$set(this.obliqueThickErrorMap[rangeKey], index, false)
      return true
    },
    validateObliqueThickRangeFromIndex(rangeKey, fromIndex = 0) {
      const rangeValue = this.formData.processingSpeedSetting[rangeKey] || []
      let isValid = true
      for (let index = fromIndex; index < rangeValue.length; index++) {
        if (!this.validateSingleObliqueThick(rangeKey, index)) {
          isValid = false
        }
      }
      return isValid
    },
    validateObliqueThickRequiredForSave() {
      if (!this.formData.processingSpeedSetting.oblique_thick_setting_switch) {
        this.resetObliqueThickErrors()
        this.syncObliqueThickListToRanges()
        return true
      }
      const visibleKeyList = this.visibleObliqueThickColumnKeyList
      // 未勾选任何斜下刀类型时，不校验表格内容（列仅隐藏，数据保留）
      if (!visibleKeyList.length) {
        this.resetObliqueThickErrors()
        this.syncObliqueThickListToRanges()
        return true
      }
      const list = this.formData.processingSpeedSetting.oblique_thick_list
      if (!Array.isArray(list) || !list.length) {
        this.resetObliqueThickErrors()
        this.syncObliqueThickListToRanges()
        return true
      }
      const isValid = this.validateObliqueThickListAll()
      this.syncObliqueThickListToRanges()
      return isValid
    },
    // 深合并target：目标对象；source：源对象
    // 将源对象的所有属性深度合并到目标对象中，确保Vue的响应式系统能正确追踪变化
    deepMerge(target, source) {
      for (const key in source) {
        if (
          source[key] &&
          typeof source[key] === 'object' &&
          !Array.isArray(source[key])
        ) {
          if (!target[key]) {
            this.$set(target, key, {})
          }
          this.deepMerge(target[key], source[key])
        } else {
          this.$set(target, key, source[key])
        }
      }
    },
    // 分层切割--铣槽拉槽
    handleInputBlur() {
      // 失去焦点的时候校验第二层切割深度必须小于设置的槽深度
      if (
        Number(
          this.formData.layeredCuttingSetting.layered_slot_second_slot_deep
        ) <
        Number(this.formData.layeredCuttingSetting.layered_slot_gt_slot_deep)
      ) {
        // 关闭提示
        this.isShowWarning = false
      } else {
        // 开启提示 并且不能保存
        this.isShowWarning = true
      }
    },
    handleCheckInput(name, e) {
      // 输入框的限制 输入为纯数字 3+2 整数+小数
      // 正则表达式
      const reg = /^(\d{0,3})(\.(\d{0,2}))?$/g
      if (reg.test(e.target.value) || e.target.value === '') {
        // 符合验证规范，直接赋值
        this.formData.layeredCuttingSetting[name] = e.target.value
      }
      // 不符合规范的时候不修改数据，将输入框的值改回原始数据
      e.target.value = this.formData.layeredCuttingSetting[name]
    },
    translateLang(key) {
      return translate(key)
    },
    onUpdateTrimSetting(val) {
      this.formData.trimmingSetting = JSON.parse(JSON.stringify(val))
    },

    handleWasterSize(val1, val2) {
      this.formData[val1][val2] = regReplaceCuttingParamsInputDepth(
        this.formData[val1][val2]
      )
      this.formData[val1][val2] =
        this.formData[val1][val2].indexOf('.') > 0
          ? this.formData[val1][val2].split('.')[0].substring(0, 3) +
            '.' +
            this.formData[val1][val2].split('.')[1].substring(0, 2)
          : this.formData[val1][val2].split('.')[0].substring(0, 3)
    },
    handleWasterSizeBlur() {
      if (this.formData.waste_setting.waste_size < 100) {
        this.formData.waste_setting.waste_size = 100
      }
    },
    handleDualInputValue(row, prop) {
      verifyInputNumber(row[prop], row, [prop], '4')
    },
    // 铣槽重叠率输入
    formatInputSlotCoverRate(val, preVal, key) {
      const reg = /^-?\d*(\.\d*)?$/
      const isMillZSlot = key === 'mill_z_slot_overlap_rate'
      const numVal = +val
      const isValid =
        val === '' ||
        (!isNaN(numVal) &&
          reg.test(val) &&
          (isMillZSlot ? numVal < 100 : numVal <= 50))
      const finalVal = isValid ? Number(val) : Number(preVal)

      this.formData.cuttingPunchingSetting[key] = finalVal
      this[key] = finalVal
    },
    // 选择二次切割
    handleSelectCutting(e) {
      this.formData.longPlankCuttingSetting.cutSingleDoor =
        e.includes('cutSingleDoor')
      this.formData.longPlankCuttingSetting.cutGeneralPlank =
        e.includes('cutGeneralPlank')
    },
    /**
     * @desc 保存长板加工中指定材质选项和列表
     */
    saveAccordmCut() {
      if (!this.formData?.longPlankCuttingSetting?.longPlankCuttingEnable)
        return
      // 新布局下组件仅在 desMaterialSwitch 开启时挂载
      this.$refs.accordTextureCut?.saveAccordmCut(
        this.formData.longPlankCuttingSetting
      )
    },
    // 选择起始工位
    chosePoint(val) {
      this.formData.countertopSetting.startPosition = val
    },
    choselavePoint(val) {
      const p = this.lavePoints.find((item) => item.label === val)
      this.formData.surplusSetting.surplusPosition = p ? p.value : 'topRight'
    },
    // 选择余料摆放位置
    changeHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'plank_thick') {
        return 'padding-left: 16px; box-sizing: border-box;background: #fafafa'
      }
      return 'background: #fafafa;'
    },
    changeCellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'plank_thick') {
        if (!this.formData.layeredThickSetting.isLayeredCut) {
          return 'padding-left: 16px; height: 53px; box-sizing: border-box; color: rgba(0, 0, 0, .25)'
        } else {
          return 'padding-left: 16px; height: 53px; box-sizing: border-box;'
        }
      }
      if (!this.formData.layeredThickSetting.isLayeredCut) {
        return 'color: rgba(0, 0, 0, .25); height: 53px;'
      }
    },
    //把每一行的索引加到行数据中
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    //把每一列的索引加到列数据中
    tableCellClassName({ column, columnIndex }) {
      column.index = columnIndex
    },
    cellClick(row, column, cell, event) {
      this.currentRow = row
      if (this.formData.layeredThickSetting.isLayeredCut) {
        this.rowIndex = row.index
        this.columnIndex = column.index
        // 不知道什么时候property可能为type，高光属性也不需要聚焦
        if (column.property != 'type' && column.property != 'highlight') {
          this.$nextTick(() => {
            this.$refs['editInput'] &&
              this.$refs['editInput'].length &&
              this.$refs['editInput'][0].focus()
          })
        }
      }
    },
    handleChangeHighGloss(optionValue, row, prop) {
      row[prop] = optionValue == 'notHeighGloss' ? false : true
      this.rowIndex = -1
      this.columnIndex = -1
    },
    inputBlur(row, prop) {
      this.rowIndex = -1
      this.columnIndex = -1
      // 如果修改的是材质，当材质被清空的时候，高光也需要被清空
      if (prop == 'matCode') {
        if (!row[prop]) {
          row.highlight = ''
        } else {
          row.highlight = false
        }
      }
      // 如果修改的是第二次的厚度，需要自动计算出第三次的值
      if (prop == 'secondCut') {
        if (row.secondCut !== '' && row.thirdCut === '') {
          const { firstCut, secondCut, pThick } = row
          row.thirdCut = (
            pThick - firstCut - secondCut < 0
              ? 0
              : pThick - firstCut - secondCut
          ).toString()
        }
      }
    },
    verifyInput(row, prop) {
      // 不需要对高光属性和板件材质进行验证
      const noVerifyList = ['matCode']
      if (!noVerifyList.includes(prop)) {
        verifyInputNumber(row[prop], row, [prop], '2-2')
      }
    },
    // 添加板件
    addNewPlank() {
      this.formData.layeredThickSetting.layeredThicks.push({
        highlight: '',
        matCode: '',
        pThick: '',
        firstCut: '',
        secondCut: '',
        thirdCut: '',
        [webId]: genUniId(), // 添加唯一id
      })
      this.rowIndex = this.formData.layeredThickSetting.layeredThicks.length - 1
      this.columnIndex = 0
      this.$nextTick(() => {
        this.$refs['editInput'] &&
          this.$refs['editInput'].length &&
          this.$refs['editInput'][0].focus()
      })
    },
    // 删除板件
    deletePlank() {
      this.formData.layeredThickSetting.layeredThicks.splice(
        this.formData.layeredThickSetting.layeredThicks.findIndex(
          (v) => v.index === this.currentRow.index
        ),
        1
      )
    },
    // 减速距离：仅正整数，最大值 999
    handleOpenKnifeDistanceFocus() {
      const value = this.formData.processingSpeedSetting.open_knife_distance
      this.openKnifeDistanceLastValid =
        value === '' || value === null || value === undefined
          ? ''
          : String(value)
    },
    validateOpenKnifeDistance(e) {
      let inputValue = String(e.target.value ?? '').replace(/[^\d]/g, '')
      if (inputValue === '') {
        this.formData.processingSpeedSetting.open_knife_distance = ''
        this.openKnifeDistanceLastValid = ''
        return
      }
      const numValue = Number(inputValue)
      if (numValue > 999) {
        this.formData.processingSpeedSetting.open_knife_distance =
          this.openKnifeDistanceLastValid
        return
      }
      this.formData.processingSpeedSetting.open_knife_distance = inputValue
      this.openKnifeDistanceLastValid = inputValue
    },
    // 加工速度使用
    validatePositiveDecimal(name, e, index, deep) {
      // 输入框的限制 输入为纯数字 6+2 整数+小数
      const reg = /^(\d{0,6})(\.(\d{0,2}))?$/g
      const inputValue = e.target.value

      // 如果输入为空，允许继续输入
      if (inputValue === '') {
        if (index != null && deep != null) {
          this.$set(this.formData.processingSpeedSetting[name][index], deep, '')
        } else {
          this.formData.processingSpeedSetting[name] = ''
        }
        if (
          name === 'oblique_thick_thick_range' ||
          name === 'back_oblique_thick_thick_range'
        ) {
          this.validateObliqueThickRangeFromIndex(name, index)
        }
        if (name === 'oblique_thick_list') {
          this.syncObliqueThickListToRanges()
        }
        return
      }

      // 如果输入符合规范，直接使用
      if (reg.test(inputValue)) {
        if (index != null && deep != null) {
          this.$set(
            this.formData.processingSpeedSetting[name][index],
            deep,
            inputValue
          )
        } else {
          this.formData.processingSpeedSetting[name] = inputValue
        }
        if (
          name === 'oblique_thick_thick_range' ||
          name === 'back_oblique_thick_thick_range'
        ) {
          this.validateObliqueThickRangeFromIndex(name, index)
        }
        if (name === 'oblique_thick_list') {
          this.syncObliqueThickListToRanges()
        }
      } else {
        // 不符合规范时，尝试修正输入
        let correctedValue = inputValue

        // 只保留数字和小数点
        correctedValue = correctedValue.replace(/[^\d.]/g, '')

        // 确保只有一个小数点
        const parts = correctedValue.split('.')
        if (parts.length > 2) {
          correctedValue = parts[0] + '.' + parts.slice(1).join('')
        }

        // 限制整数部分最多6位，小数部分最多2位
        if (parts.length === 2) {
          const integerPart = parts[0].slice(0, 6)
          const decimalPart = parts[1].slice(0, 2)
          correctedValue = integerPart + '.' + decimalPart
        } else if (parts.length === 1) {
          correctedValue = parts[0].slice(0, 6)
        }

        // 如果修正后的值符合规范，使用修正值
        if (reg.test(correctedValue)) {
          if (index != null && deep != null) {
            this.$set(
              this.formData.processingSpeedSetting[name][index],
              deep,
              correctedValue
            )
          } else {
            this.formData.processingSpeedSetting[name] = correctedValue
          }
          if (
            name === 'oblique_thick_thick_range' ||
            name === 'back_oblique_thick_thick_range'
          ) {
            this.validateObliqueThickRangeFromIndex(name, index)
          }
          if (name === 'oblique_thick_list') {
            this.syncObliqueThickListToRanges()
          }
        } else {
          // 如果修正后仍不符合规范，保持原值
          if (index != null && deep != null) {
            // 保持原值，不修改
          } else {
            this.formData.processingSpeedSetting[name] =
              this.formData.processingSpeedSetting[name]
          }
          if (
            name === 'oblique_thick_thick_range' ||
            name === 'back_oblique_thick_thick_range'
          ) {
            this.validateObliqueThickRangeFromIndex(name, index)
          }
          if (name === 'oblique_thick_list') {
            this.syncObliqueThickListToRanges()
          }
        }
      }
    },
    // 切割收刀距离补偿输入验证（最大值20，2位小数）
    validateRetractionCompensation(name, e) {
      const reg = /^(\d{0,2})(\.(\d{0,2}))?$/
      const inputValue = e.target.value

      // 如果输入为空，允许继续输入
      if (inputValue === '') {
        this.formData.processingSpeedSetting[name] = ''
        return
      }

      // 只保留数字和小数点
      let correctedValue = inputValue.replace(/[^\d.]/g, '')

      // 确保只有一个小数点
      const parts = correctedValue.split('.')
      if (parts.length > 2) {
        correctedValue = parts[0] + '.' + parts.slice(1).join('')
      }

      // 限制整数部分最多2位，小数部分最多2位
      const newParts = correctedValue.split('.')
      if (newParts.length === 2) {
        const integerPart = newParts[0].slice(0, 2)
        const decimalPart = newParts[1].slice(0, 2)
        correctedValue = integerPart + '.' + decimalPart
      } else if (newParts.length === 1) {
        correctedValue = newParts[0].slice(0, 2)
      }

      // 如果符合规范，更新值（输入过程中允许暂时超过20，失去焦点时再限制）
      if (reg.test(correctedValue) || correctedValue === '') {
        this.formData.processingSpeedSetting[name] = correctedValue
      }
    },
    // 切割收刀距离补偿失去焦点处理
    handleRetractionCompensationBlur(val1, val2) {
      const currentValue = this.formData[val1][val2]
      if (
        currentValue === '' ||
        currentValue === null ||
        currentValue === undefined
      ) {
        return
      }
      const numValue = parseFloat(currentValue)
      if (!isNaN(numValue)) {
        // 限制最大值20
        const finalValue = numValue > 20 ? 20 : numValue
        this.formData[val1][val2] = Number(finalValue.toFixed(2))
      }
    },

    // ======== 处理输入框失去焦点时的数字转换 ========

    // 获取嵌套对象的值
    getNestedValue(obj, path) {
      return path.reduce((current, key) => {
        return current && key !== null && key !== undefined
          ? current[key]
          : undefined
      }, obj)
    },

    // 设置嵌套对象的值
    setNestedValue(obj, path, value) {
      const lastKey = path[path.length - 1]
      const parentPath = path.slice(0, -1)
      const parent = this.getNestedValue(obj, parentPath)

      if (parent && lastKey !== null && lastKey !== undefined) {
        this.$set(parent, lastKey, value)
      }
    },
    // 检查值是否有效
    isValidValue(value, key) {
      const INVALID_VALUES = ['', null, undefined] // 无效值
      const ZERO_NOT_ALLOWED_KEYS = [
        'oblique_distance',
        'hole_slot_oblique_distance',
        'open_knife_distance',
      ] // 斜下刀距离/减速距离不允许为 0，其他字段允许为 0
      // 检查无效值
      if (INVALID_VALUES.includes(value) || isNaN(Number(value))) {
        return false
      }
      const numValue = Number(value)
      if (key === 'open_knife_distance' && numValue > 999) {
        return false
      }
      return !ZERO_NOT_ALLOWED_KEYS.includes(key) || numValue !== 0
    },
    handleDecimalBlur(val1, val2, index, deep) {
      try {
        // 构建路径数组，过滤掉null和undefined的值
        const path = [val1, val2, index, deep].filter(
          (key) => key !== null && key !== undefined
        )
        // 构建默认值路径，同样过滤掉null和undefined
        const defaultPath = [val2, index, deep].filter(
          (key) => key !== null && key !== undefined
        )
        // 获取当前值
        const currentValue = this.getNestedValue(this.formData, path)
        const defaultValue = this.getNestedValue(
          this.processingSpeedSettingObj,
          defaultPath
        )
        // 检查值是否有效
        if (this.isValidValue(currentValue, val2)) {
          // 转换为数字并更新
          let numericValue = Number(currentValue)
          if (val2 === 'open_knife_distance') {
            numericValue = Math.floor(numericValue)
          }
          this.setNestedValue(this.formData, path, numericValue)
        } else {
          this.setNestedValue(this.formData, path, defaultValue)
        }
        if (
          val2 === 'oblique_thick_thick_range' ||
          val2 === 'back_oblique_thick_thick_range'
        ) {
          this.validateObliqueThickRangeFromIndex(val2, index)
        }

        if (val2 === 'open_knife_distance' && currentValue !== defaultValue) {
          buryPointApi('engraving', 'open_knife_distance')
        }
      } catch (error) {
        console.error('handleDecimalBlur 执行出错:', error)
      }
    },

    // ===============================================
    // 输入检验；val2 不传时读写 this.formData[val1]，否则读写 this.formData[val1][val2]
    inputCheck(val1, val2, type, decimal, positive, max) {
      const ref = val2 === undefined ? this.formData : this.formData[val1]
      const key = val2 === undefined ? val1 : val2
      // 只为正整数
      if (type) {
        ref[key] = String(ref[key] ?? '').replace(/[^\d]/g, '')
      } else {
        // 可以为正负数
        ref[key] = regReplaceCuttingParamsInputCheck(String(ref[key] ?? ''))

        // 第五个参数加上是为了控制只能输入正数及小数不能输入负数,并返回，走小数限制会只能输入两位
        if (positive) {
          ref[key] = ref[key].replace(/[^\d*\.]/g, '')
          return
        }
        if (decimal) {
          ref[key] = ref[key].replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        }
        if (max) {
          const num = Number(ref[key])
          if (num > max) ref[key] = max
          if (num < 0 && num < -max) ref[key] = -max
        }
      }
    },
    handleBufferHeightBlur() {
      if (!this.formData.buffer_offset || this.formData.buffer_offset === '-') {
        this.formData.buffer_offset = 0
      }
      this.formData.buffer_offset = Number(this.formData.buffer_offset)
    },
    handleOffsetBlur(key) {
      if (this.formData.countertopSetting[key] == '-') {
        this.formData.countertopSetting[key] = ''
      }
    },
    //小板第二次切割深度输入限制
    inputDepth(val1, val2) {
      this.formData[val1][val2] = regReplaceCuttingParamsInputDepth(
        this.formData[val1][val2]
      )
      this.formData[val1][val2] =
        this.formData[val1][val2].indexOf('.') > 0
          ? this.formData[val1][val2].split('.')[0].substring(0, 3) +
            '.' +
            this.formData[val1][val2].split('.')[1]
          : this.formData[val1][val2].split('.')[0].substring(0, 3)
    },
    safeInputCheck(val1, val2, index) {
      // 限制只能输入正整数
      this.formData[val1][val2][index] = regReplaceCuttingParamsInputDepth(
        this.formData[val1][val2][index]
      )
    },
    handleInputVal(obj, key, deep, index) {
      this.formData[obj][key][deep][index] = this.formData[obj][key][deep][
        index
      ].replace(/[^0-9]/g, '')
    },
    //组织锚点改变url
    handlePrevent(e, link) {
      e.preventDefault()
    },
    //处理不同版厚分层切割的数据判断
    onDealHierarchyCutting(scope) {
      // 使用Number.EPSILON做容差比较
      let verifyFlag =
        Math.abs(
          Number(scope['pThick']) -
            (Number(scope['firstCut']) +
              Number(scope['secondCut']) +
              Number(scope['thirdCut']))
        ) < Number.EPSILON
      return verifyFlag
    },
    handelAddAngleDeceleration() {
      if (!this.formData.processingSpeedSetting.angle_deceleration_enabled)
        return
      this.formData.processingSpeedSetting.angle_deceleration_list.push([
        '',
        '',
      ])
    },
    // 添加斜下刀厚度设置 以及 反面修边斜下刀厚度设置
    handelAddObliqueThickSetting(switchObj, thickRangeObj) {
      if (!this.formData.processingSpeedSetting[switchObj]) return
      if (!Array.isArray(this.formData.processingSpeedSetting[thickRangeObj])) {
        this.$set(this.formData.processingSpeedSetting, thickRangeObj, [])
      }
      this.formData.processingSpeedSetting[thickRangeObj].push({ thick: '' })
      this.$set(
        this.obliqueThickErrorMap[thickRangeObj],
        this.formData.processingSpeedSetting[thickRangeObj].length - 1,
        'empty'
      )
    },
    handelDeleteAngleDeceleration(index) {
      if (!this.formData.processingSpeedSetting.angle_deceleration_enabled)
        return
      if (!index) {
        this.formData.processingSpeedSetting.angle_deceleration_list =
          this.formData.processingSpeedSetting.angle_deceleration_list.slice(1)
      } else {
        this.formData.processingSpeedSetting.angle_deceleration_list.pop()
      }
    },
    handelDeleteObliqueThickSetting(thickRangeObj, index) {
      if (!this.formData.processingSpeedSetting[thickRangeObj]) return
      if (!index) {
        this.formData.processingSpeedSetting[thickRangeObj] =
          this.formData.processingSpeedSetting[thickRangeObj].slice(1)
        this.obliqueThickErrorMap[thickRangeObj] =
          this.obliqueThickErrorMap[thickRangeObj].slice(1)
      } else {
        this.formData.processingSpeedSetting[thickRangeObj].pop()
        this.obliqueThickErrorMap[thickRangeObj].pop()
      }
      this.validateObliqueThickRangeFromIndex(thickRangeObj, 0)
    },
    /**
     * @desc 改变特殊孔槽选项
     * @param data switch值
     */
    changeSpSlotHole(data) {
      this.formData.holeFaceSetting.prorate_holes_slots_of_both_side = data
    },
    /**
     * 删除拉直器与....属性
     */
    deleteStrHine() {
      this.formData.holeFaceSetting.processChainAndHoleOnBigPlaneBack = null
    },
    addSpecialRule() {
      this.$refs.SpecialHoleAndSlotTable.handleAdd()
    },
    /**
     * @desc 更改特殊孔槽规则选项
     * @param data
     */
    handlerSpecialSwitch(data) {
      if (data) return
      this.formData.holeFaceSetting.custom_special_hole_slot_side.special_hole_slot_side =
        this.$refs.SpecialHoleAndSlotTable.getAllRules().special_hole_slot_side
    },
    changeCheck(e) {
      this.formData.holeFaceSetting.custom_special_hole_slot_side.is_open =
        e.target.checked
      this.$nextTick(() => {
        this.$refs.SpecialHoleAndSlotTable?.addStraightenerPX()
      })
    },
    // 点击选择吸力位置
    handleSuctionClick(index) {
      this.$set(
        this.suctionPosition[index],
        'isSelected',
        !this.suctionPosition[index].isSelected
      )
      this.$set(
        this.formData.movePlankSetting,
        'strong_suction_zones',
        this.suctionPosition
          .filter((v) => v.isSelected)
          .map((item) => item.value)
      )
    },

    // 异形板件切两次开关切换,添加操作记录
    handleChangeSpecialShapRepeatedCut() {
      buryPointApi('engraving', 'specialShapRepeatCut')
    },
    // 自定义加工速度添加规则
    hanadleAddSpeedRule() {
      this.formData.processingSpeedSetting.small_plank_cut_rule.push({
        short_edge_range: null,
        long_edge_range: null,
        speed: null,
      })
    },
    // 自定义加工速度删除
    handleDeleteSpeedRule(index) {
      this.formData.processingSpeedSetting.small_plank_cut_rule.splice(index, 1)
    },
    // 翻译
    translateCuttingParams(key, payload) {
      return transLang(key, languageMap, payload)
    },
    // 自定义小板加工速度
    inputCheckCustomSpeed(index, key) {
      try {
        const rule =
          this.formData.processingSpeedSetting.small_plank_cut_rule[index]
        rule[key] = rule[key].replace(/[^\d]/g, '')
        rule[key] = rule[key] ? Number(rule[key]) : null
      } catch (e) {
        console.log(e)
      }
    },
    matchHighlightBoardName(matcode) {
      return matchHighlightBoardName(matcode)
    },
    // 获取输入框显示的值
    getPlankNameValue(index) {
      return (
        this.tempPlankNames[index]?.value ??
        this.formData.longPlankCuttingSetting.secondary_cutting_board_list[
          index
        ] ??
        ''
      )
    },

    // 添加板件名
    handleAddPlankName() {
      const newIndex =
        this.formData.longPlankCuttingSetting.secondary_cutting_board_list
          .length
      this.formData.longPlankCuttingSetting.secondary_cutting_board_list.push(
        ''
      )
      // 初始化临时值
      this.tempPlankNames[newIndex] = {
        value: '',
        original: '',
      }
      buryPointApi('engraving', 'addPlankName')
    },

    // 获得焦点时保存原始值
    handleFocusPlankName(index) {
      const originalValue =
        this.formData.longPlankCuttingSetting.secondary_cutting_board_list[
          index
        ] || ''
      // 如果还没有临时值，初始化它
      if (!this.tempPlankNames[index]) {
        this.tempPlankNames[index] = {
          value: originalValue,
          original: originalValue,
        }
      } else {
        // 如果已有临时值，更新原始值（防止多次获得焦点）
        this.tempPlankNames[index].original = originalValue
      }
      this.currentInputIndex = index
    },

    // 输入时更新临时值
    handleInputPlankName(e, index) {
      const value = e?.target.value
      if (!this.tempPlankNames[index]) {
        tempPlankNames[index] = {
          value: value,
          original:
            this.formData.longPlankCuttingSetting.secondary_cutting_board_list[
              index
            ] || '',
        }
      } else {
        this.tempPlankNames[index].value = value
      }
      this.currentInputPlankName = value
      this.currentInputIndex = index
    },

    // 失焦时如果没有保存，恢复原值
    handleBlurPlankName(index) {
      // 延迟执行，确保点击保存按钮时不会触发
      setTimeout(() => {
        // 如果当前索引不是这个输入框，说明可能点击了保存或其他操作，不恢复
        if (this.currentInputIndex !== index) {
          return
        }
        // 如果没有保存，恢复原值
        if (this.tempPlankNames[index]) {
          this.tempPlankNames[index].value = this.tempPlankNames[index].original
          this.currentInputIndex = null
        }
      }, 200)
    },

    // 删除板件名
    handleDelPlank(index) {
      if (
        this.formData.longPlankCuttingSetting.longPlankCuttingEnable &&
        this.formData.longPlankCuttingSetting.specified_board_secondary_cutting
      ) {
        this.formData.longPlankCuttingSetting.secondary_cutting_board_list.splice(
          index,
          1
        )
        // 清理临时值
        delete this.tempPlankNames[index]
        // 重新整理索引
        const newTempPlankNames = {}
        Object.keys(this.tempPlankNames).forEach((key) => {
          const numKey = Number(key)
          if (numKey < index) {
            newTempPlankNames[numKey] = this.tempPlankNames[numKey]
          } else if (numKey > index) {
            newTempPlankNames[numKey - 1] = this.tempPlankNames[numKey]
          }
        })
        Object.keys(newTempPlankNames).forEach((key) => {
          this.tempPlankNames[Number(key)] = newTempPlankNames[Number(key)]
        })
        Object.keys(this.tempPlankNames).forEach((key) => {
          if (!newTempPlankNames[Number(key)]) {
            delete this.tempPlankNames[Number(key)]
          }
        })
      }
    },

    // 保存板件名
    handleSavePlankName(name, index) {
      if (
        this.formData.longPlankCuttingSetting.specified_board_secondary_cutting
      ) {
        // 立即清除索引，防止失焦事件恢复值
        this.currentInputIndex = null
        const valueToSave =
          this.tempPlankNames[index]?.value ?? this.currentInputPlankName

        // 如果输入值不为空，检查是否有重复
        if (valueToSave && valueToSave.trim()) {
          const boardList =
            this.formData.longPlankCuttingSetting.secondary_cutting_board_list
          const trimmedValue = valueToSave.trim()

          // 检查是否有重复（排除当前索引）
          const duplicateIndex = boardList.findIndex(
            (item, idx) => idx !== index && item && item.trim() === trimmedValue
          )

          if (duplicateIndex !== -1) {
            // 有重复，显示错误提示并恢复原始值
            this.$message.error('板件名不能重复')
            // 恢复原始值
            const originalValue =
              this.tempPlankNames[index]?.original ??
              this.formData.longPlankCuttingSetting
                .secondary_cutting_board_list[index] ??
              ''
            if (this.tempPlankNames[index]) {
              this.tempPlankNames[index].value = originalValue
            }
            // 恢复表单中的值
            this.$set(
              this.formData.longPlankCuttingSetting
                .secondary_cutting_board_list,
              index,
              originalValue
            )
            return
          }
        }

        // 没有重复，正常保存
        this.$set(
          this.formData.longPlankCuttingSetting.secondary_cutting_board_list,
          index,
          valueToSave
        )
        // 更新临时值的原始值，以便下次编辑时使用
        if (this.tempPlankNames[index]) {
          this.tempPlankNames[index].original = valueToSave
        }
      }
    },
    // 改变切板方式
    handleChangeCutPlankMethod() {
      buryPointApi('engraving', 'cutPlankMethod')
    },
    handleObliqueCutBuryPoint(functionPoint) {
      buryPointApi('equipment_dock', functionPoint)
    },
    verifyInputCheck(option) {
      // 失焦：去掉末尾多余小数点（如 1. → 1）
      if (option.isBlur) {
        const keys = option.keys || []
        if (!option.formData || !keys.length) {
          return
        }
        let target = option.formData
        for (let i = 0; i < keys.length - 1; i++) {
          target = target[keys[i]]
          if (target == null) {
            return
          }
        }
        const lastKey = keys[keys.length - 1]
        const val = target[lastKey]
        if (val === null || val === undefined || val === '') {
          return
        }
        const str = String(val)
        if (!str.endsWith('.')) {
          return
        }
        const next = str.slice(0, -1)
        this.$set(target, lastKey, next === '' || next === '-' ? '' : next)
        return
      }
      verifyInputNumber(
        option.value,
        option.formData,
        option.keys,
        option.rule,
        option.isMinus,
        option.min,
        option.isEmpty,
        option.max,
        option.isThickFlag
      )
    },
    // 边缘槽隔条防断规则补全 webId，供操作记录表格 diff 使用
    ensurePreventBreakageRulesWebId() {
      const rules =
        this.formData.cuttingPunchingSetting?.prevent_breakage_setting?.rules
      if (!Array.isArray(rules)) {
        return
      }
      rules.forEach((rule) => {
        if (!rule[webId]) {
          this.$set(rule, webId, rule.id || genUniId())
        }
      })
    },
    // 添加边缘槽隔条防断规则
    handleAddPreBreRule() {
      if (
        this.formData.cuttingPunchingSetting.prevent_breakage_setting.rules
          .length >= 10
      ) {
        this.$message.error(this.$translateLang('最多添加十个!'))
        return
      }
      this.formData.cuttingPunchingSetting.prevent_breakage_setting.rules.push({
        edge_distance: [],
        length: [],
        deep: [],
        cut_deep: '',
        [webId]: genUniId(),
      })
    },
    // 删除边缘槽隔条防断规则
    handleDelPreBreRule(index) {
      if (
        this.formData.cuttingPunchingSetting.prevent_breakage_setting.rules
          .length <= 1
      ) {
        this.$message.error(this.$translateLang('至少保留一个!'))
        return
      }
      this.formData.cuttingPunchingSetting.prevent_breakage_setting.rules.splice(
        index,
        1
      )
    },
    handleAddBridge() {
      this.formData.movePlankSetting.bridgeRetention.bridgeCountRules.push({
        minLength: 0,
        maxLength: 100,
        count: 1,
        [webId]: genUniId(),
      })
    },
    handleDelBridge(val) {
      if (!this.isBridgeRetentionEnabled) return
      if (typeof val === 'number') {
        this.formData.movePlankSetting.bridgeRetention.bridgeCountRules.splice(
          val,
          1
        )
      } else if (this.selectedBridgeCuttingData.length) {
        // 按索引从大到小删，避免 splice 后后续索引错位
        const selectedIndexSet = new Set(this.selectedBridgeCuttingData)
        this.formData.movePlankSetting.bridgeRetention.bridgeCountRules =
          this.formData.movePlankSetting.bridgeRetention.bridgeCountRules.filter(
            (_, index) => !selectedIndexSet.has(index)
          )
        this.selectedBridgeCuttingData = []
      }
    },
    handleBridgeCuttingSelectChange(selectedRowKeys) {
      if (!this.isBridgeRetentionEnabled) return
      this.selectedBridgeCuttingData = selectedRowKeys
    },
    handleBridgeCellEdit(index, field) {
      if (!this.isBridgeRetentionEnabled) return
      this.clearBridgeEditBlurTimer()
      this.bridgeEditingCell = { index, field }
      this.$nextTick(() => {
        const inputEl = this.$el.querySelector(
          '.bridge-length-input input, .bridge-count-input input'
        )
        if (inputEl) inputEl.focus()
      })
    },
    clearBridgeEditBlurTimer() {
      clearTimeout(this._bridgeEditBlurTimer)
    },
    handleBridgeCellBlur() {
      this.clearBridgeEditBlurTimer()
      this.bridgeEditingCell = { index: -1, field: '' }
    },
  },
}
</script>

<style scoped lang="less">
@import '~@/style/engraving.less';

.base_title {
  padding-left: 24px;
  margin-left: 8px;
  margin-bottom: 32px;
}

.cutting-params {
  position: relative;
  // margin: 16px;
  background: #fff;

  span {
    cursor: default;
  }

  .base-btn {
    color: #18a8c7;
    cursor: pointer;
  }

  .wrap {
    .navRightWrapWidth();

    .switch-box {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      margin-right: 40px;
    }

    .content-box {
      display: flex;
      align-items: center;
      padding: 0px 24px;
    }

    .common-side-cut {
      .common-side-limit {
        display: flex;
        align-items: center;

        .ant-input {
          width: 64px;
          margin: 0 8px;
        }
      }
    }

    .hole-slot-focus {
      .content {
        padding: 0px 24px;

        > div {
          margin-bottom: 32px;
        }

        .allocation {
          .ant-input {
            width: 60px;
            margin-left: 5px;
          }

          .addRules {
            color: #18a8c7;
            margin-right: 2em;
          }

          .addRules:hover {
            cursor: pointer;
          }

          .edge-again-info {
            color: #8c8c8c;
            font-size: 14px;
          }
        }
      }
    }

    .board-slot-place {
      .content {
        padding: 0px 24px;

        > div:first-child {
          margin-bottom: 32px;
        }
      }
    }

    .img-wrap {
      margin-top: 20px;
    }

    .radio-box {
      display: flex;
    }

    .common-side-accelerate {
      .speed-limit {
        display: flex;
        align-items: center;

        .ant-input {
          width: 64px;
          margin: 0 8px;
        }
      }
    }

    .table-board {
      & > div {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 0 24px;

        & > div {
          width: 100%;
          margin-bottom: 32px;
        }
      }

      .start-point {
        display: flex;
        margin-right: 40px;

        .small-title {
          margin-right: 13px;
        }

        .table-board-radio {
          display: flex;

          span {
            display: inline-block;
            width: 74px;
            height: 38px;
            line-height: 38px;
            text-align: center;
            border: 1px solid #d9d9d9;
            cursor: pointer;
            transition: all 0.5s;

            &:hover {
              z-index: 2;
              color: #18a8c7;
              border-color: #18a8c7;
            }

            &:nth-child(1) {
              margin-right: -1px;
              border-radius: 4px 0 0 4px;
            }

            &:nth-child(2) {
              margin-right: -1px;
            }

            &:nth-child(3) {
              margin-right: -1px;
            }

            &:nth-child(4) {
              border-radius: 0 4px 4px 0;
            }
          }

          .active-radio {
            z-index: 2;
            color: #18a8c7;
            border-color: #18a8c7;
          }
        }
      }

      .toggle-XY,
      .toggle-XYAuto {
        display: flex;
        align-items: center;
        margin-right: 40px;
      }

      .toggle-XYAuto {
        align-items: flex-start;
      }

      .double-start-point {
        display: flex;
        align-items: center;
        margin-right: 40px;
      }

      .machine-board {
        display: flex;
        align-items: flex-start;

        .board-switch {
          display: flex;
          align-items: center;
          margin-right: 8px;
        }

        .board-offset {
          display: flex;
          align-items: center;

          .small-title {
            margin-right: 8px;
          }

          .ant-input {
            width: 110px;
            height: 32px;
          }
        }
      }

      // .change-dual {
      //   display: flex;
      //   // .dual-input-wrapper {
      //   //   flex: 1;
      //   // }
      // }
      .dual-input {
        /deep/ .ant-input,
        .ant-input-affix-wrapper {
          width: 138px;
        }
      }
    }

    .lave-off {
      .lave-off-setting-img {
        display: flex;

        .lave-off-setting {
          padding: 0 24px;

          .start-point {
            display: flex;
            margin-right: 40px;

            .small-title {
              margin-right: 13px;
              font-weight: 500;
            }

            .table-board-radio {
              display: flex;

              span {
                display: inline-block;
                width: 74px;
                height: 38px;
                line-height: 38px;
                text-align: center;
                border: 1px solid #d9d9d9;
                cursor: pointer;
                transition: all 0.5s;

                &:hover {
                  z-index: 2;
                  color: #18a8c7;
                  border-color: #18a8c7;
                }

                &:nth-child(1) {
                  margin-right: -1px;
                  border-radius: 4px 0 0 4px;
                }

                &:nth-child(2) {
                  margin-right: -1px;
                }

                &:nth-child(3) {
                  margin-right: -1px;
                }

                &:nth-child(4) {
                  border-radius: 0 4px 4px 0;
                }
              }

              .active-radio {
                z-index: 2;
                color: #18a8c7;
                border-color: #18a8c7;
              }
            }
          }
        }

        .lave-off-img {
          width: 200px;
        }
      }
    }

    .cut-hole-way {
      .cut-hole {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;

        & > div {
          display: flex;
          width: 100%;
          margin-right: 40px;
          margin-bottom: 32px;

          .ant-input {
            width: 51px;
          }
        }

        .symbol {
          span {
            margin-right: 16px;
          }

          .slot-cover-rate {
            width: 60px;
            height: 32px;
          }
        }

        .G02-cure {
          span:first-child {
            margin-right: 16px;
          }

          span:last-child {
            margin-left: 16px;
            color: #8c8c8c;
          }
        }
      }
    }

    .prevent-breakage-enable {
      margin-top: -6px;
    }

    .prevent-breakage-rule {
      /deep/ .ant-input,
      /deep/ .ant-input-affix-wrapper {
        width: 120px;
      }

      .rule-to {
        margin: 0 8px;
      }

      &-item {
        margin-top: 20px;

        .btn {
          cursor: pointer;
        }

        .add-btn {
          color: #18a8c7;
          margin-right: 8px;
        }

        .delete-btn {
          color: #f5222d;
        }

        .disabled-btn {
          color: #ccc;
          cursor: not-allowed;
        }
      }
    }

    .optimize-speed {
      .content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;

        & > div {
          width: 100%;
          margin-bottom: 32px;
        }

        div {
          display: flex;
          margin-right: 32px;

          .ant-input {
            width: 138px;
          }

          .ant-switch {
            margin-right: 20px;
          }
        }

        // 父级 div{display:flex} 会把 el-table 表头/表体拆成左右布局，这里还原为上下
        .oblique-thick-table {
          display: block;
          width: 100%;
          margin-right: 0;

          .manage-plank {
            display: flex;
            align-items: center;
            margin-right: 0;
          }

          /deep/ .el-table {
            display: block;
            margin-right: 0;
          }

          /deep/ .el-table__header-wrapper,
          /deep/ .el-table__body-wrapper,
          /deep/ .el-table__footer-wrapper {
            display: block;
            margin-right: 0;
          }
        }

        .oblique-param-sub-label {
          display: inline-block;
          min-width: 154px;
          margin-right: 8px;
        }
      }
    }

    .newCutSequence {
      .content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;
        padding: 0px 24px;

        & > div {
          width: 100%;
          margin-bottom: 24px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .postioon-tip {
          margin-left: 180px;
        }
      }

      .container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;

        .grid-left {
          display: flex;
          flex-wrap: wrap;
          width: 200px;
          height: 200px;
          margin: 0px 35px;
        }

        .grid-item {
          border: 1px solid #ccc;
          padding: 20px;
          text-align: center;
          font-size: 24px;
          cursor: pointer;
          flex: 1 0 33.333%;
          box-sizing: border-box;
        }

        .grid-item:hover {
          background-color: rgb(223, 250, 255);
        }

        .grid-item.active {
          background-color: #18a8c7;
        }

        .grid-rigth {
          width: 200px;
          height: 200px;
          display: flex;
          flex-direction: column;
          place-content: space-between;

          .rigth-top {
            display: flex;
            align-items: center;

            .example {
              background-color: #18a8c7;
              width: 50px;
              height: 20px;
            }
          }
        }
      }

      .strong-van {
        display: flex;
      }

      .last-cut-point-wrapper {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
      }

      .last-cut-point-container {
        display: flex;
        align-items: center;
      }

      .plank-diagram {
        position: relative;
        width: 80px;
        height: 120px;
        border: none;
        margin: 10px 20px;
        background: #ffe9ac;

        .corner {
          position: absolute;
          width: 24px;
          height: 24px;
          cursor: pointer;

          &.left-top {
            top: 0;
            left: 0;
          }

          &.right-top {
            top: 0;
            right: 0;
          }

          &.left-bottom {
            bottom: 0;
            left: 0;
          }

          &.right-bottom {
            bottom: 0;
            right: 0;
          }

          .corner-dot {
            display: block;
            width: 24px;
            height: 24px;
            background: #ccc;
            transition: background 0.2s;
          }

          &:hover .corner-dot {
            background: #7dd3e8;
          }

          &.active .corner-dot {
            background: #18a8c7;
          }
        }

        .center-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 12px;
          color: #333;
          white-space: nowrap;
        }
      }

      .tip-text {
        color: #999;
        font-size: 12px;
      }
    }

    .hierarchy-cut {
      .hierarchy-cut-twice {
        display: flex;
      }

      .hierarchy-cut-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;

        & > div {
          display: flex;
          // margin-right: 40px;
          width: 100%;
          margin-bottom: 32px;

          .ant-switch {
            margin-right: 40px;
          }

          .hierarchy-cut-limit {
            align-items: center;
            // display: flex;

            .secondCutting {
              margin-top: 16px;

              .el-input {
                width: 56px;

                /deep/.el-input__inner {
                  height: 32px;
                  padding: 0px 5px;
                  line-height: 32px;
                  text-align: center;
                }
              }
            }

            .ant-input {
              width: 51px;
              margin: 0 8px;
            }
          }
        }
      }
    }

    .plank-table {
      .plank-table-main {
        max-height: 500px;
      }

      /deep/.el-table {
        width: 597px;
        .tip {
          position: absolute;
          left: 170px;
          top: 0;
          width: 300px;
          color: rgb(255, 0, 0);
          line-height: 48px;
          height: 48px;
        }
      }

      .manage-plank {
        margin-bottom: 16px;
      }
    }

    .bridge-cutting-object {
      display: flex;
      .ant-checkbox-wrapper {
        color: rgba(0, 0, 0, 0.9);
      }
    }

    .bridge-cutting-generate {
      display: flex;

      /deep/ .bridge-cutting-table {
        width: 520px;
        margin-top: 20px;
        .ant-table-thead > tr > th {
          padding: 10px 8px;
          white-space: normal;
          word-break: break-word;
        }
        .bridge-length-text {
          cursor: pointer;
          padding: 0 2px;
          border-radius: 2px;
          &:hover {
            background: rgba(24, 168, 199, 0.12);
          }
        }
        .bridge-length-input,
        .bridge-count-input {
          width: 64px;
          text-align: center;
        }
        .mh4 {
          margin: 0 4px;
        }
      }
      .bridge-del-btn {
        color: #18a8c7;
        cursor: pointer;
        &--disabled {
          color: rgba(0, 0, 0, 0.25);
          cursor: not-allowed;
        }
      }
    }

    .long-door-plank {
      .long-door {
        display: flex;
        margin-bottom: 32px;

        .ant-input {
          width: 51px;
        }

        .cutting-number {
          margin-left: -20px;
        }

        /deep/.ant-input-number-handler-wrap {
          display: none;
        }
      }

      .long-plank-filter-panel {
        margin-bottom: 0;

        .hierarchy-cut-twice {
          display: flex;
        }

        .long-plank-section-row {
          display: flex;
          margin-bottom: 16px;

          &--cutting {
            margin-top: 8px;
          }

          .long-plank-section-title {
            width: 160px;
            margin-right: 5px;
            color: rgba(0, 0, 0, 0.9);
            font-size: 14px;
            font-weight: 600;
            text-align: right;
          }
        }

        .long-plank-filter-level {
          flex-direction: column;
          align-items: flex-start;
          margin-bottom: 20px;

          &--last {
            margin-bottom: 24px;
          }

          &__title {
            flex-shrink: 0;
            width: 260px;
            height: auto;
            margin-bottom: 12px;
            line-height: 22px;
            white-space: normal;
          }
        }

        .long-plank-filter-level__body {
          box-sizing: border-box;
          padding-left: 265px;
        }

        .long-plank-filter-level__group {
          display: flex;
          flex-direction: column;
        }

        .long-plank-filter-level__item {
          display: flex;
          align-items: center;
          height: auto;
          margin: 0 0 8px 0;
          margin-left: 0;
          line-height: 32px;

          /deep/ .ant-checkbox + span {
            display: inline-flex;
            align-items: center;
            padding-right: 0;
          }
        }

        .long-plank-specified-board {
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .long-plank-filter-level__item {
            margin-bottom: 0;
          }
        }

        .long-plank-filter-level__tip {
          margin-left: 24px;
          line-height: 22px;
        }

        .long-plank-inline-inputs {
          line-height: 32px;
        }

        .long-plank-material-cut {
          /deep/ .long-door {
            margin-bottom: 0;
          }

          /deep/ .ctx {
            margin-top: 12px !important;
            margin-left: 0 !important;
          }
        }

        .long-plank-cutting-row {
          align-items: flex-start;
          margin-bottom: 24px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .add-plank-name {
      color: #18a8c7;
      cursor: pointer;
    }

    .plank-name-box {
      width: 500px;
      .add-plank {
        color: #18a8c7;
        cursor: pointer;
      }
    }

    .decimals {
      .decimals-num {
        display: flex;
        padding: 0 24px;
        margin-bottom: 32px;

        .ant-input {
          width: 138px;
        }
      }
    }

    .buffer-code {
      .buffer-code-check {
        display: flex;
        align-items: center;
        padding: 0 24px;

        .right-margin {
          margin-right: 24px;
        }
      }
    }

    .interval-setting {
      margin-bottom: 32px;

      .interval-setting-content {
        display: flex;
        padding: 0 24px;

        .ant-input {
          width: 138px;
        }
      }
    }

    .zk-customize {
      width: 107.39px;
      height: 137.87px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: -25px;
      margin-left: 44px;
      background-color: #f3f3f3;

      .img-top {
        top: 4px;
        left: 43px;
      }

      .img-left {
        top: 60px;
        left: 3px;
      }

      .img-right {
        top: 60px;
        right: 3px;
      }

      .img-bottom {
        bottom: 3px;
        left: 43px;
      }

      .customize-style {
        color: #18a8c7;
      }
    }

    .waste_auto_cutting {
      margin-bottom: 32px;
    }
  }

  .tipField {
    margin-left: 20px;
    color: #8c8c8c;
    font-weight: 500;
    font-size: 14px;
  }

  .img-box {
    background: #f3f3f3;
  }

  .imgWrap {
    width: 175px;
  }

  .switch-class {
    display: flex;
    align-items: center;
  }

  .warning {
    color: #e90e0e;
  }

  .oblique-thick-tip {
    margin-left: -32px;
    margin-right: 16px;
  }

  ::v-deep .oblique-thick-input-error .ant-input {
    border-color: #ff4d4f;
  }

  ::v-deep .oblique-thick-input-error .ant-input:focus {
    border-color: #ff4d4f;
    box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
  }

  .ant-select {
    width: 100%;
  }

  .text-color {
    color: #18a8c7;
    font-size: 14px;
    font-weight: 500;
  }

  .speed-rule {
    flex-direction: column;
  }

  .rule-disabled {
    color: #8c8c8c;
    pointer-events: none;
  }
}
</style>
